{
  "accessibility": {
    "closeModal": "Sulje modaali",
    "useSetting": "Käytä asetusta",
    "srOnly": {
      "close": "Sulje",
      "loading": "Ladataan..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Myyntiresurssit",
      "searchDocuments": "Hae asiakirjoja",
      "minimalRating": "Minimiluokitus",
      "maxRating": "Maksimiluokitus"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Ota käyttöön uudelleenlaskutus tälle asiakkaalle, jotta voit ansaita jopa 10-kertaiset voitot puhelujen, sähköpostien, automaatioiden jne. käytöstä.",
      "enableRebilling": "Ota uudelleenlaskutus käyttöön",
      "servicesActivateAfterPayment": "Uudelleenlaskutuspalvelut aktivoidaan, kun asiakas on lisännyt maksutavan. Siihen asti asiakkaan tilin käyttöoikeutta rajoitetaan.",
      "cannotModifyOnHold": "Uudelleenlaskutusasetuksia ei voi muokata, koska tällä alatilillä on jo SaaS-suunnitelma pidossa. Uudelleenlaskutusmarginaalit määritellään suunnitelman mukaisesti, kun asiakas lisää maksutavan.",
      "rebillingSettings": "Uudelleenlaskutusasetukset"
    }
  },
  "affiliates": {
    "aboutMe": "Tietoa minusta",
    "error": {
      "unableToSend": "Sähköpostia ei voida lähettää"
    },
    "industriesServed": "Toimialat",
    "sendAMessage": "Lähetä viesti",
    "sendMessageIntro": "Lähetä viesti esitelläksesi itsesi tälle neuvonantajalle. Sisällytä yksityiskohdat itsestäsi ja etsimistäsi palveluista.",
    "socialSites": "Sosiaalisen median sivustot",
    "success": {
      "emailSent": "Sähköposti lähetetty onnistuneesti"
    },
    "validationErrors": {
      "validEmail": "Anna kelvollinen sähköpostiosoite.",
      "validMessage": "Anna kelvollinen viesti.",
      "validName": "Anna kelvollinen nimi."
    },
    "yearsInBusiness": "Vuosia liiketoiminnassa",
    "yourEmail": "Sähköpostisi",
    "yourName": "Nimi",
    "paymentDetailsAccessMessage": " Tähän maksutiedot-osioon pääsee käsiksi ja sitä voi muokata vain <strong>toimiston omistaja</strong>. Jos tarvitset apua, ota yhteyttä <strong>toimistosi omistajaan ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Kumppanimerkki",
    "photoAlt": "Kumppanin valokuva",
    "defaultCompany": "Ei yritystä",
    "moreServices": "+ {count} lisää palvelua"
  },
  "agency": {
    "saas": {
      "saasMode": "SaaS-tila",
      "pendingPaymentInformation": "Kesken olevat maksutiedot",
      "customerId": "Asiakastunnus",
      "noPaymentMethods": "Näyttää siltä, että maksutapoja ei ole lisätty! Aktivoi saas-tila lisäämällä maksutapa.",
      "enableSaasDescription": "Luo tilaus ja uudelleenlaskuta puhelimen ja sähköpostin käyttö ottamalla SaaS käyttöön tässä sijainnissa",
      "missingEmailAddress": "Tilin sähköpostiosoite puuttuu. Lisää ensin tiedot.",
      "toConvertToSaaS": "Muuntaaksesi tämän tilin SaaS-tiliksi, sinun on ensin lisättävä sijainnin ylläpitäjä ja yritettävä uudelleen.",
      "newUser": "Luo uusi käyttäjä",
      "stripeCustomerConnected": "Stripe-asiakas on yhdistetty onnistuneesti!",
      "requestClientPaymentDetails": "Pyydä asiakkaan maksutiedot",
      "saasLocationDescription": "Sijainnit SaaS-tilassa tarvitsevat asiakkaasi luottokortin toimiakseen. Voit pyytää lähettämällä sähköpostiviestin, tekstiviestin tai jakamalla URL-osoitteen",
      "selectSpace": "Jatka valitsemalla tila",
      "spaceDescription": "Tässä valitsemaasi tilaa käytetään tämän asiakkaan tietojen tallentamiseen, maksujen käsittelyyn ja tilausten hallintaan.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Kun käyttäjä rekisteröityy, voit tarjota hänelle ilmaisia krediittejä sähköposti- ja puhelinpalveluiden käyttöä varten.",
      "thatAboutMinsInCalls": "Kyse on noin {count} tekstiviestistä tai {count1} minuutista puheluissa",
      "subscriptionSettings": "Tilausasetukset",
      "toUpgradeOrCancelPlan": "Jos haluat päivittää tai peruuttaa tilauksen",
      "allowClientUpgrade": "Salli asiakkaan (alatili) vaihtaa korkeampaan tilaustyyppiin.",
      "addNewPlanFeatures": "Lisää uuden suunnitelman ominaisuudet päivityksen yhteydessä.",
      "upgradeFeatureDescription": "Kun päivität korkeampaan tilaustyyppiin, alatilit saavat käyttöönsä uuden suunnitelman lisäominaisuudet. pääsy uuden tilaustyypin lisäominaisuuksiin.",
      "allowClientCancel": "Salli asiakkaan (alatilin) peruuttaa tilauksensa.",
      "snapshotDescription": "Valittu tilannevedos lisätään automaattisesti uuteen SaaS-sijaintiin",
      "ownSnapshots": "Omat tilannevedokset",
      "selectAndContinue": "Valitse ja jatka"
    },
    "advancedSettings": {
      "controlLocationSettings": "Sijaintiasetusten hallinta",
      "disableAddSmtp": "Poista Lisää sähköpostipalvelu ‑painike käytöstä alatilin sähköpostipalvelun asetuksista.",
      "disableAddSmtpDescription": "Rajoita alitilien käyttäjien mahdollisuutta lisätä omaa sähköpostipalveluntarjoajaansa",
      "enableReVerification": "Ota 90 päivän uudelleenvahvistus käyttöön",
      "lcEmailNotEnabled": "Sijainnilla ei ole LeadConnectoria oletussähköpostipalveluntarjoajana.",
      "onlyVisibleForAgency": "Näet nämä asetukset vain, jos ne on otettu käyttöön toimistolle",
      "reVerificationDescription": "Jokainen sähköpostivahvistus mitätöidään 90 päivän kuluttua (tämä suojelee mainettasi lähettäjänä ja takaa viesteille parhaan mahdollisen toimitusvarmuuden)",
      "account": {
        "accountDetails": "Tilin tiedot",
        "advancedEmailSettings": "Sähköpostin lisäasetukset",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-vaatimustenmukainen",
        "smsEmailLimits": "SMS- ja sähköpostirajoitukset",
        "socialProfiles": "Sosiaalisen median profiilit",
        "subscribed": "Tilattu"
      },
      "activityTracking": {
        "history": "Historia"
      },
      "addAccount": {
        "accountInfo": "Tilitiedot",
        "accountSnapshots": "Tilin tilannevedokset",
        "businessNiche": "Yrityksen markkinarako",
        "chooseBusinessNiche": "Valitse liiketoiminnan erikoisala...",
        "pickSnapshot": "Valitse tilannevedos",
        "selectSnapshot": "Valitse tilannevedos",
        "title": "Lisää alatili",
        "accountInfo1": "Tilin tiedot"
      },
      "addBalance": {
        "addBalanceToWallet": "Lisää saldoa lompakkoon",
        "addMoneyToWallet": "Lisää rahaa lompakkoon",
        "balanceAddedSuccessfully": "Saldo lisätty onnistuneesti",
        "cardWillBeCharged": "Korttia, joka päättyy {cardNumber}, veloitetaan",
        "complimentaryCredits": "Ilmaiset krediitit ({credits})",
        "creditsRemovedByAgency": "Toimisto poisti krediittejä",
        "currentBalance": "Tämänhetkinen saldo",
        "customerCCWillNotBeCharged": "Asiakkaan luottokorttia ei veloiteta",
        "moneyWillBeAddedToWallet": "Rahat lisätään lompakkoon",
        "pleaseProvideAmountBetween": "Anna summa väliltä {min} ja {max}",
        "processing": "Käsitellään",
        "removeBalance": "Poista saldo",
        "transactionSuccessful": "Transaktio onnistui",
        "walletBalance": "Lompakon saldo ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Lisätään...",
        "cardDetails": "Kortin tiedot",
        "cardSuccessfullyAdded": "Kortti lisätty onnistuneesti",
        "errorWhileAddingCard": "Virhe uuden kortin lisäämisessä!",
        "maximumCardUpdateLimitReached": "Kortin päivitysten enimmäisraja saavutettu",
        "rateLimitMessage": "Näyttää siltä, että olet saavuttanut korttien lisäämiseen sallitun enimmäismäärän tänään. Yritä uudelleen 24 tunnin kuluttua."
      },
      "aiProductRebilling": {
        "funnel": " suppilo",
        "images": " Kuvat,",
        "per1000Words": " /1 000 sanaa, ",
        "perFunnel": " /suppilo",
        "perImage": " / Kuva,",
        "pleaseCheckSupport": "lue",
        "ratesMayDiffer": "Hinnat voivat vaihdella alueittain. Esitetyt laskelmat perustuvat Yhdistyneen kuningaskunnan hintoihin,",
        "ratesMayDifferUS": "Hinnat voivat vaihdella alueittain. Laskelmat on esitetty Twilion Yhdysvaltojen hintojen mukaisesti. Tarkasta lisätiedot Twiliosta.",
        "pleaseCheckTwilioRates": "Yhdysvaltoihin/Kanadaan lähtevien tekstiviestien veloitus on 0,0079 $/segmentti. Saapuvat tekstiviestit hintaan 0,0075 $/segmentti.",
        "words": " sanaa, "
      },
      "api": {
        "advancedFunctionalityNote": "Huomautus edistyneestä toiminnallisuudesta",
        "agencyApiKeys": "Toimiston API-avaimet",
        "apiAccess": {
          "partOfAdvancedApi": "Tämä on osa Advanced API:ta, joka on saatavilla Pro-sopimuksessa.",
          "toUpgrade": "päivittääksesi"
        },
        "createNew": "Luo uusi",
        "developerCouncilInfo": "Kehittäjäneuvoston tiedot",
        "noAccess": "Sinulla ei ole tämän osion käyttöoikeutta.",
        "securityAlert": "Turvahälytysviesti",
        "table": {
          "fetchingKeys": "Yrityksen avainten noutaminen...",
          "noKeysYet": "Sinulla ei ole vielä API-avaimia.",
          "toCreateFirstKeys": "luodaksesi ensimmäiset API-avaimesi."
        },
        "zapierNote": "Zapier-viesti"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Mahdollisuus valita Google-kalenterit ”Lisää kohteeseen” + ”Ristiriita”-kalentereihin, jotta voidaan tarkistaa jokaisen käyttäjän saatavuuden laskenta",
        "abilityToAllocateRoundRobin": "Mahdollisuus jakaa tapaamisia Round Robin -periaatteella",
        "abilityToChooseSpecificUser": "Mahdollisuus valita tietty käyttäjä, jonka kanssa tapaaminen varataan.",
        "adminAbilitySeeEveryUser": "Ylläpitäjä – mahdollisuus nähdä jokaisen käyttäjän kalenteritapaamiset",
        "adminAbilityViewAllCalendar": "Ylläpitäjä – mahdollisuus nähdä kaikki käyttäjän kalenteritapaamiset",
        "adminsCanDeleteIntegrations": "Ylläpitäjät voivat poistaa mitkä tahansa integroinnit, mutta käyttäjät voivat poistaa vain omansa",
        "adminsCanSeeAllIntegrations": "Järjestelmänvalvojat näkevät kaikki integraatiot riippumatta siitä, kuka ne on luonut, mutta käyttäjät näkevät vain itse luomansa integraatiot.",
        "contactDetailAppointments": "Kontaktin tiedot > Tapaamiset (uusi)",
        "conversationsScheduleAppointment": "Keskustelut > Aikatauluta tapaaminen (uusi)",
        "essentialConsiderations": "Olennaiset näkökohdat",
        "funnelsWebsitesCalendar": "Suppilot/Verkkosivut > Kalenteri (Uusi)",
        "helpReorientTriggers": "Puhelun aikana autamme suuntaamaan käynnistimet uudelleen uuden kalenterin määrityksen mukaisesti",
        "iAgreeMessage": "Jos hyväksyt edellä mainitut muutokset, napsauta \"Hyväksyn\" ja aloita Kalenterin (beta) käyttö tässä sijainnissa.",
        "integrationNew": "Integrointi (uusi)",
        "loseAbilityToViewEdit": "Käyttäjät uudessa versiossa menettävät mahdollisuuden tarkastella tai muokata edellisessä versiossa luotuja tapaamisia Opportunity Details -modaalin kautta, mutta he voivat edelleen suorittaa kaikki nämä toiminnot Tapaamiset-sivulla",
        "newOldTriggersCoexist": "Uudet ja vanhat käynnistimet tulevat olemaan rinnakkain",
        "nonAdminAbilityViewPersonal": "Ei-ylläpitäjä – mahdollisuus vain katsoa omia henkilökohtaisia tapaamisia (Määritettyjen tilastojen/kalenterin yhdistämisellä TIIMINHALLINNASSA ei ole vaikutusta)",
        "nonAdminViewPersonalOnly": "Ei-ylläpitäjä – mahdollisuus nähdä vain omat henkilökohtaiset tapaamiset",
        "notAtMoment": "Ei tällä hetkellä. Mutta pyrimme kovasti saamaan sen saataville mobiililaitteille mahdollisimman pian.",
        "oldAppointmentsCanBeViewed": "Vanhoja tapaamisia voidaan tarkastella tapaamissivulla vaihtokytkimen avulla.",
        "oldAppointmentsDisplayed": "Vanhat tapaamiset näytetään uusien tapaamisten rinnalla samassa tapaamisten luettelossa",
        "oldCalendarVersionAppointments": "Vanha kalenteriversio + vanhat tapaamiset",
        "onlyNewCalendarWidget": "Vain uusi Kalenteri-widget voidaan lisätä",
        "opportunityAddAppointment": "Mahdollisuus > Lisää tapaaminen (uusi)",
        "profilePageAdmin": "Profiili-sivu ylläpitäjälle (uusi)",
        "profilePageAllUsers": "Profiilisivu (kaikki käyttäjät)",
        "providesAllOptions": "Tarjoaa kaikki valinnat (Ryhmät + Palvelut), jotka ovat pakollisia uuden kalenterin määrittämiseksi",
        "reintegratingConnectionsRequired": "Kaikkien yhteyksien uudelleenintegrointi voi olla tarpeen, kun kalenterin beetaversio on otettu käyttöön tietyssä sijainnissa.",
        "roundRobinHighlight": "Mahdollisuus jakaa tapaamiset Round Robin -periaatteella eri agenttiryhmien kesken on tämän päivityksen tärkein uutuus.",
        "schedulingCalendarAppointments": "Ajoittaminen > Kalenteri/Tapaamiset (Uudet suodattimet + Vaihtokytkin uusien ja vanhojen tapaamisten välillä)",
        "settingsCalendarBeta": "Asetukset > Kalenteri (Beta)",
        "surfacingFirstTime": "Esille tuominen ensimmäistä kertaa",
        "teamManagementAdminOnly": "Tiiminhallinta (saatavilla vain ylläpitäjille)",
        "toggleOffNewVersion": "Poistettu käytöstä (uusi versio)",
        "toggleOnOldVersion": "Kytke päälle (vanha versio)",
        "whatChangesWithNewVersion": "Mitä muutoksia uuden version kalenteriin on tehty?",
        "whatDoesCalendarEntail": "Mitä kalenteri (yksityinen beetaversio) sisältää?",
        "whatHappensToOldAppointments": "Mitä tapahtuu vanhoille tapaamisillemme siirtymän jälkeen?",
        "whatWillWeSeeMobile": "Mitä näemme mobiililaitteilla beetan aikana?",
        "willOldAppointmentsBeFactored": "Otetaanko vanhat tapaamiset huomioon, kun lasketaan uusien tapaamisten saatavuutta?",
        "willOldCalendarUrlsWork": "Toimivatko vanhat kalenterin URL-osoitteet edelleen siirtymisen jälkeen?",
        "willWeGetNewVersionMobile": "Pääsemmekö käyttämään uutta versiota mobiililaitteilla beetavaiheen aikana?",
        "yesOldSettingsPageContinues": "Kyllä. Itse asiassa vanha asetussivu säilyy edelleen, joten voit edelleen tehdä muutoksia siellä. Vanha ja uusi kalenteri-widget toimivat itsenäisesti, mutta ovat jatkuvasti synkronoituna keskenään, jotta saatavuutesi lasketaan tarkasti molemmissa järjestelmissä. Sekaannusten välttämiseksi suosittelemme käyttämään uusia URL-osoitteita aina kun mahdollista, jotta vältät kahden erillisen URL-osoitteen seuraamisen samalle käyttäjäryhmälle.",
        "yesSyncOnGoogleCalendar": "Kyllä, koska yksisuuntainen synkronointi on käytössä, Google-kalenteri varmistaa, että varatut ajat estetään."
      },
      "companyPlansModal": {
        "billedAnnually": "Laskutetaan vuosittain",
        "billedMonthly": "Laskutetaan kuukausittain",
        "changePlanFor": "Muuta aikataulua sijainnille {locationName}",
        "notAuthorized": "Sinulla ei ole valtuuksia suorittaa tätä toimintoa. Vain toimiston käyttäjät/ylläpitäjät ja sijainnin ylläpitäjät voivat suorittaa sen.",
        "payAnnually": "Maksa vuosittain",
        "payMonthly": "Maksa kuukausittain"
      },
      "locationBillingHistory": {
        "billingHistory": "Laskutushistoria",
        "cardNo": "Kortin nro.",
        "errorWhileFetchingInvoices": "Virhe laskujen noutamisessa, yritä uudelleen napsauttamalla",
        "invoiceDescription": "Laskun kuvaus",
        "invoiceNo": "Laskun numero",
        "noInvoices": "Ei laskuja",
        "refunded": "Hyvitetty",
        "succeeded": "onnistunut",
        "view": "KATSO"
      },
      "locationWallet": {
        "autoRechargeWith": "Automaattinen lisäys kohteelle",
        "balance": "Saldo:",
        "credits": "Krediitit",
        "seeTransactions": "Näytä transaktiot",
        "whenBalanceLowerThan": "saldon ollessa alle"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Tarkista sähköposti ({emails}).",
        "csvSentMessage": "Lähetämme CSV-tiedoston sähköpostiisi. Tämä kestää yleensä 7–10 minuuttia.",
        "enterEmailAddress": "Anna sähköpostiosoite",
        "exportAndSendCsv": "Vie ja lähetä CSV",
        "exportTransactions": "Vie transaktiot",
        "itUsuallyArrives": "Se saapuu yleensä 10 minuutissa.",
        "useCommasToSeparate": "Erota useat sähköpostiosoitteet pilkuilla."
      },
      "modifySubscription": {
        "cancelClientDescription": "Mitätöi asiakkaasi tilaus ja sulje tili",
        "cancelDescription": "Peruuta tilauksesi ja sulje tili",
        "cancelImmediately": "Peruuta välittömästi",
        "cancelNow": "Peruuta nyt",
        "cancelSubscription": "Peruuta tilaus",
        "changedYourMind": "Oletko muuttanut mieltäsi?",
        "changedYourMindClient": "Voit jatkaa asiakkaasi tilausta",
        "changedYourMindYou": "Voit jatkaa tilaustasi",
        "confirmByTyping": "Vahvista kirjoittamalla alle {text}",
        "confirmCancellation": "Vahvista peruutus",
        "modifySubscription": "Muokkaa tilausta",
        "modifyYourSubscription": "Muokkaa tilaustasi",
        "resumeSubscription": "Jatka tilausta",
        "subscriptionWillBeCancelledOn": "Tämä aikatauluttaa tilauksesi peruutettavaksi {date}. Voit jatkaa tilausta keskeyttämällä ajoitetun peruutuksen milloin tahansa.",
        "subscriptionWillBeCancelledOnClient": "Tämä aikatauluttaa asiakkaasi tilauksen peruutuksen päivämäärälle {date}. Sinä ja asiakkaasi voitte jatkaa tilausta keskeyttämällä ajoitetun peruutuksen milloin tahansa.",
        "subscriptionWillBeCancelledOnDate": "Tilauksesi peruutetaan {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Asiakkaasi tilaus peruutetaan {date}.",
        "subscriptionWillBeResumed": "Tilauksesi jatkuu ja sinua laskutetaan normaalisti.",
        "subscriptionWillBeResumedClient": "Asiakkaasi tilaus jatkuu ja sitä aletaan laskuttaa normaalisti.",
        "upgradeDescription": "Siirry korkeampaan tilaussuunnitelmaan",
        "weAreGladYouStaying": "Hienoa kuulla, että jatkat tilaustasi!",
        "nextBillingDate": "Seuraava laskutuspäivä: {date}",
        "cancelImmediatelyTitle": "Haluatko todella peruuttaa tilauksen heti?",
        "cancelNowDescription": "Tilauksesi on tarkoitus peruuttaa {date}. Jos päätät peruuttaa nyt, tilisi, mukaan lukien kaikki lähtevät toiminnot, kuten ajastetut viestit ja sähköpostit, lopetetaan heti.",
        "cancelNowDescriptionClient": "Asiakkaasi tilaus on määrä peruuttaa {date}. Jos päätät peruuttaa nyt, asiakkaasi tili, mukaan lukien kaikki lähtevä toiminta, kuten ajastetut viestit ja sähköpostit, lopetetaan välittömästi.",
        "modifyDescription": "Voit {action} tilauksesi",
        "modifyDescriptionClient": "Voit {action} asiakkaasi tilauksen."
      },
      "noPaymentMethodWarning": {
        "addNow": "Lisää nyt",
        "youNeedToEnterCardInfo": "Sinun on annettava korttisi yksityiskohdat.",
        "youNeedToEnterClientCardInfo": "Sinun täytyy antaa asiakkaasi korttitiedot."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Veloitukset perustuvat valtuuksiin. Alla näkyvät sanamäärät ovat arvioita, jotka auttavat sinua ymmärtämään käyttöä. Todelliset veloitukset voivat vaihdella.",
        "examplePricingGpt4oMini": "Hinnoitteluesimerkki – GPT-4o Mini",
        "for750kWords": "(750 000 sanaa) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Syöte",
        "or": "tai ",
        "output": "Tuloste",
        "perImage": " / Kuva",
        "perResultSelection": " / Tulosten valinta",
        "ratesMayDifferUK": "Hinnat voivat vaihdella alueittain. Esitetyt laskelmat ovat Yhdistyneen kuningaskunnan hintojen mukaisia, lue",
        "ratesMayDifferUS": "Hinnat voivat vaihdella alueen ja numerotyypin mukaan. Laskelmat esitetään Twilio-hintojen mukaisesti Yhdysvalloissa,",
        "pleaseCheckSupport": "lue",
        "resultSelection": " Tulosten valinta",
        "supportDoc": "tukiasiakirja",
        "forMoreDetails": "lisätietoja",
        "words": " sanaa"
      },
      "removePaymentMethod": {
        "endingIn": "Päättyy *{cardNo}",
        "no": "Ei",
        "removeCard": "Poistetaanko kortti?",
        "removing": "Poistetaan..",
        "yesRemove": "Kyllä, poista"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Pyydä asiakkailta maksutiedot",
        "saasLocationDescription": "Määritä SaaS-tilaus tälle sijainnille",
        "selectSpace": "Valitse tila",
        "spaceDescription": "Valitse, mihin haluat määrittää laskutuksen tälle sijainnille"
      },
      "saasEnableProducts": {
        "disable": "Poista käytöstä",
        "enableDisableProducts": "Ota tuotteet käyttöön / poista ne käytöstä",
        "feature": "Ominaisuus",
        "unsavedChanges": "Tallentamattomia muutoksia"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Tämän asiakkaan seuraava laskutus näyttää olevan jo menneisyydessä. Tämä tapahtuu, kun toimistosi Stripe-tili ei toimi kunnolla. Kirjaudu sisään toimistosi Stripeen korjataksesi sen.",
        "copiedText": "kopioitu teksti:",
        "couldNotCopy": "Asynkroninen: tekstiä ei voitu kopioida: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Seuraava laskutuspäivä: ",
        "plan": "Paketti",
        "pleaseContactAgency": "Ota yhteyttä toimistoon ottaaksesi tilauksen käyttöön.",
        "stripeSubscriptionId": "Stripe-tilauksen tunnus:",
        "subscriptionPlans": "Tilaussuunnitelmat",
        "subscriptionWillBeCancelledOn": "Tilauksesi peruutetaan {date}",
        "subscriptionWillBeCancelledOnClient": "Asiakkaasi tilaus peruutetaan {date}",
        "toModifyClientSubscription": "muokataksesi asiakkaasi tilausta",
        "toModifyYourSubscription": "muokataksesi tilaustasi",
        "whatsappNumberSubscription": "WhatsApp-numerotilaus",
        "yourBillingDatePast": "Seuraava laskutuspäivä näyttää olevan menneisyydessä. Lähetä sähköpostia osoitteeseen {email} korjataksesi tämän. Kaikki jatkuu sillä välin tavalliseen tapaan."
      },
      "salesResources": {
        "certifiedUser": "Sertifioitu käyttäjä",
        "clearFilter": "Tyhjennä suodatin",
        "dateRange": "Päivämääräalue"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Maksat {amount} $ /kk, laskutettuna {interval}",
        "planUpgradeFailed": "Suunnitelmaasi ei voitu päivittää!!",
        "planUpgraded": "Suunnitelmasi on päivitetty!",
        "retryUpgrade": "Yritä päivittää uudelleen",
        "upgradeFailed": "Suunnitelman päivitys epäonnistui. Yritä uudelleen.",
        "upgradedSuccessfully": "Olet päivittänyt suunnitelman {oldPlan} onnistuneesti suunnitelmaan {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "laskutetaan kuukausittain hintaan {amount} /kuukausi",
        "billedAsYearlyCharge": "laskutetaan vuosittain hintaan {amount} /vuosi",
        "upgradeFrom": "Päivitä kohteesta",
        "whatYouWillGet": "Saat:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo transaktion jälkeen:",
        "callDuration": "Puhelun kesto:",
        "callSid": "Puhelun SID:",
        "charge": "Veloitus:",
        "contact": "Kontakti:",
        "contactName": "Kontaktin nimi:",
        "contactPhone": "Kontaktin puhelinnumero:",
        "credit": "Luotto:",
        "creditsAfterTransaction": "Luotto transaktion jälkeen:",
        "dateSent": "Lähetyspäivämäärä",
        "deleted": "-<Deleted>",
        "discount": "Alennus:",
        "eventId": "Tapahtumatunnus:",
        "from": "Lähettäjä:",
        "noContactFound": "Kontaktia ei löytynyt",
        "noOfSegments": "Segmenttien määrä:",
        "openContactPage": "Avaa kontaktisivu",
        "openConversation": "Avaa keskustelu",
        "openEvent": "Avata tapahtuma",
        "originalCharge": "Alkuperäinen veloitus:",
        "received": "Vastaanotettu",
        "smsSid": "SMS SID:",
        "timeBilled": "Laskutettu aika:",
        "timeOfCall": "Puhelun aika",
        "transactionDetails": "Transaktiotiedot -",
        "transactionId": "Transaktiotunnus:",
        "type": "Tyyppi:",
        "segments": "Segmentit"
      },
      "calendarSettings": {
        "meetings": "Tapaamiset",
        "services": "Palvelut",
        "hideCalendarWarning": "Jos haluat piilottaa kalenterimoduulin kokonaan, tee se kohdassa Alatilin asetukset > Oma henkilökunta > Roolit ja käyttöoikeudet",
        "calendarSettingsUpdated": "Kalenteriasetukset on päivitetty",
        "meetingDescription": "Ota tämä asetus käyttöön, jotta alatilit voivat käyttää kokousominaisuutta, joka on suunniteltu myyntikalentereiden, perehdytyspuheluiden, Round Robin ‑aikataulutusten, tiimiyhteistyön, luokkavarausten, haastattelujen ja muiden toimintojen hallintaan. Ihanteellinen yrityksille, jotka tarvitsevat joustavia ja yhteistyöhön perustuvia aikataulutustyökaluja.",
        "serviceDescription": "Ota palvelut käyttöön, niin alatilit saavat palvelupohjaisten yritysten täydellisen varausratkaisun käyttöoikeuden. Siihen sisältyy muun muassa useita palveluita sisältävien varaussivujen luominen, resurssien hallinta, useiden sijaintien käsittely, henkilökuntakohtaisen hinnoittelun määrittäminen ja palveluvariaatioiden tai lisäosien lisääminen."
      }
    },
    "apiKeys": {
      "apiKey": "API-avain",
      "copied": "Kopioitu!",
      "copyApiKey": "Kopioi API-avain",
      "createApiKey": "Luo API-avain",
      "deleteAllKeys": "Poista kaikki avaimet",
      "nameRequired": "Nimi-kenttä on pakollinen",
      "somethingWentWrong": "Pahoittelut! Jokin meni pieleen! Yritä uudelleen.",
      "updatedSuccessfully": "Päivitetty"
    },
    "billing": {
      "accountPaused": "Tilisi {name} on keskeytetty.",
      "accountProvisioned": "Tiliäsi valmistellaan parhaillaan.",
      "activateSubAccount": "Aktivoi alatili",
      "activeServices": "Aktiiviset palvelut",
      "addNewCard": "Lisää uusi kortti",
      "addNewService": "Lisää uusi palvelu",
      "addPaymentMethod": "Lisää maksutapa",
      "alertIcon": "hälytyskuvake",
      "approve": "Hyväksy",
      "authenticateCardMessage": "Turvallisuuden lisäämiseksi sinun on vahvistettava korttitietosi uudelleen.",
      "badActorWarning": "Jos uskot, että tämän alatilin on luonut haitallinen toimija, suosittelemme poistamaan alatilin ja peruuttamaan sitä vastaavan tilauksen.",
      "callUs": "Soita meille",
      "cancelAndDelete": "Peruuta tilaus ja poista alatili",
      "completeFormNextStep": "Täytä lomake seuraavassa vaiheessa",
      "congratulations": "🎉 Onnittelut! 🎉",
      "contactAgency": "Ota yhteyttä toimistoosi ongelman ratkaisemiseksi.",
      "contactThroughEmailOrPhone": "Voit ottaa meihin yhteyttä joko sähköpostitse tai puhelimitse ongelman ratkaisemiseksi",
      "dataSafe": "Kaikki tietosi ovat turvassa, ja kaikki automaatiot, verkkosivut jne. alkavat taas toimia, kun maksu on suoritettu onnistuneesti.",
      "declineSubAccount": "Hylkää alatili",
      "deleteRecommendation": "Tämän alatilin poistaminen on suositeltavaa. Tai voit tehdä sen myöhemmin kohdasta Alatilit > Hallinnoi asiakasta.",
      "emailUsAt": "Lähetä meille sähköpostia osoitteeseen",
      "moveToDashboard": "Siirry raporttinäkymään",
      "noPaymentMethods": "Näyttää siltä, että maksutapoja ei ole lisätty! Ole hyvä",
      "paymentMethod": "Maksutapa",
      "paymentMethodUpdated": "Maksutapasi on päivitetty",
      "paymentNotCompleted": "Näet tämän viestin, koska maksua ei ole suoritettu.",
      "proceedToNextStep": "Jatka seuraavaan vaiheeseen.",
      "questionMark": "?",
      "reachOutMessage": "Ota yhteyttä, jos sinulla on kysyttävää.",
      "reactivateBillingFor": "Aktivoi laskutus uudelleen sijainnille {location}",
      "retryPayment": "Yritä maksua uudelleen",
      "secureSystemMessage": "Olemme siirtyneet turvallisempaan laskutusjärjestelmään.",
      "setupMessage": "Joku ottaa sinuun yhteyttä tilin määrittämiseksi. Se vie yleensä 12–24 tuntia,",
      "signout": "Kirjaudu ulos",
      "subAccountId": "Alatilin tunnus:",
      "successfullyInitiated": "{product} on aloitettu onnistuneesti",
      "systemError": "Järjestelmävirhe ilmeni",
      "toReactivate": "aktivoidaksesi tilin uudelleen",
      "userImage": "Käyttäjäkuva",
      "verificationSkipped": "Sähköposti- ja puhelinvahvistus ohitetaan tämän alatilin kohdalla, ja asiakas voi kirjautua tilille.",
      "verifyAccount": "Vahvista tili",
      "verifyAfterAttempt": "Voit vahvistaa tämän tilin vähintään yhden alatilin ylläpitäjän tekemän vahvistusyrityksen jälkeen.",
      "verifySubAccount": "Vahvista alatili",
      "recommendedPlans": "Suositellut suunnitelmat",
      "buildYourOwnPlan": "LUO OMA SUUNNITELMASI",
      "resetToDefaults": "Palauta oletusasetukset",
      "paymentMethodChange": "Jos sinun täytyy vaihtaa maksutapaa",
      "approveSubAccount": "Hyväksy alatili",
      "approveSubAccountDescription": "Alatili otetaan uudelleen käyttöön, ja alatilin ylläpitäjät voivat päästä sisään ja käyttää tiliä.",
      "productInitiated": "Tuote käynnistetty"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Tätä toimintoa ei voi peruuttaa.",
      "cancelKeep": "Peruuta, säilytä",
      "confirmDeletionInstructions": "Tallenna poisto kirjoittamalla {word} alle:",
      "enterConfirm": "Syötä {word} uudelleenluontia varten",
      "message": "Tämän sijaintien API-avain poistetaan.",
      "title": "Poistetaanko sijainnin API-avain?",
      "yesDelete": "Kyllä, poista"
    },
    "generalDetails": {
      "noPermission": "Sinulla ei ole oikeutta ladata tiedostoa. Tarkista käyttöoikeutesi toimistosi järjestelmänvalvojalta.",
      "relatedContacts": "Aiheeseen liittyvät kontaktit ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Haluatko varmasti poistaa kaikki sijaintien API-avaimet?",
      "deleteAllConfirmTitle": "Poistetaanko kaikki sijainnin API-avaimet?",
      "deleteConfirmMessage": "Tämä poistaa API-avaimen sijainnille: {location}. Haluatko jatkaa?",
      "deleteAgencyApiKeyConfirmMessage": "Tämä poistaa API-avaimen. Haluatko jatkaa?",
      "fetchingLocations": "Haetaan sijainteja...",
      "maxApiKeysMessage": "Sinulla voi olla enintään viisi API-avainta.",
      "noLocationsFound": "Sijaintia ei löytynyt",
      "old": "Vanha",
      "proPlanRequiredMessage": "Tämä on osa Advanced API:ta, joka on saatavilla Pro-sopimuksessa.",
      "searchLocation": "Hae sijainti",
      "title": "Sijainnin API-avain"
    },
    "locationCard": {
      "deletionScheduledMessage": "Tämä alatili poistetaan {date}, jos olet muuttanut mieltäsi -",
      "emailUsageNotRebilled": "Sähköpostin käytöstä ei tehdä uudelleenlaskutusta",
      "emailUsageRebilled": "Sähköpostin käyttö laskutetaan uudelleen asiakkaallesi",
      "listings": "Listaukset",
      "manageClient": "Hallinnoi asiakasta",
      "paymentPending": "Maksu on kesken",
      "remainingWalletBalance": "Tämän SaaS-sijainnin jäljellä oleva lompakkosaldo",
      "requestPaymentAgain": "Pyydä maksu uudelleen",
      "saasModeActivated": "SaaS-tila on aktivoitu",
      "saasModeNotActivated": "SaaS-tilaa ei ole aktivoitu",
      "saasSubscriptionNotEnabled": "SaaS-tilaus ei ole käytössä",
      "saasSubscriptionRunning": "SaaS-tilaussopimus on käynnissä",
      "social": "Some",
      "switchToSaaS": "Vaihda SaaS:iin",
      "switchToSubAccount": "Vaihda alatiliin",
      "telephoneUsageNotBilled": "Puhelimen käyttöä ei laskuteta",
      "telephoneUsageRebilled": "Puhelimen käyttö laskutetaan uudelleen asiakkaallesi",
      "wordpressActive": "WordPress aktiivinen",
      "wordpressInactive": "WordPress inaktiivinen",
      "wordpressNotSoldYet": "WordPressiä ei ole vielä myyty",
      "wordpressSaleSuccessful": "WordPress-myynti onnistui",
      "yextActive": "Yext aktiivinen",
      "yextInactive": "Yext inaktiivinen",
      "yextNotSoldYet": "Yextiä ei ole vielä myyty",
      "yextSaleSuccessful": "Yext-myynti onnistui",
      "reviews": "Arvostelut"
    },
    "messageUsage": {
      "acceptTnc": "Hyväksy käyttöehdot",
      "cannotPerformAction": "Tätä toiminta ei voida suorittaa. Ota yhteyttä tukeen.",
      "currentLimit": "Tämänhetkinen rajoitus",
      "days": "Päivä(t)",
      "failedToUpdate": "Viestin käytön päivittäminen epäonnistui.",
      "helpCentre": "Ohjekeskus",
      "increaseLimitFurther": "Nosta rajaa edelleen",
      "increaseLimitNow": "Nosta rajaa nyt",
      "lessThanUsage": "Tämänhetkinen käyttö on {usage}, ja valittu käyttö on vähemmän kuin tämänhetkinen käyttö.",
      "lessThanUsageModal": "Tämänhetkinen käyttö on {usage}, raja ei voi olla vähemmän kuin tämänhetkinen käyttö",
      "limitAlreadyUnlocked": "Rajoitus on jo avattu käyttöön",
      "limitReached": "Raja saavutettu",
      "limitUpdatedFrom": "{type} raja päivitetty {old}:sta {new}:een.",
      "lookingForSmsLimit": "Etsitkö tekstiviestirajoitusta?",
      "minLimitShould": "Minimirajan tulisi olla {limit}",
      "newLimit": "Uusi {type} rajoitus",
      "perDay": "/ Päivä",
      "sameLimit": "Valittu raja on sama kuin tämänhetkinen raja!",
      "smsLimitLocation": "SMS-raja löytyy nyt sijaintitasolla",
      "smsLimitSettingsInfo": "Nyt löydät nämä asetukset kohdasta Viestirajoitus osiossa Lisäasetukset.",
      "timesInLast30Days": "Kerrat kuluneiden 30 päivän aikana",
      "todaysUsage": "Käyttö tänään",
      "typePerDay": "{type} / päivä",
      "updateLimit": "Päivitä raja",
      "updateLimitFor": "Päivitä tilin {name} {type} rajoitus"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Aktiiviset {type}",
      "contactSource": "Kontaktin lähde",
      "customer": "Asiakas",
      "noPastCampaignsWorkflows": "Ei mennyt {type}",
      "pastCampaignsWorkflows": "Mennyt {type}"
    },
    "settings": {
      "affiliateSettings": "Kumppanin asetukset",
      "agencyBilling": "Toimiston laskutus",
      "agencyTeamManagement": "Toimiston tiiminhallinta",
      "apiKeys": "API-avaimet",
      "compliance": "Vaatimustenmukaisuus",
      "customMenuLink": "Mukautettu valikkolinkki",
      "launchpadSettings": "Launchpad-asetukset",
      "phoneSystemTwilio": "Puhelinjärjestelmä – Twilio",
      "smtpService": "SMTP-palvelu",
      "userSettings": "Käyttäjäasetukset",
      "agencySettings": "Toimiston asetukset",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Virhe tilannevedoksen luomisessa",
      "pickAnAccount": "Teidän täytyy valita tili.",
      "snapshotName": "Tilannevedoksen nimi",
      "snapshotNameRequired": "Sinun on annettava tilannevedokselle nimi."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Google Places ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram-URL",
      "linkedInUrl": "LinkedIn-URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pintrest URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Pyyntö tekstiviestitse",
    "iAlreadyHaveACustomer": "Minulla on jo asiakas",
    "noAccountFound": "Tiliä ei löytynyt!",
    "thisIs": "Tämä on",
    "pleaseEnterValueBetween0To30Days": "Syötä arvo 0–30 päivän välillä",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Lue, miten voit lisätä näihin paketteihin kertaluonteisen määritysmaksun",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">Älä poista</span> näitä tuotteita Stripe-tililtäsi.",
    "opportunityStats": "Mahdollisuustilastot",
    "createNewSnapshot": "Luo uusi tilannevedos",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Toimiston raporttinäkymä näkyvissä kohteelle",
      "onlyMe": "Vain minä",
      "allAgencyAdmins": "Kaikki toimiston ylläpitäjät",
      "stripeConnect": "Poistetaan pian käytöstä. Vaihda Stripe Connectiin",
      "recommendStripe": "Suosittelemme Stripe Connectin käyttöä paremman turvallisuuden takaamiseksi.",
      "switchToStripeConnect": "Vaihda Stripe Connectiin",
      "highLevelAccess": "HighLevel pääsee käsiksi tietoihisi ja voi luoda maksuja ja asiakkaita puolestasi",
      "stripeAccountWarning": "Kun Stripe-tili on yhdistetty, sitä ei voi muuttaa myöhemmin. On suositeltavaa käyttää uutta Stripe-tiliä, joka on tarkoitettu Highlevel-ansioille.",
      "connectToStripeAccount": "Yhdistä Stripe-tilillesi",
      "unverified": "Tähän toimistoon liitetty Stripe-tili on vahvistamaton eikä voi kerätä maksuja. Suorita vahvistus loppuun kirjautumalla sisään Stripe-tilillesi.",
      "loginToStripe": "Kirjaudu sisään Stripeen",
      "connectedAccount": "Yhdistetty tili",
      "verified": "VAHVISTETTU",
      "totalPendingBalance": "Käsiteltävä kokonaissaldo",
      "disconnectStripe": "Katkaise yhteys Stripeen",
      "removeSaasPlanConfigurations": "Poistetaanko kaikki SaaS-suunnitelman määritykset?",
      "haveSaasPlans": "Stripe-tilillä on luotuja SaaS-suunnitelmia!",
      "disconnectWarning": "Jos katkaiset yhteyden, kaikki SaaS-suunnitelmat menetetään ja sinun täytyy luoda ne uudestaan.",
      "acknowledgeDisconnect": "Hyväksyn, että kaikki SaaS-suunnitelmani menetetään ja minun on luotava ne uudelleen.",
      "disconnect": "Katkaise yhteys"
    },
    "zoomSuccess": {
      "title": "Toivottavasti kokemuksesi oli hieno!",
      "message": "Kiitos, että osallistuit puheluun. Toivottavasti palaat nauttimaan palveluistamme pian uudelleen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Kokeilukokemusasiantuntijasi",
      "successSpecialist": "Menestysasiantuntijasi",
      "supportSpecialist": "Tukiasiantuntijasi",
      "jumpOnZoomCall": "Osallistu aloituspuheluun kanssani aloittamalla Zoom-puhelu",
      "jumpOnChat": "Ota yhteyttä chatissa, niin autan sinua",
      "joinVideoCallNow": "Liity videopuheluun nyt",
      "whatToExpect": "Mitä on odotettavissa?",
      "helpArticles": "Ohjeartikkelit",
      "changelog": "Muutosloki",
      "ideasBoard": "Ideataulu"
    },
    "saasDashboard": {
      "title": "SaaS-hallintapaneeli",
      "plansAndPricing": "Suunnitelmat ja hinnoittelu"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Tälle sivulle on nyt saatavilla siistimpi ja nopeampi Konsoli. Kokeile itse!",
      "enableInLabs": "Ota käyttöön laboratorioissa",
      "pendingTransferRequests": "Sinulla on odottavia alatilien siirtopyyntöjä.",
      "otherAgenciesRequested": "Muut toimistot ovat pyytäneet alatilien siirtämistä sinulle.",
      "reviewRequests": "Arvostelupyynnöt",
      "clientList": "Asiakasluettelo (alatilit)",
      "subAccountTransfers": "Alatilien siirrot"
    },
    "implementationModal": {
      "title": "HighLevel-videopuhelukokemuksesi alkaa pian!",
      "videoCall": "Videopuhelu",
      "whatsNext": "Mitä seuraavaksi?",
      "enteringLobby": "Siirryt aulaamme muiden kaltaistesi Highlevelereiden kanssa!",
      "successConcierge": "Success Conciergemme tervehtii sinua ja yhdistää sinut seuraavaan vapaaseen neuvonantajaan kahdenkeskistä istuntoa varten.",
      "haveReady": "Pidä seuraavat asiat valmiina",
      "stableInternet": "Vakaa internetyhteys.",
      "videoNameMatches": "Videossa nimesi vastaa HighLevel-käyttäjätunnustasi.",
      "estimatedDuration": "Arvioitu istunnon kesto",
      "firstVisit": "Ensimmäinen vierailu: HighLevel-perehdytysistunto: (45–60 min).",
      "returning": "Palaaminen: jatkuva käyttöönoton tuki (15–25 minuuttia).",
      "meetingBegins": "Kokouksesi alkaa automaattisesti <span class=\"text-[#155EEF]\">{ countdown } sekunnin kuluttua.</span>  Tai voit liittyä heti napsauttamalla alla olevaa painiketta:",
      "joinNow": "Liity nyt"
    },
    "gdpr": {
      "logo": "GDPR-logo",
      "dataProtection": "Tietosuoja ja GDPR",
      "introduction": "Johdanto",
      "intro1": "HighLevel on sitoutunut suojelemaan käyttäjiensä ja heidän asiakkaittensa yksityisyyttä. Seuraamme tietosuojalakien kehitystä varmistaaksemme, että voit luottaa turvallisuuteesi käyttäessäsi alustaamme.",
      "intro2": "Tällä sivulla selitetään, mitkä säännöt ovat voimassa, miten ne koskevat HighLevel-alustan käyttöäsi ja mitä toimenpiteitä olemme toteuttaneet niiden noudattamiseksi.",
      "intro3": " Sinun tulee lukea tämä asiakirja sekä tietosuojakäytäntömme ja ottaa yhteyttä lakimieheen, jos tarvitset lisätietoja tai neuvoja.",
      "gdprRegulation": "Yleinen tietosuoja-asetus (GDPR)",
      "regulation1": "Asetus (EU) 2016/679, joka tunnetaan yleisesti nimellä yleinen tietosuoja-asetus (GDPR), on EU:n asetus, jonka tarkoituksena on yhdenmukaistaa tietosuoja- ja yksityisyydensuojalainsäädäntöä koko EU:ssa. GDPR:n säännöksiä sovelletaan aina, kun EU:n rekisteröidyn henkilötietoja käsitellään.",
      "regulation2": "GDPR keskittyy antamaan yksilöille enemmän hallinnointia siitä, miten yritykset käyttävät heidän tietojaan sekä lisätä tietojen keräämisen ja käsittelyn läpinäkyvyyttä.",
      "regulation3": "GDPR sisällytettiin suoraan Yhdistyneen kuningaskunnan lainsäädäntöön Brexitin siirtymäkauden päätyttyä, mikä tarkoittaa, että brittiläisten yritysten on edelleen noudatettava sen määräyksiä \"UK GDPR:n\" kautta.",
      "basicConcepts": "GDPR:n peruskäsitteet",
      "controllerAndProcessor": "Rekisterinpitäjä ja käsittelijä",
      "controllerProcessorObligation": "GDPR asettaa henkilölle erilaisia velvoitteita riippuen siitä, onko hän henkilötietojen rekisterinpitäjä vai käsittelijä.",
      "controllerDefinition": " Rekisterinpitäjä on taho, joka päättää henkilötietojen käsittelystä ja tekee päätöksiä käsittelyn perusteista ja käytettävistä menetelmistä. Rekisterinpitäjillä on tiettyjä velvollisuuksia henkilötietojen suhteen, joihin sinun tulee tutustua ennen kuin keräät henkilötietoja asiakkailtasi.",
      "processorDefinition": "Käsittelijä on taho, joka käsittelee tietoja rekisterinpitäjän puolesta ja lukuun. He eivät tee itsenäisiä päätöksiä tiedoista tai niiden käsittelystä, koska he käsittelevät niitä vain rekisterinpitäjän puolesta ja heidän on noudatettava kaikkia rekisterinpitäjän antamia ohjeita.",
      "youAreController": "Kun käytät HighLevel-palvelua, olet rekisterinpitäjä. Sinä hallitset HighLevel-järjestelmään lataamiasi tietoja, mitä teet näillä tiedoilla ja miksi. Tämän seurauksena sinun vastuullasi on varmistaa, että sinulla on laillinen peruste tietojen käsittelylle ja että et säilytä tietoja pidempään kuin on tarpeen.",
      "highlevelIsProcessor": "Sinun tulee varmistaa, että ymmärrät velvollisuutesi rekisterinpitäjänä, ja päivittää omat järjestelmäsi ja käytäntösi, jotta henkilötietojen siirto HighLevelille on lainmukaista. HighLevel on tietojen käsittelijä. Me tallennamme ja hallinnoimme HighLevel-alustan kautta keräämiäsi tietoja ohjeidesi mukaisesti. Emme koskaan käytä HighLevel-järjestelmään lataamiasi henkilötietoja omiin tarkoituksiimme tai ilman ohjeitasi.",
      "legalBasisForProcessing": "Käsittelyn oikeudellinen perusta",
      "legalBasisRequirement": "Henkilötietoja saa kerätä ja käsitellä vain, jos siihen on laillinen peruste. Sallitut oikeusperustat on esitetty GDPR:ssä.",
      "processorReliesOnCustomers": "Käsittelijänä HighLevel luottaa siihen, että asiakkaat valitsevat oikean perusteen, jonka perusteella he keräävät ja käsittelevät henkilötietoja, sekä laativat asianmukaiset ilmoitukset ja suostumukset. Ennen kuin käytät HighLevel-palvelua, sinun tulee selvittää, mitkä oikeusperusteet ovat käytettävissäsi, ja kerätä ja säilyttää henkilötietoja vain siinä laajuudessa kuin se on tarpeen kyseisen oikeusperusteen toteuttamiseksi. Henkilötietojen keräämisen perusteita ei tule muuttaa ilman erittäin hyvää syytä, joten on tärkeää ymmärtää eri perusteiden vaatimukset ja varmistaa, että valitset oikean perusteen alusta alkaen.",
      "dataSubjectAccessRights": "Rekisteröidyn oikeudet",
      "dataSubjectRights": "GDPR myöntää rekisteröidyille (eli asiakkaillesi) tiettyjä oikeuksia, jotka liittyvät heidän henkilötietoihinsa, mukaan lukien oikeus saada pääsy, oikaista ja/tai poistaa kaikki heitä koskevat tiedot.",
      "highlevelEasySystems": "HighLevel on ottanut käyttöön helppokäyttöiset järjestelmät, joiden avulla voit ilmoittaa meille, jos saat tällaisen pyynnön rekisteröidyltä, ja joiden avulla voimme ilmoittaa sinulle, jos saamme tällaisen pyynnön. Varmistamme, että nämä pyynnöt täytetään viipymättä ohjeidesi mukaisesti. Sinun tulee tutustua velvoitteisiin, jotka sinulle asetetaan, mukaan lukien velvoitteet, jotka liittyvät omiin järjestelmiisi tallennettuihin henkilötietoihin tai muihin palveluihin kuin HighLevel-palveluun.",
      "transfersToUSA": "Tietojen siirto Yhdysvaltoihin",
      "transfersRestrictions": "Henkilötietoja ei saa siirtää ETA:n ulkopuolelle muuten kuin erityisissä olosuhteissa. Käytämme vakiosopimuslausekkeita osana tietojenkäsittelysopimustamme, jonka allekirjoitamme kaikkien asiakkaidemme kanssa.",
      "dataSecurity": "Tietoturva",
      "securitySafeguards": "Olemme ottaneet käyttöön vahvat turvatoimet ja toimenpiteet varmistaaksemme, että kaikki hallussamme olevat henkilötiedot säilytetään turvallisesti. Testaamme tuotteitamme säännöllisesti virheiden ja haavoittuvuuksien varalta.",
      "backupSystems": "Varmistamme, että meillä on käytössä säännölliset varmuuskopiointijärjestelmät, ja huolehdimme siitä, että meillä on tietojen palautus- ja tietojen eheysjärjestelmät ja -prosessit, joilla minimoidaan henkilötietojen vioittumisen tai menettämisen riski.",
      "stepsForCompliance": "Toimenpiteet, joihin olemme ryhtyneet varmistaaksemme GDPR-vaatimustenmukaisuuden",
      "dutyAsProcessor": "Suhtaudumme käsittelijän velvollisuuksiimme erittäin vakavasti. Olemme ottaneet käyttöön useita menettelyjä ja toteuttaneet useita toimenpiteitä varmistaaksemme, että noudatamme GDPR-asetusta ja että voit laillisesti lähettää meille keräämäsi henkilötiedot, esimerkiksi:",
      "standardContractualClauses": "Tietojenkäsittelysopimuksessamme käytetään vakiomuotoisia sopimuslausekkeita, joilla varmistetaan, että voit laillisesti lähettää henkilötietojasi meille Yhdysvaltoihin.",
      "detectBreaches": "Pystymme havaitsemaan henkilötietojen loukkaukset ja ilmoittamaan niistä asiakkaillemme mahdollisimman pian.",
      "dealWithAccessRequests": "Voimme käsitellä tietojen saantia ja poistamista koskevia pyyntöjä ja varmistamme, että ilmoitamme sinulle, kun rekisteröity on esittänyt meille tällaisen pyynnön.",
      "assessedDocumented": "Olemme arvioineet ja dokumentoineet puolestasi käsittelemämme henkilötiedot.",
      "assessedSecurity": "Olemme arvioineet tietoturvamme ja päivittäneet sitä tarvittaessa varmistaaksemme, että se on asianmukainen suhteessa tietoturvaloukkaukseen liittyvään riskitasoon.",
      "dataProcessingAgreement": "Tietojenkäsittelysopimus",
      "dateUpdated": "Päivityspäivämäärä: 1. huhtikuuta 2023",
      "downloadAgreement": "Lataa sopimus",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Onko sinulla kysyttävää?"
    },
    "sendGridSettings": {
      "title": "SendGrid-asetukset",
      "settingsForLocations": "Sijaintien SendGrid-asetukset",
      "sendGrid": "SendGrid",
      "last12Months": "Viimeiset 12 kuukautta",
      "totalSent": "Lähetetty yhteensä",
      "opens": "Avaukset",
      "clicks": "Napsautukset",
      "bounces": "Pomppaukset"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Poistaa Launchpad käytöstä kaikissa sijainneissani.",
      "description1": "Launchpad on hyvin suunniteltu aloitussivu, joka on todistetusti lisännyt asiakastyytyväisyyttä ja asiakaspysyvyyttä lisäämällä tuotteen käyttöä. ",
      "description2": "GMB:n, FB:n, Webchat-liitännäisen ja mobiilisovelluksen kautta yhdistäminen on osoittautunut loistaviksi ominaisuuksiksi, jotka pitävät asiakkaat pidempään palvelun käyttäjinä.",
      "confirmDisable": "Haluatko varmasti poistaa Launchpadin käytöstä?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Tämä on kumppanilinkkisi. Käytä tätä linkkiä, jotta tuttavasi voivat rekisteröidä tilin, ja saat 40 % heidän kuukausittaisista tuloistaan eliniäksi.",
      "appendToUrls": "Lisää tämä URL-osoitteidesi loppuun:",
      "needToSignUp": "Tarvitseeko rekisteröityä?",
      "goToUrl": "Siirry URL:ään:",
      "andSignUpUsing": "ja rekisteröidy käyttämällä sähköpostiosoitetta",
      "asYourEmailAddress": "FirstPromoterin sähköpostiosoitteena.",
      "pageSettings": "Sivun asetukset",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "Pikselin tunnus"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "17. kesäkuuta 2024 alkaen parannettu tilisuojaus otetaan automaattisesti käyttöön tililläsi oletusarvoisesti. Parannetut tietoturvatoimenpiteet sisältävät:",
      "discontinuationOfAutoGeneration": "Sijainti-API-avainten automaattisen luomisen lopettaminen",
      "exclusionOfApiKeysInLocationCrudApis": "API-avainten poissulkeminen Sijainti-CRUD-API-rajapinnoissa",
      "optOutLink": "Jos haluat kieltäytyä tästä muutoksesta, poista Parannettu tilisuojaus käytöstä <a href=\"/settings/company\">Asetukset &gt; Yritys</a>",
      "advancedFunctionalityNote": "Tämä API on tarkoitettu edistyneeseen toiminnallisuuteen. Tukitiimimme ei voi tarjota suoraa apua API-määrityksiin liittyen.",
      "developerCouncilInfo": "Tarjoamme kehittäjäneuvoston, joka kokoontuu kerran kuukaudessa toimistoaikoina (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) sekä kehittäjäyhteisön Slack-kanavan, josta voit löytää apua yhteisöltä ja API-tiimiltämme. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Zapierin käyttämiseen tarvitset tietyn sijainnin Location API -avaimen. Voit saada sen alla olevasta luettelosta tai vaihtamalla tilille vasemmanpuoleisen valikon valitsimen avulla.",
      "partOfAdvancedApi": "Tämä on osa Advanced API:ta, joka on saatavilla Pro-sopimuksessa.",
      "upgradeMessage": "Tämä on osa Advanced API:ta, joka on saatavilla Pro-sopimuksessa. Päivitä <a>napsauttamalla tästä</a>."
    },
    "accountMap": {
      "addAccountManually": "Lisää tili manuaalisesti"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Asetukset ryhminä."
    },
    "accountDetails": {
      "basicDetails": "Perustiedot",
      "saas": "SaaS",
      "rebilling": "Uudelleenlaskutus",
      "marketplaceApps": "Marketplace-sovellukset",
      "advancedEmailSettings": "Lisäasetukset",
      "calendarSettings": "Kalenteriasetukset"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Sijaintiasetusten hallinta",
      "disableAddEmailService": "Poista Lisää sähköpostipalvelu ‑painike käytöstä alatilin sähköpostipalvelun asetuksista.",
      "disableAddSmtp": "Poista Lisää sähköpostipalvelu ‑painike käytöstä alatilin sähköpostipalvelun asetuksista.",
      "restrictSubAccountEmailProvider": "Rajoita alitilien käyttäjien mahdollisuutta lisätä omia sähköpostipalveluntarjoajiaan",
      "disableAddSmtpDescription": "Rajoita alitilien käyttäjien mahdollisuutta lisätä omia sähköpostipalveluntarjoajiaan",
      "enableReVerification": "Ota 90 päivän uudelleenvahvistus käyttöön",
      "locationNoLeadConnector": "Sijainnilla ei ole LeadConnectoria oletussähköpostipalveluntarjoajana.",
      "lcEmailNotEnabled": "Sijainnilla ei ole LeadConnectoria oletussähköpostipalveluntarjoajana.",
      "onlyForAgency": "Näet nämä asetukset vain, jos ne on otettu käyttöön toimistolle",
      "onlyVisibleForAgency": "Näet nämä asetukset vain, jos ne on otettu käyttöön toimistolle",
      "reVerificationDescription": "Jokainen sähköpostivahvistus mitätöidään 90 päivän kuluttua (tämä suojelee mainettasi lähettäjänä ja takaa viesteille parhaan mahdollisen toimitusvarmuuden)"
    }
  },
  "attributes": {
    "addAttribute": "Lisää attribuutti",
    "attributeName": "Attribuutin nimi",
    "enterAttributeName": "Anna attribuutin nimi",
    "number": "Luku",
    "selectAttributeType": "Valitse attribuuttityyppi"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Muut metatiedot",
      "title": "Lisätyt/päivitetyt kentät"
    }
  },
  "bulkActions": {
    "additionalDetails": "Lisätiedot",
    "allOnGivenDate": "Kaikki annetulla päivämäärällä",
    "attempted": "Yritetty",
    "batchQuantity": "Erän lukumäärä",
    "bulkActionProcessing": "Massatoiminnan käsittely",
    "bulkActionTitle": "Massatoiminto",
    "campaignRequired": "Kampanja on pakollinen",
    "currentStatus": "Tämänhetkinen tila",
    "delayBetweenBatches": "Viive erien välillä",
    "dispatchMode": "Lähetystila: {mode}",
    "editBatchQuantity": "Muokkaa erän lukumäärää",
    "emailStats": "Sähköpostitilastot",
    "enterBatchSprintLimit": "Syötä erän sprinttiraja",
    "hideStats": "Piilota tilastot",
    "mode": "Tila",
    "nextProcessingOn": "Käsitellään seuraavaksi",
    "noStatsFound": "Tilastoja ei löydetty",
    "parentBulkActionID": "Ylätason massatoiminnon ID",
    "pleaseEnterQuantity": "Lisää määrä",
    "processAllAsSoonAsPossible": "Käsittele kaikki mahdollisen pian",
    "processAllOnGivenDate": "Käsittele kaikki annettuna päivänä",
    "processDuring": "Käsitellään tämän aikana",
    "processGraduallyDrip": "Käsittele vähitellen (drip)",
    "processingAllowedOn": "Käsittely sallittu",
    "restoredBulkActionId": "Palautettu massatoiminnon ID:",
    "revert": "Kumoa",
    "revertedBulkActionId": "Kumotun massatoiminnon ID:",
    "saveChanges": "Tallenna muutokset",
    "scheduledStart": "Ajoitettu aloitus",
    "showErrorLog": "Näytä virheloki",
    "showImported": "Näytä tuodut",
    "showStats": "Näytä tilastot",
    "skipped": "Ohitettu",
    "statistics": "Tilastot",
    "statuses": {
      "complete": "Valmis",
      "next-drip": "Seuraava Drip",
      "notStarted": "Ei aloitettu",
      "processing": "Käsitellään",
      "queueing": "Jonottaminen",
      "reading": "Lukeminen",
      "resumed": "Jatkettu",
      "reverted": "kumottu",
      "waiting": "Odottaa"
    },
    "successful": "Onnistui",
    "tagsAdded": "Tagit lisätty",
    "tagsRemoved": "Tagit poistettu",
    "tagsRestored": "Tagit palautettu",
    "timeElapsed": "Kulunut aika",
    "totalExported": "Viedyt yhteensä",
    "totalMerge": "Yhdistetyt yhteensä",
    "unknownError": "Tuntematon virhe",
    "updateBatchQuantity": "Päivitä erän lukumäärä",
    "updated": "Päivitetty",
    "usesDynamicList": "** Käyttää dynaamista luetteloa",
    "workflowRequired": "Työnkulku on pakollinen"
  },
  "business": {
    "addedToCompany": "Kontaktit lisätty yritykseen onnistuneesti",
    "cantAddMoreContacts": "Enintään 50 kontaktia voidaan sisällyttää kerralla",
    "cleanerUi": "Selkeämpi käyttöliittymä",
    "common": {
      "addContact": "Lisää kontakti",
      "internalServerError": "Sisäinen palvelinvirhe",
      "to": "kohteeseen"
    },
    "companiesNowHave": "Yrityksillä on nyt",
    "companyNoteLabsText": "Yritysmuistiinpanot on Labs-ominaisuus",
    "contactRemoveCompany": "Haluatko varmasti poistaa tämän kontaktin yrityksestä?",
    "moreFunctionalUx": "Toimivampi käyttökokemus",
    "newCompanyUpdate": "Uusi yrityspäivitys!",
    "tabs": "Välilehdet",
    "tasks": {
      "assignTask": "Määritä tehtävä",
      "assignee": "Vastuuhenkilö",
      "deleteTask": "Poista tehtävä",
      "editTask": "Muokkaa tehtävää",
      "markAsComplete": "Merkitse valmiiksi",
      "markAsPending": "Merkitse odottavaksi",
      "nameAndDescription": "Nimi ja kuvaus",
      "noTasksAvailable": "Tehtäviä ei ole saatavilla"
    },
    "visitLabs": "Vieraile Labsissa"
  },
  "calendar": {
    "googleCalendar": "Google-kalenteri",
    "noSync": "Ei synkronointia",
    "outlookCalendar": "Outlook-kalenteri"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Vaihda Frontend-virheenkorjausohjelmaa"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Virhe tapahtui, yritä uudelleen.",
    "tabs": "Välilehdet",
    "showPassword": "Näytä salasana",
    "hidePassword": "Piilota salasana",
    "goToHomepage": "Siirry etusivulle",
    "leadConnectorHqLogo": "Lead Connector HQ -logo",
    "companyLogo": "Yrityksen logo",
    "countries": {
      "australia": "Australia",
      "austria": "Itävalta",
      "czechRepublic": "Tšekin tasavalta",
      "belgium": "Belgia",
      "brazil": "Brasilia",
      "canada": "Kanada",
      "chile": "Chile",
      "denmark": "Tanska",
      "switzerland": "Sveitsi",
      "germany": "Saksa",
      "estonia": "Viro",
      "spain": "Espanja",
      "finland": "Suomi",
      "france": "Ranska",
      "uk": "Iso-Britannia",
      "hongKong": "Hongkong",
      "hungary": "Unkari",
      "ireland": "Irlanti",
      "italy": "Italia",
      "japan": "Japani",
      "kenya": "Kenia",
      "lithuania": "Liettua",
      "mexico": "Meksiko",
      "netherlands": "Alankomaat",
      "newZealand": "Uusi-Seelanti",
      "norway": "Norja",
      "philippines": "Filippiinit",
      "puertoRico": "Puerto Rico",
      "poland": "Puola",
      "portugal": "Portugali",
      "sweden": "Ruotsi",
      "singapore": "Singapore",
      "unitedStates": "Yhdysvallat",
      "vietnam": "Vietnam",
      "southAfrica": "Etelä-Afrikka"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "Sisään",
      "na": "–",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "puh:+1 555 987 6543",
      "1x": "1x",
      "3x": "3 kertaa",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "Tekstiviesti",
      "api": "API",
      "otp": "Kertakäyttöinen salasana",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "ALV",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Muokkaa numeroryhmää – <strong>{name}</strong>",
      "displayphonenumber": "näytäPuhelinnumero",
      "js_heap_memory": "JS-heap-muisti",
      "vuex_store_modules": "Vuex-moduulit",
      "vuex_store_size": "Vuex-kaupan koko",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "mallikuva",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "Tiedosto-kuva",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com tai utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR</strong> -vahvistus on valmis alatilillesi. Luo luottamusta asiakkaiden kanssa vahvistettujen puheluiden avulla.",
      "mp3wavfile": "mp3/wav-tiedosto",
      "usd": "$",
      "1_555_9876543": "puh:+1 555 987 6543"
    },
    "stepProgress": "Vaihe {currentStep} / {totalSteps}",
    "loadMore": "Lataa lisää",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segmentti vastaa 160 merkin SMS:ää. Napsauta kuvaketta saadaksesi lisätietoja hinnoittelusta.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segmentti vastaa 160 merkin SMS-viestiä. Napsauta kuvaketta saadaksesi lisätietoja hinnoittelusta.",
    "_email": "/ sähköposti",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% kokonaismäärästä",
    "_please_add_a_payment_method_for": "Lisää maksutapa kohteelle! ",
    "_segment": " / segmentti",
    "_used": "Käytetty %",
    "a_new_twilio_account_needs_to_be_created_before_we": "Uusi Twilio-tili täytyy luoda ennen kuin voimme aloittaa uudelleenlaskutuksen",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Alatilillä voi olla enintään 10 mukautettua objektia. Jos raja ylittyy, tästä tilannevedoksesta ei luoda mukautettuja objekteja.",
    "a_twilio_account_is_already_setup_for_this_location": "Twilio-tili on jo luotu tälle sijainnille.",
    "accountName": "Tilin nimi",
    "account_sid": "Tilin SID:",
    "action": "Toiminta",
    "actions": "Toiminnot",
    "activate": "Aktivoi",
    "active": "Aktiivinen",
    "active_listeners": "Aktiiviset kuuntelijat",
    "active_subscriptions": "Aktiiviset tilaukset",
    "ad_manager": " Ad Manager",
    "add": "Lisää",
    "addAction": "Lisää toiminto",
    "add_eliza": "Lisää Eliza",
    "add_image": "Lisää kuva",
    "add_payment_method": "Lisää maksutapa",
    "add_to_account": "Lisää tilille",
    "add_user_icon": "Lisää käyttäjäkuvake",
    "add_your_first_email": "Lisää ensimmäinen sähköpostiosoitteesi.",
    "address": "Osoite",
    "adwords_reporting": "Adwords-raportointi",
    "affiliate_manager": "Kumppanipäällikkö",
    "agency": "Toimisto",
    "agency_logo": "toimistosi logo",
    "agency_settings": "Toimiston asetukset",
    "agent_reporting": "Edustajaraportointi",
    "ai_employee": " AI-työntekijä ",
    "all": "Kaikki",
    "allow_subaccounts_to_cancel_their_subscription": "Salli alatilien peruuttaa tilauksensa",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Salli alatilien siirtyä korkeampaan suunnitelmaan",
    "allowed_format": "Sallittu muoto:",
    "am": "ap.",
    "announcements_click_to_open_in_new_tab": "Ilmoitukset – napsauttamalla avaat uuteen välilehteen",
    "answers": "Vastaukset",
    "app_name": "Sovelluksen nimi",
    "appointments": "Tapaamiset",
    "apps": " sovellukset",
    "ask_ai": "Ask AI",
    "ask_anything": "Kysy mitä tahansa...",
    "assigned_to_another_user": "(Määritetty toiselle käyttäjälle)",
    "at_least_one_location_is_required": "Vähintään yksi sijainti vaaditaan",
    "attach_snapshot": "Liitä tilannevedos",
    "attribution_reporting": "Attribuutioraportointi",
    "authorized_representative": "Valtuutettu edustaja",
    "automation_type": "Automaation tyyppi",
    "available_hours": "Saatavilla olevat tunnit",
    "avg_memoryinstance": "Keskimääräinen muisti / instanssi",
    "back": "Takaisin",
    "base_url": "Perus-URL",
    "between_10_kb_and_5_mb": " 10 kt:n ja 5 Mt:n välillä",
    "birthday_sms": "Syntymäpäivätekstiviesti",
    "birthday_sms_with_image": "Syntymäpäivätekstiviesti kuvalla",
    "blogging": "Bloggaaminen",
    "bounced": "Palautunut",
    "bulk_requests": "Massapyynnöt",
    "business_email": "Yrityssähköposti",
    "business_hours_configurations": "Aukioloaika-asetukset",
    "business_industry": "Liiketoiminta-ala",
    "business_information": "Yrityksen tiedot",
    "business_logo": "Yrityksen logo",
    "business_niche": "Liiketoiminnan erikoisala",
    "business_phone": "Yrityksen puhelin",
    "business_physical_address": "Yrityksen toimipaikkaosoite",
    "business_regions_of_operations": "Liiketoiminnan toiminta-alueet",
    "business_registration_id_type": "Yritysrekisteröinnin tunnuslaji",
    "business_registration_number": "Yrityksen rekisteröintinumero",
    "business_type": "Yritystyyppi",
    "business_website": "Yrityksen verkkosivusto",
    "busy": "Varattu",
    "buttons": {
      "cancel": "Peruuta",
      "confirm": "Vahvista",
      "deleteAll": "Poista kaikki",
      "view": "Katso",
      "close": "Sulje",
      "previous": "Edellinen",
      "next": "Seuraava",
      "clear": "Tyhjennä",
      "save": "Tallenna",
      "edit": "Muokkaa",
      "delete": "Poista",
      "reset": "Nollaa",
      "refresh": "Päivitä",
      "nextLoading": "Seuraava...",
      "copied": "Kopioitu",
      "notNow": "Ei nyt",
      "send": "Lähetä",
      "send1": "Lähetä",
      "download": "Lataa",
      "sendNow": "Lähetä nyt",
      "saved": "Tallennettu",
      "back": "Takaisin",
      "update": "Päivitä",
      "add": "Lisää",
      "submit": "Lähetä",
      "submitting": "Lähetys",
      "done": "Valmis",
      "manageUsers": "Käyttäjien hallinnointi",
      "no": "Ei",
      "yes": "Kyllä"
    },
    "calendar": "Kalenteri",
    "calendar_groups": "Kalenteriryhmät",
    "call": "Soita",
    "call_reporting": "Puheluraportointi",
    "call_tracking_is_disabled": "Puheluiden seuranta on poistettu käytöstä",
    "call_voicemail_settings": "Puhelu- ja vastaaja-asetukset",
    "calls": " puhelut",
    "campaign": "Kampanja",
    "campaigns": "Kampanjat",
    "cancel": " Peruuta ",
    "cancel_subscription": "Peruuta tilaus",
    "cancelled": "Peruutettu",
    "certificates": "Sertifikaatit",
    "change": "Muuta",
    "changed_data": "Muutetut tiedot",
    "charge": " Veloitus",
    "charged_to_customer": "Veloitettu asiakkaalta",
    "chat": "Keskustele",
    "chat_user": "Chat-käyttäjä",
    "chat_widget_icon": "Keskustelu-widget-kuvake",
    "chats_will_be_saved_for_2_days": "Keskustelut tallennetaan kahdeksi päiväksi",
    "check": "tarkista",
    "check_number_validity_before_first_sms_block_incom": "Tarkista numeron voimassaolo ennen ensimmäistä tekstiviestiä, estä saapuvat roskapostipuhelut ja etsi tuntemattomien soittajien nimet ennen puhelimeen vastaamista. Lisämaksuja veloitetaan",
    "cinque_terre": "Cinque Terre",
    "city": "Kaupunki",
    "clear_history": "Tyhjennä historia",
    "click_here": "Napsauta tästä",
    "click_on_create_new_snapshot_to_add_one": " Napsauta Luo uusi tilannevedos lisätäksesi sellaisen.",
    "click_to_access_the_highlevel_welcome_course": "Napsauta päästäksesi HighLevelin aloituskurssille",
    "click_to_upgrade": "Päivitä napsauttamalla",
    "clicked": "Napsautettu",
    "clio": "Clio",
    "cloning": "Kloonaus",
    "close_debugger": "Sulje virheenkorjausohjelma",
    "close_whatsapp_template_creator": "Sulje WhatsApp-mallipohjan luontityökalu",
    "collection": "Kokoelma",
    "columns": "Sarakkeet",
    "coming_soon": "Tulossa pian",
    "company_email_": "Yrityksen sähköposti (",
    "complete_component_data": "Täydelliset komponenttitiedot",
    "complete_event_data": "Täydelliset tapahtumatiedot",
    "complete_query_data": "Kyselytietojen täydellisyys",
    "completed": "Valmis",
    "complimentary_credits": "Ilmaiset krediitit",
    "component": "Komponentti",
    "component_name": "Komponentin nimi",
    "component_type": "Komponenttityyppi",
    "components": " komponentit",
    "condition": "Ehto",
    "confirm": "VAHVISTA",
    "confirmation_message": "Vahvistusviesti",
    "confirmed": "Vahvistettu",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Yhdistä sertifioituun ylläpitäjään – napsauta avataksesi uudessa välilehdessä",
    "connect_with_us_start_live_chat": "Ota yhteyttä meihin – aloita live-keskustelu",
    "connect_your_stripe_account": "Yhdistä Stripe-tiliisi ",
    "connect_zoom": "Yhdistä Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Voit jättää tämän kohdan tyhjäksi, jos päätät käyttää ennalta määritettyä tapaamispaikkaa",
    "contact": "Kontakti",
    "contact_support": "ota yhteyttä tukeen",
    "contact_us_call_highlevel_at_18887324197": "Ota yhteyttä – soita HighLevelille numeroon +1(888)732-4197",
    "contacts": "Kontaktit",
    "content_ai": "Content AI",
    "controls": "Säätimet",
    "conversations": "Keskustelut",
    "copied": "Kopioitu",
    "cost_borne_by_you": " sinun maksamasi kustannukset",
    "count": "Lukumäärä",
    "country": "Maa",
    "createNewFolder": "Luo uusi kansio",
    "credit_balance": "KREDIITTISALDO",
    "current_location_id": "Tämänhetkinen sijaintitunnus",
    "custom": "Mukautettu",
    "custom_email": "Mukautettu sähköposti",
    "custom_niche": "Mukautettu erikoisala",
    "customer_notifications": "Asiakasilmoitukset",
    "customize": "Mukauta",
    "customize_chat_widget": "Mukauta keskustelu-widgetiä",
    "dashboard_stats": "Hallintapaneelin tilastot",
    "data_keys": "Data-avaimet",
    "date": "Päivämäärä",
    "days": "Päivät",
    "dedicated_ip": "Erillinen IP-osoite ",
    "default": "Oletus",
    "default_snapshots": "Oletusarvoiset tilannevedokset",
    "delete": "Poista",
    "deleted": "poistettu",
    "delivered": "Toimitettu",
    "description": "kuvaus",
    "details": "Tiedot",
    "disable_gbp_messaging_not_recommended": "poista GBP-viestintä käytöstä (ei suositella)",
    "disable_tracking": "Poista seuranta käytöstä",
    "disabled": "Poistettu käytöstä",
    "dismiss": "Hylkää",
    "display_name": "Näyttönimi",
    "do_not_delete": "älä poista",
    "do_something": "TEE JOTAIN",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Haluatko säilyttää samanlaisen vai luoda uuden?",
    "download_application_icon": "Lataa sovelluskuvake",
    "draft": "Luonnos",
    "dropdown_icon": "pudotusvalikon kuvake",
    "duplicate": "Kopioi",
    "duration": "Kesto",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza-ohitustagi (valinnainen)",
    "eliza_is_required": "Eliza on välttämätön.",
    "eliza_service": "Eliza-palvelu",
    "email": "Sähköposti",
    "email_resell_settings": "Sähköpostin uudelleenmyyntiasetukset",
    "email_sending": "Sähköpostin lähetys",
    "email_signature": "Sähköpostin allekirjoitus",
    "enable": "Ota käyttöön",
    "enable_beta": " Ota Beeta käyttöön",
    "enable_company_automation": "Ota käyttöön yritysautomaatiot",
    "enable_disable_deprecated_features": "Ota käyttöön / poista käytöstä vanhentuneet ominaisuudet",
    "enable_gbp_call_tracking": " Ota GBP-puheluiden seuranta käyttöön ",
    "enable_gbp_messaging": "ota käyttöön GBP-viestintä",
    "enable_signature_on_all_outgoing_messages": "Ota allekirjoitus käyttöön kaikissa lähtevissä viesteissä",
    "enabled": "Käytössä",
    "notEnabled": "Ei käytössä",
    "enter_a_logical_name": "Anna looginen nimi",
    "enter_the_exact_business_address_as_it_appears_in_": "Syötä yrityksen tarkka osoite täsmälleen sellaisena kuin se näkyy EIN-luettelossa.",
    "enter_the_exact_legal_business_name_as_registered_": "Anna täsmällinen oikeudellinen yritysnimi sellaisena kuin se on rekisteröity EIN-tunnuksella.",
    "enter_the_full_street_address_as_it_appears_in_the": "Syötä koko katuosoite kuten se näkyy EIN-listauksessa.",
    "enter_user_email": "Anna käyttäjän sähköpostiosoite",
    "enter_user_phone_number": "Anna käyttäjän puhelinnumero",
    "enter_your_business_registration_id_type": "Anna yrityksesi rekisteröintitunnuksen tyyppi",
    "enter_your_business_vertical_eg_travel": "Syötä yrityksesi toimiala (esim. matkailu)",
    "error_code": "Virhekoodi",
    "error_code_chart": "Virhekooditaulukko",
    "error_while_copying_api_key": "Virhe API-avaimen kopioinnissa!",
    "event": "Tapahtuma",
    "event_bus_listeners": "Tapahtumabussin kuuntelijat",
    "events": " tapahtumat",
    "everything_in": "Kaikki kohteessa ",
    "exact": "Täsmälleen",
    "execute_this_action_if_the_current_time_falls_in_t": "Suorita tämä toiminto, jos nykyinen aika osuu tähän ikkunaan. Muussa tapauksessa odota seuraavaan ikkunaan asti toiminnon suorittamiseksi.",
    "extension": "Laajennus",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Mainokset",
    "facebook_ads_reporting": "Facebook-mainosten raportointi",
    "facebook_adsets": "Facebook AdSetit",
    "facebook_campaigns": "Facebook-kampanjat",
    "facebook_icon": "Facebook-kuvake",
    "facebook_page": "Facebook-sivu",
    "feature_image": "Ominaisuuskuva",
    "features": "Ominaisuudet:",
    "feedback": "Palaute: ",
    "file_path": "Tiedostopolku",
    "firestore_listeners": "Firestore-kuuntelijat",
    "forms": "Lomakkeet",
    "free": "Ilmainen",
    "fri": "pe",
    "friendly_business_name": "Yrityksen kutsumanimi",
    "from": " kohteesta ",
    "funnels": "Suppilot",
    "gbp_call_tracking": "GBP-puheluiden seuranta",
    "gbp_configuration": "GBP-konfiguraatio",
    "general": "Yleinen",
    "general_information": "Yleistä tietoa",
    "generating_link_please_wait": "Linkkiä luodaan, odota hetki...",
    "google_ads_adgroups": "Google Ads Mainosryhmät",
    "google_ads_ads": "Google Ads -mainokset",
    "google_ads_campaigns": "Google Ads -kampanjat",
    "google_ads_keywords": "Google Ads -avainsanat",
    "google_business_messaging": "Google-yritysviestit",
    "google_business_profile": "Google-yritysprofiili",
    "google_my_business_icon": "Google My Business -kuvake",
    "hello": "Hei ",
    "here": "tässä",
    "hhmm_a": "hh.mm A",
    "hi": "Hei ",
    "hide": "Piilota",
    "highlevel_events_click_to_open_in_new_tab": "Korkean tason tapahtumat – napsauta avataksesi uuteen välilehteen",
    "how_can_i_help_you_today": "Kuinka voin auttaa sinua tänään?",
    "how_did_the_call_go": "Kuinka puhelu sujui?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Kuinka voin laskea sähköpostini hinnan? Napsauta kuvaketta saadaksesi lisätietoja",
    "how_does_it_work": "Miten se toimii",
    "htmlElement": "HTML-elementti (TODO):",
    "html_element_todo": "HTML-elementti (TODO): ",
    "id": "ID: ",
    "if": "Jos",
    "if_activated_the_sender_information_will_be_automa": "Aktivoinnin jälkeen lähettäjän tiedot lisätään automaattisesti ensimmäiseen SMS-viestiin kaikissa massaviestilähetyksissä. Näin varmistetaan vaatimustenmukaisuus ja toimitusaste paranee.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Aktivoinnin jälkeen lisäämme peruutuslinkit sähköpostien alatunnisteisiin, jotta vastaanottajat voivat peruuttaa tilauksen merkitsemättä sähköpostia valitukseksi tai roskapostiksi.",
    "ignore_this_update": "Älä välitä tästä päivityksestä",
    "image": "kuva",
    "image_turned_on": "Kuva kytketty päälle",
    "imported_date": "Tuontipäivämäärä",
    "imported_snapshots": "Tuodut tilannevedokset",
    "inbound": "Saapuva",
    "inbound_number": "Saapuva numero",
    "incoming_call_timeout": "Saapuvan puhelun aikakatkaisu",
    "instance_id": "Esiintymän tunnus",
    "instances": "Esiintymät: ",
    "instructions_mentioned_in_this_page": "Tällä sivulla mainitut ohjeet",
    "internal": "Sisäinen",
    "intro_message": "Johdantoviesti",
    "intro_question": "Johdantokysymys",
    "invalid": "Ei voimassa",
    "invoicing": "Laskutus",
    "is_scheduled_for_deletion_on": " on aikataulutettu poistettavaksi ",
    "job_position": "Työtehtävä",
    "job_title": "Työtehtävä",
    "join_our_facebook_group_click_to_open_in_new_tab": "Liity Facebook-ryhmäämme – napsauta avataksesi uudessa välilehdessä",
    "jpg_or_png": " JPG tai PNG ",
    "just_one_sec": "Hetkinen...",
    "key_sizes": "Avainkoot",
    "label": "tunniste",
    "labels": {
      "sortDirection": "Lajittelusuunta",
      "tableStyling": "Taulukon muotoilu",
      "loadingMore": "Ladataan lisää...",
      "loading": "Ladataan...",
      "filter": "Suodata",
      "search": "Haetaan...",
      "sortBy": "Lajitteluperuste:",
      "perPage": "Per sivu",
      "date": "Päivämäärä",
      "time": "Aika",
      "readMore": "Lue lisää",
      "day": "Päivä",
      "slot": "Aikaväli",
      "template": "Mallipohja",
      "city": "Kaupunki",
      "country": "Maa",
      "state": "Osavaltio",
      "customerName": "Asiakkaan nimi",
      "friendlyName": "Kutsumanimi",
      "required": "* vaaditaan",
      "addressLine1": "Osoiterivi 1",
      "addressLine2": "Osoiterivi 2",
      "postalCode": "Postinumero",
      "searchUsers": "Hae käyttäjiä",
      "unknown": "Tuntematon",
      "businessName": "Yrityksen nimi"
    },
    "last_updated": "Viimeksi päivitetty",
    "launchpad_icon": "launchpad-kuvake",
    "lead": "Liidi",
    "leadconnector": "LeadConnector",
    "learn_how": "(Opi miten)",
    "legal_business_name": "Yrityksen virallinen nimi",
    "limit_updated_from": " rajaa päivitetty alkaen ",
    "listeners": " Kuuntelijat",
    "loading_your_conversation_history": "Ladataan keskusteluhistoriaasi...",
    "location": "Sijainti",
    "locations": " sijainnit",
    "logical_name": "Looginen nimi",
    "logical_name_is_required": "Looginen nimi on pakollinen.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Puheluiden soittaminen",
    "manage_custom_email": "Hallinnoi mukautettua sähköpostia",
    "marketing": "Markkinointi",
    "maximize": "Maksimoi",
    "me_": "Minä (",
    "member_since": "Jäsenyys alkanut",
    "membership": "Jäsenyys",
    "memory_analysis": "Muistianalyysi",
    "memory_api_not_available": "Muistirajapinta ei ole käytettävissä",
    "message": "Viesti",
    "minimize": "Minimoi",
    "minimum_must_be": " Vähimmäismäärän on oltava ",
    "miscellaneous_charges": "Muut maksut",
    "missed_call_text_back": "Vastaamattomien puheluiden viestivastaukset",
    "missed_text_back_call_message": "Vastaamattomien tekstiviestien takaisinsoittopyyntö",
    "model": "Malli",
    "module": "Moduuli",
    "modules": " moduulit",
    "mon": "ma",
    "month": "/kuukausi",
    "monthly": "kuukausittain",
    "more_emails_in_thread": " Lisää sähköposteja ketjussa",
    "mount_count": "Asennusmäärä",
    "mount_time": "Asennusaika",
    "moved_to_calendar_settings": "Siirretty kalenteriasetuksiin",
    "multiple_locations_using_same_twilio_account": "Useat sijainnit käyttävät samaa Twilio-tiliä",
    "must_be_in_range_of_0": " Sen täytyy olla alueella 0–",
    "must_be_less_than_monthly_plan_12": " Sen on oltava pienempi kuin kuukausitilaus × 12 ",
    "my_business_is": "Yritykseni on ",
    "my_snapshots": "Omat tilannevedokset",
    "name": "Nimi",
    "name_of_other_registration_id_type": "Muun rekisteröintitunnuksen tyypin nimi",
    "newFolder": "Uusi kansio",
    "new_task_update": "Uusi tehtäväpäivitys",
    "next": "Seuraava",
    "no_answer": "Ei vastausta",
    "no_bigger_than_25mb": "enintään 2,5 Mt",
    "no_customer_selected": "Asiakasta ei ole valittu",
    "no_error_data_found": "Virhetietoja ei löytynyt",
    "no_payment_method_available": "Maksutapoja ei ole käytettävissä",
    "no_provider_found": "Palveluntarjoajaa ei löytynyt",
    "no_snapshots_found": "Tilannevedoksia ei löytynyt!",
    "noshow": "Ei osallistunut",
    "not": "Ei",
    "not_now": "Ei nyt",
    "not_saved": "Ei tallennettu",
    "notes": "Muistiinpanot",
    "notifications": "Ilmoitukset",
    "now": "Nyt",
    "numbers_and": " numero(t) ja ",
    "objective": "Tavoite:",
    "of": "/",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Perehdytysvideo-oppaat – napsauta avataksesi uudessa välilehdessä",
    "online_listings": "Online-listaukset",
    "only_assigned_data": "Vain määritetyt tiedot",
    "open_performance_debugger": "Avaa suorituskyvyn virheenkorjausohjelma",
    "opened": "Avattu",
    "opportunities": "Mahdollisuudet",
    "options": {
      "ascending": "Nouseva",
      "descending": "Laskeva",
      "none": "-- Ei mitään --"
    },
    "or_drag_and_drop": "Tai vedä ja pudota",
    "outbound": "Lähtevä",
    "pagination": "Sivutus",
    "pass_body_content_here": " Vie viestin runko tänne ",
    "password": "Salasana",
    "paused": "Keskeytetty",
    "payment_links": "Maksulinkit",
    "payment_methods": "Maksutavat",
    "payment_refund": "Maksun palautus",
    "payment_settings_navigation": "Maksuasetusten siirtyminen",
    "payments": "Maksut",
    "payments_integration": "Maksujen integrointi",
    "pending": "Kesken",
    "per_page": "Per sivu",
    "percentage": "Prosenttiosuus",
    "permanently_delete_this_email": "Poista tämä sähköposti pysyvästi",
    "personal_logo": "Henkilökohtainen logo",
    "phone": "Puhelin",
    "phone_number_with_country_code": "Puhelinnumero sisältäen maakoodin",
    "pick_a_niche": "Valitse erikoisala",
    "pick_a_snapshot": "Valitse tilannevedos",
    "pick_business_industry": "Valitse toimiala",
    "pick_business_registration_id_type": "Valitse yritysrekisteröintitunnuksen tyyppi",
    "pick_business_type": "Valitse yrityksen tyyppi",
    "pick_job_position": "Valitse työtehtävä",
    "plans_pricing": "Suunnitelmat ja hinnoittelu",
    "please_enter_a_value_greater_than_20": "Anna arvo, joka on suurempi kuin 20.",
    "pm": "ip.",
    "points": "Pisteet",
    "postalzip_code": "Postinumero",
    "previous": "Edellinen",
    "privacy_policy_url": "Tietosuojakäytännön URL-osoite",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "Tietosuojakäytännön URL-osoite näkyy Google-agenttisi tiedoissa.",
    "process_your_payment": "Käsittele maksusi",
    "profile_picture": "Profiilikuva",
    "profit": "Voitto",
    "prospecting": " Prospektointi ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Anna uusille tileille valmiita tilannevedoksia.",
    "queries": " kyselyt",
    "questions": "Kysymyksiä",
    "quick_actions_icon": "Pikatoimintojen kuvake",
    "re_generate_key": "Luo avain uudelleen",
    "read_only": "Vain luku",
    "receipts_settings": "Kuittiasetukset",
    "receiving_calls": "Puheluiden vastaanottaminen",
    "recent_events": "Viimeaikaiset tapahtumat",
    "recommended": "Suositeltu",
    "recommended_resolution": "Suositeltu ratkaisu:",
    "reconnect": "Yhdistä uudelleen ",
    "record_payment": "Kirjaa maksu",
    "registered": " rekisteröity.",
    "renameFolder": "Nimeä kansio uudelleen",
    "replied": "Vastattu",
    "representative_email": "Edustajan sähköposti",
    "resell_settings": " Uudelleenmyyntiasetukset",
    "reset": "Nollaa",
    "resolve_now": "Ratkaise nyt",
    "resource_counts": "Resurssilukumäärä",
    "restore": "Palauta",
    "results": "Tulokset",
    "reviews": "Arvostelut",
    "rollover_unused_credits_to_next_month": "Siirrä käyttämättömät krediitit seuraavalle kuukaudelle",
    "row": " rivi",
    "runNow": "Juokse nyt",
    "sample_data": "(Näytetiedot)",
    "sat": "la",
    "save": "Tallenna",
    "save_missed_call_text_settings": "Tallenna vastaamattomien puheluiden tekstiviestiasetukset",
    "save_staging_url": "Tallenna vaiheen URL",
    "saved": "Tallennettu",
    "saving": "Tallennetaan...",
    "search": "Hae",
    "search_active_apps": "Etsi aktiivisia sovelluksia...",
    "search_components": "Etsi komponentteja...",
    "search_customer": "Hae asiakasta",
    "search_email": "Hae sähköpostia",
    "search_history": "Hakuhistoria",
    "search_icon": "Hakukuvake",
    "search_listeners": "Etsi kuuntelijoita...",
    "search_modules": "Etsi moduuleja...",
    "search_queries": "Hakutiedustelut...",
    "see_this_review_on_gbp": "Katso tämä arvostelu GBP:ssä ",
    "segments": " segmentit",
    "select": "Valitse",
    "select_a_snapshot": "Valitse tilannevedos",
    "monetary": "RAHALLINEN",
    "pleaseSelectAValue": "Valitse arvo",
    "select_account": "Valitse tili",
    "select_an_account": "Valitse tili",
    "select_eliza_bypass_tag": "Valitse Eliza Bypass -tunniste",
    "select_phone_number": "Valitse puhelinnumero",
    "select_send_to_eliza_tag": "Valitse lähetä Elizaan -tunniste",
    "select_snapshot": " Valitse tilannevedos",
    "select_upto": "Valitse jopa ",
    "selected": "Valittu: ",
    "send": "Lähetä",
    "send_to_eliza_tag_optional": "Lähetä Eliza-tunniste (valinnainen) ",
    "seo": " SEO ",
    "settings": "Asetukset",
    "setup_pending": "Asennus odottaa vahvistusta",
    "share": "Jaa",
    "shared_snapshots": "Jaetut tilannevedokset",
    "shared_type": "Jaettu tyyppi",
    "shipping_and_delivery": "Lähetys ja toimitus",
    "shipping_origin": "Lähetyksen alkuperä",
    "show": "Näytä",
    "showed": "Osallistunut",
    "signin_with_single_signon": "Kirjaudu sisään kertakirjautumisella",
    "size": "Koko",
    "sms_message_sent_to_customer": "SMS-viesti lähetetty asiakkaalle",
    "snapshot_date": "Tilannevedoksen päivämäärä",
    "snapshot_name": "Tilannevedoksen nimi",
    "social_planner": "Somekalenteri",
    "sortBy": "Lajitteluperuste:",
    "sortOptions": {
      "createdDate": "Luontipäivämäärä"
    },
    "source": "Lähde",
    "sources": "Lähteet:",
    "spent": "Käytetty",
    "staging_url_settings_for_db_event": "Vaiheen URL-asetukset (Db-tapahtumaa varten)",
    "state": "Osavaltio",
    "state_prov_region_": "Osavaltio / maakunta / alue *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Kalifornia",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "Columbian piirikunta",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Havaiji",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "Pohjois-Carolina",
      "north_dakota": "Pohjois-Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "Etelä-Carolina",
      "south_dakota": "Etelä-Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Tietueita ei löytynyt",
      "noEntriesToShow": "Ei näytettäviä merkintöjä",
      "unsuccessful": "Epäonnistunut",
      "pending": "Kesken",
      "noUsersFound": "Käyttäjiä ei löytynyt"
    },
    "status": "Tila",
    "stop_delete_operation": "Pysäytä poistamistoiminto",
    "street_address": "Katuosoite",
    "street_address_as_it_appears_in_the_ein_listing": "Katuosoite sellaisena kuin se näkyy EIN-luettelossa.",
    "stripe_icon": "Stripe-kuvake",
    "stripe_integration": "Stripe-integrointi",
    "stripe_secret_key": "Stripe-salausavain",
    "subscriptions": "Tilaukset",
    "sun": "su",
    "surveys": "Kyselyt",
    "suspend_subaccount_when_their_saas_subscription_fa": "Keskeytä alatili, kun heidän SaaS-tilauksensa epäonnistuu.",
    "switchAccount": "Vaihda tiliä",
    "switch_off_sections_below_to_disable": "Poista käytöstä poistamalla alla olevat osiot käytöstä",
    "tags": "Avainsanat",
    "tax_settings": "Veroasetukset",
    "team_management": "Tiimin johto",
    "team_notifications": "Tiimin ilmoitukset",
    "template": "Mallipohja",
    "terms_and_conditions": "Käyttöehdot",
    "test_mobile_no": "Testimobiilinumero",
    "text_messages": "Tekstiviestit",
    "the_proposed_size_is_350px_180px": "Suositeltu koko on 350 × 180 pikseliä.",
    "the_proposed_size_is_512512px": "Ehdotettu koko on 512 x 512 pikseliä",
    "the_selected_language_will_be_used_by_the_system_a": "Järjestelmä käyttää valittua kieltä oletuksena.",
    "the_welcome_message_automatically_appears_after_a_": "Tervetuloviesti ilmestyy automaattisesti, kun käyttäjä aloittaa uuden keskustelun.",
    "these_are_margins_that_are_billed_to_your_clients_": "Nämä ovat katteita, jotka laskutetaan asiakkailtasi ",
    "this_data_will_be_used_for_future_compliance_regis": "Näitä tietoja käytetään tulevassa vaatimustenmukaisuusrekisteröinnissä.",
    "this_is_my_twilio_use_same": "Tämä on minun Twilio, käytä samaa",
    "this_is_visible_to_both_agency_and_location": "Tämä näkyy sekä toimistolle että toimipaikalle",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Tämä nimi näkyy yrityksesi kanssa keskusteleville liideille",
    "this_setting_is_applicable_with_only_team_calendar": "Tämä asetus on voimassa vain tiimikalentereiden kanssa.",
    "this_stripe_customer_is_already_connected_to_anoth": "Tämä Stripe-asiakas on jo liitetty toiseen alitiliin.",
    "thu": "to",
    "tiktok": "TikTok",
    "time_signed": " Allekirjoitusaika: ",
    "time_zone_": "Aikavyöhyke *",
    "timestamp": "Aikaleima",
    "title": "Otsikko",
    "to_resolve_this_problem_follow_the": "Tämän ongelman ratkaisemiseksi, seuraa ohjeita ",
    "token": "Valtuus:",
    "total": "Yhteensä: ",
    "trigger_link": "Triggerilinkki",
    "triggers": "Käynnistimet",
    "tue": "ti",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilion asennus odottaa.",
    "type": "Tyyppi",
    "type_campaign_objective": "Kirjoita kampanjan tavoite",
    "type_message": "Kirjoita viesti",
    "unsavedChangesWarning": "Muutoksiasi ei tallenneta. Haluatko varmasti poistua?",
    "unsaved_changes": "Tallentamattomia muutoksia",
    "unsubscribed": "Tilaus peruutettu",
    "unsuccessful": "Epäonnistunut",
    "update_business_profile_details": "Päivitä yritysprofiilin tiedot",
    "update_is_inprogress_visit_integrations_page_to_fi": "Päivitys on käynnissä, katso lisätietoja integraatiosivulta.",
    "update_url": "Päivitä URL-osoite",
    "updated_date": "Päivityspäivä",
    "updates": " päivitykset",
    "updating": "Päivitetään...",
    "upgrade_to_agency_pro": "päivitä Agency Pro -versioon ",
    "upload": "Lataa",
    "upload_a_file": "Lataa tiedosto",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Käytä tätä Zapier- ja API-integraatioon.",
    "user_email": "Käyttäjän sähköposti",
    "user_permissions": "Käyttäjän käyttöoikeudet",
    "user_role": "Käyttäjärooli",
    "user_type": "Käyttäjätyyppi",
    "valid": "Voimassa",
    "verification_status": "Vahvistustila",
    "verify": "Tarkista",
    "verify_email_using_otp": "Vahvista sähköpostiosoite kertakäyttöisellä salasanalla",
    "view_less": " Näytä vähemmän ",
    "visiblehidden": "Näkyvä/Piilotettu",
    "visit_our_help_center_click_to_open_in_new_tab": "Vieraile ohjekeskuksessamme – napsauta avataksesi uudessa välilehdessä",
    "voicemail": "Vastaaja",
    "wave_integration": "Wave-integraatio",
    "we_have_found_some_errors_in_your_contact_fields_c": "Olemme löytäneet virheitä kontaktikentistäsi. Napsauta kansiota katsoaksesi ja ratkaistaksesi virheet.",
    "websites": "Verkkosivustot",
    "wed": "ke",
    "welcome_message": "Tervetuloviesti",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-kuvake",
    "when": "Kun",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Kun tämä on valittuna, puhelut ohjataan mobiilisovellukseen. (Tätä tuetaan sekä iOS:ssä että Androidissa.)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Kun tämä on valittu, puhelut ohjataan verkkosovellukseen.",
    "which_business_do_you_want_to_link_to_this_locatio": "Minkä yrityksen haluat linkittää tähän sijaintiin?",
    "widget_code": "Widget-koodi",
    "will_give_you_about": " antaa sinulle noin",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-kuvake",
    "workflows": "Työnkulut",
    "xero_integration": "Xero-integraatio",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Voit poistaa tämän sijainnin muutamalla helpolla vaiheella",
    "you_are_not_authorized_to_perform_this_action_only": "Sinulla ei ole valtuuksia suorittaa tätä toimintoa. Vain toimiston ylläpitäjät voivat poistaa alatilejä.",
    "your_email_cost": "Sähköpostikustannuksesi",
    "your_facebook_page_has_been_integrated_however_the": "Facebook-sivusi on integroitu. Seuraavat ominaisuudet eivät kuitenkaan toimi, koska LeadConnectorilla ei ole tarvittavia käyttöoikeuksia: ",
    "your_outlook_connection_has_expired_please_disconn": "Outlook-yhteytesi on vanhentunut. Irrota yhteys ja yhdistä sitten uudelleen tilille yhteyden muodostamiseksi.",
    "zip_code": "Postinumero",
    "zoom_connected_please_close_this_modal": "Zoom yhdistetty, sulje tämä modaali",
    "hidden": "Piilotettu",
    "messageDetails": "Viestin tiedot",
    "openOptions": "Avaa asetukset",
    "progress": "Edistyminen",
    "close": "Sulje",
    "loading": "Ladataan",
    "fullName": "Koko nimi",
    "languages": "Kielet",
    "phoneNumber": "Puhelinnumero",
    "phoneNumberWithCountry": "Puhelinnumero maakoodin kanssa",
    "sendMessage": "Lähetä viesti",
    "services": "Palvelut",
    "servicesProvided": "Tarjotut palvelut",
    "pleaseProvideAValid": "Anna kelvollinen puhelinnumero.",
    "copy": "Kopioi",
    "editApiKey": "Muokaa API-avainta",
    "confirmPay": "Vahvista ja maksa",
    "contactUs": "Ota meihin yhteyttä",
    "decline": "Hylkää",
    "deleteSubaccount": "Poista alatili",
    "disabled1": "poistettu käytöstä",
    "purchaseSummary": "Oston yhteenveto",
    "subscriptionPlan": "Tilaussuunnitelma",
    "businessName": "WhatsApp Yritys -näyttönimi",
    "chooseOne": "Valitse yksi",
    "stateProvRegion": "Osavaltio/maakunta/alue",
    "streetAddress": "Katuosoite",
    "timeZone": "Aikavyöhyke",
    "website": "Verkkosivusto",
    "zipPostalCode": "Postinumero",
    "apiKey": "API-avain",
    "createdAt": "Luotu",
    "deleteAllLocationApi": "Poista kaikki sijainnin API-avaimet",
    "deleteApiKey": "Poista API-avain",
    "generatedBy": "Luonut",
    "lastUsedAt": "Viimeksi käytetty",
    "pageNavigation": "Sivunavigointi",
    "somethingWentWrong": "Jokin meni pieleen!",
    "clickHere": "Napsauta tästä",
    "emailRebillingActive": "Sähköpostin uudelleenlaskutus aktiivinen",
    "saasSubscriptionActive": "SaaS-tilaus aktiivinen",
    "scheduledForDeletion": "Poistettavaksi ajoitettu",
    "twilioRebillingActive": "Twilio-uudelleenlaskutus on aktiivinen",
    "iAcknowledgeThisIs": "Vahvistan, että tämä on kelvollinen alatili ja olen vahvistanut lähettämisen käyttötapauksen, jossa lähetetään enemmän kuin {limit} {type} päivässä.",
    "iAcknowledgeThisIs1": "Vahvistan, että tämä on kelvollinen alatili ja että olen varmistanut lähettämisen käyttötapauksen, joten olen säätänyt päivittäistä SMS-rajaa.",
    "emailSentByLocation": "Tänään lähetetyt sähköpostit sijainnin mukaan.",
    "goToSmsLimit": "Siirry tekstiviestien rajoitusasetuksiin",
    "toIncreaseTheLimit": "Jos haluat nostaa rajaa, ota yhteyttä tukeen.",
    "newLimitOfLimit": "Uusi raja {limit} on virheellinen. Anna arvo väliltä {min} ja {max}",
    "typeLimitUpdatedSuccessfully": "{type} -raja päivitetty onnistuneesti",
    "locationsCurrentLimitIs": "Sijainnin tämänhetkinen rajoitus on {current}. Voit päivittää rajan vain välillä {min} ja {max} tässä. Jos haluat päivittää rajaa yli {maxAllowed}:n, ota yhteyttä tukeen.",
    "notNow": "Ei nyt",
    "smsSentByLocation": "Tänään lähetetyt tekstiviestit sijainnin mukaan.",
    "youHaveSuccessfullyUpdated": "Olet päivittänyt rajan",
    "willAutoUnlockIn": "Aukeaa automaattisesti",
    "contactType": "Kontaktin tyyppi",
    "createdBy": "Luonut:",
    "createdOn": "Luotu:",
    "dateOfBirth": "Syntymäaika",
    "emailAddress": "Sähköpostiosoite",
    "firstName": "Etunimi",
    "lastName": "Sukunimi",
    "twilioLookupMarkedThis": "Twilio Lookup merkitsi tämän puhelinnumeron virheelliseksi.",
    "twilioLookupStatedThis": "Twilio Lookup ilmoitti, että kyseessä on {type} -numero, joten se ei vastaanota SMS-viestejä.",
    "accountSnapshot": "Tilin tilannevedos",
    "auditLogs": "Jäljityslokit",
    "account": "Tili",
    "selectAccount": "Valitse tili",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Teksti",
    "allTagsLinkedTo": "Kaikki valittuihin kontakteihin linkitetyt tagit on poistettava",
    "automation": "Automaatio",
    "bulkOperation": "Massatoiminto",
    "campaign1": "Kampanja",
    "created": "Luotu",
    "dateTime": "Päivämäärä ja kellonaika",
    "description1": "Kuvaus",
    "drip": "Drip",
    "edit": "Muokkaa",
    "someStatsAreNot": "Jotkin tilastot eivät ole saatavilla, jos palveluntarjoaja on SMTP. Tilastojen tarkkuus riippuu vastaanottajan verkkotunnuksesta.",
    "error": "Virhe",
    "from1": "Lähettäjä",
    "immediately": "Heti",
    "pause": "Keskeytä",
    "processed": "Käsitelty",
    "queued": "Jonossa",
    "restored": "Palautettu",
    "resume": "Jatka",
    "sent": "Lähetetty",
    "scheduled": "Ajoitettu",
    "success": "Onnistui",
    "templateName": "Mallipohjan nimi",
    "total1": "Yhteensä",
    "totalAttempted": "Yrityskerrat yhteensä",
    "user": "Käyttäjä",
    "viewDetails": "Näytä tiedot",
    "workflow": "Työnkulku",
    "company": "Yritys",
    "note": "Muistiinpano",
    "perPage": "per sivu",
    "showing": "Näytetään",
    "task": "Tehtävä",
    "tasks": "Tehtävät",
    "customFields": "Mukautetut kentät",
    "dueDate": "Määräpäivä",
    "tryNow": "Kokeile nyt!",
    "archive": "Arkistoi",
    "markAsRead": "Merkitse luetuksi",
    "markAsUnread": "Merkitse lukemattomaksi",
    "youNeedToAdd": "Sinun on lisättävä kalenteri, jotta voit aloittaa tapaamisten ajoittamisen.",
    "additionalNotes": "Lisätiedot",
    "appointmentStatus": "Tapaamisen tila",
    "appointmentTitle": "Tapaamisen otsikko",
    "contactName": "Kontaktin nimi",
    "contactTimezoneUsedFor": "Kontaktin aikavyöhyke (käytetään muistutusta varten)",
    "day": "Päivä",
    "editAppointment": "Muokkaa tapaamista",
    "nameRequired": "Nimi on pakollinen",
    "slotRequired": "Aikaväli on pakollinen",
    "teamMemberIsRequired": "Tiimin jäsen on pakollinen",
    "meetingLocation": "Tapaamispaikka",
    "pickTeamMember": "Valitse tiimin jäsen",
    "phoneNumbers": "Puhelinnumerot",
    "roundRobin": "Vuorottelujako",
    "selectCalendar": "Valitse kalenteri",
    "selectTeamMember": "Valitse tiimin jäsen",
    "actionRequired": "Toimia vaaditaan",
    "scheduleAppointment": "Ajoita tapaaminen",
    "considerLeavingItBlank": "Voit jättää tämän kohdan tyhjäksi, jos päätät käyttää ennalta määritettyä tapaamisen otsikkoa",
    "assignedTo": "Määritetty henkilölle",
    "download": "Lataa",
    "loadingTranscription": "Ladataan transkriptio...",
    "mute": "Mykistys",
    "playpause": "Toista/keskeytä",
    "playbackSpeed": "Toistonopeus",
    "remove": "Poista",
    "stop": "Pysäytä",
    "timePlayedTotalTime": "Toistoaika : Kokonaisaika",
    "viewTranscript": "Näytä transkriptio",
    "below": "alla",
    "calls1": "Puhelut",
    "liveChat": "Live-keskustelu",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chat-keskustelu on määritetty",
    "youAreChoosingNot": "Et ole valitsemassa LC-puhelimen alatilin poistamista ja sulkemista, mikä tarkoittaa, että sinua laskutetaan jatkossakin kaikesta käytöstä sijaintilaskutuksesta riippumatta.",
    "thingsAreJustGetting": "Asiat ovat vasta alussa, tutkitaan, miten GHL voi auttaa kasvattamaan liiketoimintaasi.\nSillä välin voit lähettää viestejä vapaasti",
    "wohooConversationsAreFlowing": "Hienoa! Keskustelut virtaavat nyt sujuvasti.",
    "conversationBegan": "Keskustelu alkoi.",
    "fetchOlderMessages": "Hae vanhoja viestejä",
    "inboundDndHasBeen": "Saapuvien DND on aktivoitu tälle kontaktille",
    "internalComment": "Sisäinen kommentti",
    "confirmByTyping": "Vahvista kirjoittamalla",
    "iConfirmToDisconnect": "Vahvistan, että haluan katkaista LC-puhelintilin yhteyden ja sulkea sen tässä sijainnissa. Tiedostan, että tämä tarkoittaa, että kaikki numerot ja A2P-kampanjat poistetaan eikä niitä voi palauttaa.",
    "iConfirmThatI": "Vahvistan, että olen keskustellut tästä asiakkaani kanssa ja minulla on valtuudet suorittaa tämä toiminto",
    "connect": "Yhdistä",
    "disputeThisReview": "Riitauta tämä arvostelu",
    "dndIsActiveFor": "DND on käytössä puheluita varten",
    "off": "POIS KÄYTÖSTÄ",
    "done": "Valmis",
    "downloadFile": "Lataa tiedosto",
    "AddAccount": "+ Lisää tili",
    "attachFile": "Liitä tiedosto",
    "clickHereToAdd": "Napsauta tästä lisätäksesi yhden.",
    "customerName": "Asiakkaan nimi",
    "customerPhone": "Asiakkaan puhelin",
    "orEnterAMessage": "Tai kirjoia viesti",
    "fromEmail": "Lähettäjän sähköposti",
    "fromName": "Lähettäjän nimi",
    "youDontHaveAny": "Sinulla ei ole vielä mallipohjia.",
    "requestPayment": "Pyydä maksua",
    "schedule": "Ajoita",
    "selectATemplate": "Valitse mallipohja",
    "sendNow": "Lähetä nyt",
    "smtpProvidersHasSome": "SMTP-palveluntarjoajilla on joitain rajoituksia. Napsauta tästä saadaksesi lisätietoja.",
    "subject": "Aihe",
    "useATemplateSnippet": "Käytä mallipohjaa (katkelma)",
    "deliveredtotalDelivered": "{delivered}/{total} lähetetty",
    "countMoreEmailsIn": "{count} lisää sähköposteja keskusteluketjussa",
    "primary": "(Ensisijainen)",
    "reply": "Vastaa",
    "respond": "Vastaa",
    "retry": "Yritä uudelleen",
    "to": "Vastaanottaja:",
    "fbCommentReplyDm": "FB-kommenttivastaus – yksityisviesti",
    "fbMessage": "FB-viesti",
    "theseAttachmentsMayNot": "Näitä liitetiedostoja ei ehkä enää tueta.",
    "urlCannotBeFound": "URL-osoitetta ei löydy",
    "activity": "Toiminta",
    "filters": "Suodattimet",
    "goToPost": "Siirry julkaisuun",
    "inboundCall": "Saapuva puhelu",
    "instagramDm": "Instagram DM",
    "internalChat": "Sisäinen keskustelu",
    "search2": "Haetaan...",
    "starred": "Tähdellä merkitty",
    "leftAVoicemail": "Jätti vastaajaviestin",
    "manual": "Manuaalinen",
    "mergeFields": "Yhdistä kentät",
    "addToDocuments": "Lisää asiakirjoihin",
    "failedToAddAttachments": "Liitteiden lisääminen asiakirjoihin epäonnistui",
    "attachmentsAddedToDocuments": "Liitteiden lisääminen asiakirjoihin onnistui",
    "newCommentOnPagename": "Uusi kommentti {pageName} -julkaisussa.",
    "outboundCall": "Lähtevä puhelu",
    "replyAsDm": "Vastaa DM:llä",
    "replyingAsAPrivate": "Yli seitsemän päivää vanhoihin kommentteihin ei voi vastata DM-viestillä.",
    "reportFeedbackForAi": "Anna AI-palautetta",
    "storyMention": "Tarinan maininta",
    "storyReply": "Vastaus tarinaan",
    "bulkRequest": "Massapyyntö",
    "eventsAreCurrentlyCaptured": "Vain kontaktin sähköpostiosoitteen tapahtumat tallennetaan tällä hetkellä.",
    "failed": "Hylätty",
    "gbpMessage": "GBP-viesti",
    "pageName": "Sivun nimi",
    "unknown": "Tuntematon",
    "typeAMessage": "Kirjoita viesti",
    "new": "Uusi",
    "newAppointmentBookedBy": "Uuden tapaamisen varannut",
    "customerNameRequired": "Asiakkaan nimi on pakollinen",
    "messageIsRequired": "Viesti on pakollinen",
    "pickATemplateTo": "Valitse mallipohja käytettäväksi.",
    "newMessage": "Uusi viesti",
    "newTask": "Uusi tehtävä",
    "toMakeACall": "Voit soittaa syöttämällä puhelinnumeron tähän kenttään.",
    "primary1": "Ensisijainen",
    "provider": "Palveluntarjoaja",
    "refresh": "Päivitä",
    "resetPassword": "Vaihda salasana",
    "thisReviewHasAlready": "Tämä arvostelu on jo julkaistu kohteessa {network}. Oletko varma, että haluat julkaista sen uudelleen?",
    "seeThisReviewOn": "Katso tämä arvostelu GBP:ssä",
    "reviewResponse": "Arvosteluvastaus",
    "searchUsers": "Hae käyttäjiä",
    "sendEmail": "Lähetä sähköpostiviesti",
    "sending": "Lähetetään...",
    "thisSubaccountHasPhonenumberco": "Tällä alatilillä on {phoneNumberCount} numero(a) ja {campaignsCount} A2P-kampanja(a). Kuluja aiheutuu tilin poistamisen jälkeenkin, ellet katkaise LC-puhelinjärjestelmätilin yhteyttä ja sulje sitä.",
    "thisSubaccountDoesNot": "Tällä alatilillä ei ole puhelinnumeroita eikä A2P-kampanjoita. Tilin keskeyttämisestä ei aiheudu kuluja, mutta suosittelemme, että katkaiset LC-puhelintilin yhteyden ja suljet sen.",
    "summary": "Yhteenveto",
    "unassigned": "Määrittämätön",
    "viewSubmission": "Näytä lähetys",
    "contactSupport": "Ota yhteyttä tukeen",
    "create": "Luo",
    "illDoThisLater": "Teen tämän myöhemmin",
    "enterBusinessName": "Anna yrityksen nimi",
    "firstNameOfThe": "Yrityksen omistajan etunimi",
    "mobileBusinessPhone": "Matkapuhelin / yrityspuhelin",
    "iDontHaveA": "Minulla ei ole sivustoa",
    "clientName": "Asiakkaan nimi",
    "letUsSetupYour": "Aloitetaan oman tilisi tai ensimmäisen asiakkaasi konfiguraatio.",
    "clientNameIsRequired": "Asiakkaan nimi on pakollinen",
    "pleaseEnterAValid": "Anna kelvollinen sähköpostiosoite",
    "emailAddressIsRequired": "Sähköpostiosoite on pakollinen",
    "firstNameIsRequired": "Etunimi on pakollinen",
    "lastNameIsRequired": "Sukunimi on pakollinen",
    "phoneNumberIsRequired": "Puhelinnumero on pakollinen",
    "copyOfName": "Kohteen {name}kopio",
    "goToDashboard": "Siirry raporttinäkymään",
    "permissionsNotEnabled": "Käyttöoikeuksia ei ole otettu käyttöön!",
    "createAndSellCustom": "Luo ja myy räätälöityjä tuotteita tilauspainatus ja suoratoimitus -palvelulla",
    "viewApp": "Näytä sovellus",
    "seamlessFulfillmentRealtimeShi": "Saumaton täyttö ja reaaliaikaiset lähetyshinnat verkkokaupoillesi",
    "learnMore": "Lue lisää",
    "activateFormMapping": "Käynnistä lomakekartoitus",
    "avatarName": "Avatar-nimi",
    "formFields": "Lomakekentät",
    "formName": "Lomake nimi",
    "mapFields": "Kartoittaa kentät",
    "update": "Päivitä",
    "pauseSubaccount": "Keskeytä alatili",
    "pausing": "Keskeytetään...",
    "subaccount": "alatili",
    "howItWorks": "Näin se toimii",
    "uponCompletingThisAction": "Kun toiminto on suoritettu, siirtopyyntö lähetetään vastaanottavalle toimistolle ({relNo}). Alatili siirretään heti, kun vastaanottaja on hyväksynyt sen. Huomaa, että tätä toimintoa ei voi kumota.",
    "ejectSubaccount": "Poista alatili",
    "newAgencyCreationMail": "Uuden toimiston luomista koskeva viesti on lähetetty valitulle käyttäjälle. Käyttäjä voi luoda uuden toimiston napsauttamalla sähköpostiviestissä olevaa linkkiä.",
    "unableToTransferSubaccount": "Alatiliä ei voi ladata tälle toimistolle.",
    "nominateAccountOwnerFor": "Nimeä uuden tilin omistaja",
    "pleaseConfirmOwnershipWill": "Vahvista, että omistusoikeus siirretään",
    "scheduledDate": "Aikataulun mukainen päivämäärä",
    "thisDateIsBased": "Tämä päivämäärä perustuu yrityksen aikavyöhykkeeseen, joka on {timezone}",
    "campaignName": "Kampanjan nimi",
    "copyCampaign": "Kopioi kampanja",
    "endTime": "Päättymisaika",
    "event10xEmail4": "Tapahtuma: 10X sähköposti 4 (listauksen toimitus) ",
    "10xEmail1Reviews": "10X sähköposti 1 (arvostelut)",
    "fromAddress": "Lähettäjän osoite",
    "leadValue": "Liidin arvo",
    "option1": "Vaihtoehto 1",
    "option2": "Vaihtoehto 2",
    "option3": "Vaihtoehto 3",
    "preview": "Esikatselu",
    "selectCampaign": "Valitse kampanja",
    "startTime": "Aloitusaika",
    "time": "Aika",
    "users": "Käyttäjät",
    "noRecordsFound": "Tietueita ei löytynyt",
    "pageDetail": "Sivun tiedot",
    "selectAll": "Valitse kaikki",
    "submission": "Vastauslähetys",
    "addProduct": "Lisää tuote",
    "visitors": "vierailijat",
    "By": " tekijä",
    "conversions": "Konversioaste ",
    "liveReviews": "Live-arvostelut",
    "liveVisitors": "Reaaliaikaiset kävijät",
    "pageVisits": "Sivuvierailut",
    "stream": "Virtaus",
    "addOneOrMore": "Lisää yksi tai useampi sivun URL-osoite tai kopioi ne suoraan selaimestasi.",
    "WeWillAutomatically": " Seuraamme automaattisesti verkkosivustosi kävijöitä reaaliajassa. ",
    "connectYourLocationsFacebook": "Yhdistä sijaintisi Facebook-tili",
    "connected": "Yhdistetty!",
    "Contains": " sisältää ",
    "expression": "Lauseke",
    "facebookAccount": "Facebook-tili",
    "wowYouDontNeed": "Vau! Sinun ei tarvitse määrittää mitään tässä, voit siirtyä eteenpäin.",
    "Regex": " regex ",
    "selectUrlMatchType": "Valitse URL-vastaavuuden tyyppi",
    "Simple": " yksinkertainen ",
    "LivePreview": " Reaaliaikainen esikatselu",
    "seconds": "sekuntia",
    "launch": "Käynnistä ",
    "decorativeVector1": "Koristevektori 1",
    "showingFromToTo": "Näytetään {from} – {to} / {total} merkinnästä",
    "cloneProduct": "Kloonaa tuote",
    "connectFacebookInstagram": "Yhdistä Facebook ja Instagram",
    "connectPage": "Yhdistä sivu!",
    "everythingIn": "Kaikki kohteessa",
    "agentChat25": "Asiakaspalvelijan chat-keskustelu (odotusaika ~2–5 min)",
    "aiSupportChat": "Tekoälytuen chat",
    "startChat": "Aloita chat-keskustelu",
    "locations1": "sijainnit",
    "phone1": "puhelin",
    "slack": "Slack",
    "segments1": "segmentit",
    "areYouSureYou": "Haluatko varmasti poistaa tämän kansion?",
    "verified": "Vahvistettu",
    "highlevelPrice": "HighLevel-hinta",
    "howDoesItWork": "Miten se toimii?",
    "payNow": "Maksa heti",
    "priceMustBeMore": "Hinnan on oltava vähintään yhtä suuri kuin HighLevel-hinnan",
    "saving2": "Tallennetaan",
    "yourPrice": "Sinun hintasi",
    "yourProfit": "Sinun tuottosi",
    "youNeedToComplete": "Sinun täytyy suorittaa loppuun muutama helppo vaatimustenmukaisuusvaihe, jotta voit poistaa SaaS-tilan käytöstä tässä sijainnissa.",
    "youAreNotAuthorized": "Sinulla ei ole valtuuksia suorittaa tätä toimintoa. Vain toimiston ylläpitäjät voivat suorittaa sen.",
    "disableSaasModeFor": "Poista SaaS-tila käytöstä kohteelle {name}",
    "companyBilling": "Yrityksen laskutus",
    "bccEmailsCommaDelimited": "BCC-sähköpostit (pilkuin eroteltuina)",
    "unableToDeleteMailgun": "Mailgun-tilin poistaminen epäonnistui. Ota yhteyttä tukeen.",
    "forwardingAddress": "Edelleenlähetysosoite",
    "forwardingAddressesCommaDelimi": "Edelleenlähetysosoitteet (pilkuin eroteltuina)",
    "amount": "Määrä",
    "billingDate": "Laskutuspäivämäärä",
    "debugWalletTransactionsTotal": "DEBUG-lompakon transaktiot, yhteensä: {count}",
    "detailedTransactions": "Yksityiskohtaiset transaktiot",
    "transactionsOnlyAfter26th": "Vain 26.4.2022 jälkeen tehdyt transaktiot on lueteltu ja saatavilla vientiä varten",
    "someRecordsMayTake": "Joidenkin tietueiden päivittyminen täällä voi kestää 24 tuntia.",
    "totalBalance": "Saldo yhteensä",
    "walletTransactions": "Lompakon transaktiot",
    "walletTransactionsAllDate": "Lompakon transaktiot – Kaikki – {date}",
    "enterMessage": "Kirjoita viesti",
    "applyThisChangeTo": "Käytä tätä muutosta kaikilla alatileillä.",
    "characters": "Merkit",
    "iConfirmThatI1": "Vahvistan, että olen keskustellut tästä asiakkaani kanssa ja että minulla on hänen suostumuksensa.",
    "iConfirmThatI2": "Vahvistan, että varmistan kaikkien tältä tililtä lähetettävien SMS-viestien olevan tämänhetkisten säännösten mukaisia.",
    "theContentsOfThis": "Tämän viestin sisältö lisätään automaattisesti ensimmäiseen SMS-viestiin, joka lähetetään massaviestien kautta.",
    "iConfirmThatSms": "Vahvistan, että SMS-viestejä lähetetään vain niille kontakteille, jotka ovat antaneet suostumuksensa SMS-viestien vastaanottamiseen.",
    "quickTip": "Pikavinkki",
    "messageWillBeAppended": "Viesti liitetään ensimmäiseen tekstiviestiin keskustelussa, jos se ei sisällä kieltäytymissanoja",
    "readMore": "Lue lisää",
    "noncompliantActivityMayLead": "Vaatimusten vastainen toiminta voi johtaa tilin SMS- ja ääniominaisuuksien keskeyttämiseen.",
    "typeConfirmBelowTo": "Jatka kirjoittamalla Vahvista alle",
    "products": "Tuotteet",
    "chooseCountry": "Valitse maa...",
    "email2": "Sähköposti*",
    "firstName1": "Etunimi*",
    "lastName1": "Sukunimi*",
    "brandDetails": "Bränditaulutiedot",
    "brandName": "Brändin nimi*",
    "useEitherLegalName": "Käytä joko viestejä lähettävän organisaation virallista nimeä tai omaa nimeäsi, jos tämä brändi ei ole organisaatiolle.",
    "businessIndustry": "Liiketoiminta-ala*",
    "chooseVertical": "Valitse pystysuuntainen...",
    "mobileNumberForOtp": "Matkapuhelinnumero OTP-varmennukseen (maakoodilla)*",
    "pleaseProvideAMobile": "Anna matkapuhelinnumero, johon sinulla on pääsy, jotta voit vahvistaa OTP-todennuksen. Vain yhdysvaltalaiset / kanadalaiset numerot hyväksytään. Et saa käyttää CPaaS-puhelinnumeroa, kuten LeadConnectorista hankittua numeroa. Et voi käyttää samaa matkapuhelinnumeroa rekisteröidäksesi yli kolmea yksityisyrittäjän tuotemerkkiä. Tätä rajaa hallinnoidaan TCR-tasolla.",
    "increasedDeliveryRate": "Lisääntynyt toimitusprosentti",
    "sendUpto3000Segments": "Voit lähettää jopa 3 000 segmenttiä päivässä",
    "businessDetails": "Yrityksen tiedot",
    "thereWasSomeIssue": "Profiilin lähettämisessä ilmeni ongelma.",
    "yourProfileSubmissionFailed": "Profiilisi lähettäminen epäonnistui.",
    "endUserConsent": "Loppukäyttäjän hyväksyntä",
    "minLength40Characters": "Minimipituus: 40 merkkiä. Enimmäispituus: 2 048 merkkiä.",
    "closeExamples": "Sulje esimerkit",
    "sampleMessage1": "Malliviesti nro 1*",
    "seeExamples": "Katso esimerkkejä",
    "enterCampaignDetails": "Anna kampanjan yksityiskohdat",
    "youWillReceiveAn": "Saat OTP-viestin antamaasi matkapuhelinnumeroon vahvistusta varten TCR:ltä. Vastaa Kyllä 24 tunnin kuluessa tekstiviestin vastaanottamisesta.",
    "brandNameIsRequired": "Brändin nimi on pakollinen.",
    "businessVerticalIsRequired": "Toimiala on pakollinen.",
    "mobileNumberIsRequired": "Matkapuhelinnumero on pakollinen.",
    "hideDetail": "Piilota tiedot",
    "showDetail": "Näytä tiedot",
    "people": "ihmisiä",
    "person": "yksilö",
    "after": "seuraavan jälkeen:",
    "before": "ennen",
    "hour": "tunti",
    "hours": "tuntia",
    "minute": "minuutti",
    "minutes": "minuuttia",
    "triggerLinksEmbeddedIn": "Triggerilinkkien (viestiin upotettu) napsautusprosentti lähetetyistä viesteistä",
    "addNewEvent": "Lisää uusi tapahtuma",
    "addTask": "Lisää tehtävä",
    "manualCall": "Manuaalinen puhelu",
    "manualSms": "Manuaalinen tekstiviesti",
    "messenger": "Messenger",
    "wait": "Odota",
    "webhook": "Webhook",
    "about": "Tietoa",
    "accessRestricted": "Pääsyä rajoitettu",
    "addPartner": "Lisää kumppani",
    "addPartnerForm": "Lisätä kumppanilomake",
    "affiliatePortal": "Kumppaniportaali",
    "badges": "Merkit",
    "aBriefBio": "Lyhyt bio",
    "dashboard": "Raporttinäkymä",
    "experience": "Kokemus",
    "industryServed": "Palveltu toimiala",
    "instagramAccount": "Instagram-tilit",
    "invoiceHistory": "Laskutushistoria",
    "englishGermanHindi": "Englanti, saksa, hindi",
    "linkToWebsite": "linkki verkkosivustolle",
    "linkedinAccount": "LinkedIn-tili",
    "locationId": "Sijaintitunnus",
    "partnerName": "Kumppanin nimi",
    "partnerStatus": "Kumppanin tila",
    "paymentDetails": "Maksutiedot",
    "paymentHistory": "Maksuhistoria",
    "profilePhoto": "Profiilikuva",
    "profilePhotoUrl": "profiilikuvan URL-osoite",
    "promoterReports": "Mainostajan raportit",
    "searchPartner": "Hakukumppani",
    "twitterAccount": "Twitter-tili",
    "updatePartner": "Päivitä kumppani",
    "updatePartnerForm": "Päivitä kumppanilomake",
    "yearOfExperience": "vuoden kokemus",
    "youtubeAccount": "YouTube-tili",
    "serviceProvided": "Tarjottu palvelu",
    "controlTheSubaccountSettings": "Alatilin asetusten hallinta",
    "generalInfo": "Yleistä tietoa",
    "okay": "Okei",
    "proceed": "Jatka",
    "addCard": "Lisää kortti",
    "makeThisCardPrimary": "Aseta tämä kortti ensisijaiseksi",
    "nameOnCard": "Kortissa oleva nimi",
    "chargedToCustomer": "Veloitettu asiakkaalta",
    "clientBillingPage": "Asiakaslaskutussivu",
    "companyStripeIntegrationPage": "Yrityksen Stripe-integrointisivu",
    "enableRebilling": "Ota uudelleenlaskutus käyttöön",
    "enabling": "Otetaan käyttöön...",
    "forMoreDetails": "lisätietoja.",
    "youreOnTheFreelancer": "Sinulla on Freelancer-sopimus, joka rajoittaa sinut 1,05-kertaiseen lisäykseen.",
    "minimumAmountShouldBe": "Minimimäärän tulee olla välillä ${min} ja ${max}",
    "beforeEnablingThisFeature1": "Ennen kuin otat tämän ominaisuuden käyttöön, yhdistä Stripe-tilisi",
    "planToSetYour": "suunnitelmaan, jotta voit asettaa marginaalisi korkeammiksi.",
    "rebillAmount": "Uudelleenlaskutussumma",
    "supportDoc": "tukiasiakirja",
    "10WillGiveYou": "10 $:lla saat noin",
    "minimumMustBeBetween": "Minimiarvon on oltava välillä 0,0001–0,005",
    "sorryYouCannotRebillAtTheMarkup": "Pahoittelut! Et voi laskuttaa uudelleen Freelancer-suunnitelman marginaalilla.",
    "modifyingTheseSettingsWillChange": "Näiden asetusten muuttaminen muuttaa asiakkaillesi jatkossa koituvia kustannuksia.",
    "pleaseDoNotModifyThese": "Älä muuta näitä asetuksia, jos et ole varma muutoksen vaikutuksista.",
    "theseSettingsWillApply": "Nämä asetukset koskevat jatkossa uusia asiakkaitasi",
    "congratulationsYourDedicatedIp": "Onnittelut! Omistettu IP-jälleenmyyntiarvosi on tallennettu onnistuneesti.",
    "youHaveAgreedToProvide": "Olette suostuneet tarjoamaan dedikoituja IP-osoitteita suoraan alatilille. Virasto kattaa kulut alatilin puolesta.",
    "youHaveDiscontinuedToProvide": "Olet lopettaneet dedikoitujen IP-osoitteiden tarjoamisen suoraan alatilille. Toimisto ei enää maksa alatilin puolesta aiheutuneita kuluja.",
    "oopsSomethingWentWrongAndWeCouldnt": "Hups! Jokin meni pieleen, emme voineet tallentaa erillisen IP-osoitteen jälleenmyyntiasetuksianne. Yritä myöhemmin uudelleen.",
    "pleaseAgreeToTheTerms": "Hyväksy ehdot",
    "errorWhileFetchingDomains": "Virhe verkkotunnusten noutamisessa",
    "sameStripeCustomerProfileCantBeMapped": "Samaa Stripe-asiakasprofiilia ei voi liittää useampaan kuin yhteen alatiliin.",
    "pleasePickADifferentStripeCustomer": "Valitse toinen Stripe-asiakasprofiili tai käytä \"Jaa linkki\" -vaihtoehtoa, jotta voimme luoda uuden Stripe-asiakasprofiilin tälle alatilille.",
    "clickNextToChooseAPlan": "Valitse tilaus ja luo uusi tilaus napsauttamalla Seuraava.",
    "youDontHaveAnyActiveSubscriptions": "Sinulla ei ole aktiivisia tilauksia",
    "youCanEitherSelectAnExistingSubscription": "Voit joko valita olemassa olevan tilauksen tai luoda uuden tilauksen seuraavassa vaiheessa.",
    "useCommasToSeparateMultipleEmails": "Erota useat sähköpostiosoitteet pilkuilla.",
    "useCommasToSeparateMultiplePhoneNumbers": "Käytä pilkkuja erottamaan useita puhelinnumeroita.",
    "noUserFoundInThisLocation": "Käyttäjää ei löytynyt tästä sijainnista",
    "noPhoneNumberAttached": "Puhelinnumeroa ei ole liitetty",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Liitä maksutapasi alla olevan linkin kautta.",
    "allowDuplicateContact": "Salli päällekkäiset kontaktit",
    "allowDuplicateOpportunity": "Salli päällekkäiset mahdollisuudet",
    "mergeFacebookContactsByName": "Yhdistä Facebook-kontaktit nimen mukaan",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Vain Facebookista tulevat viestit yhdistetään, jos ne vastaavat olemassa olevan kontaktin nimeä. Nimissä huomioidaan kirjainkoot.",
    "disableContactTimezone": "Poista kontaktien aikavyöhyke käytöstä",
    "markEmailsAsInvalidDueToHardBounce": "Merkitse sähköpostit virheellisiksi kovan palautuksen vuoksi",
    "contactsEmailsWillBeMarkedAsInvalid": "Kontaktin sähköpostit merkitään automaattisesti virheellisiksi, kun ne palautuvat kovasti. Automaatioiden sähköpostitoiminnot ohitetaan sellaisten kontaktien kohdalla, joilla on virheelliset sähköpostiosoitteet.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Kerää tietoa tuntemattomista puhelinnumeroista",
    "makeSmsCompliantByAddingAnOptOutMessage": "Tee SMS-viestistä vaatimustenmukainen lisäämällä kieltäytymisviesti.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Aktivoinnin jälkeen kieltäytymisviesti lisätään automaattisesti ensimmäiseen SMS-viestiin, joka lähetetään massaviestien kautta. Näin varmistetaan vaatimustenmukaisuus ja toimitusaste paranee.",
    "platformLanguage": "Alustan kieli",
    "outboundCommunicationLanguageForCustomValues": "Lähtevän viestinnän kieli mukautettuja arvoja varten",
    "updateInformation": "Päivitä tiedot",
    "upgradeToTheAgency": "Päivitä Agency Pro",
    "yourCost": "Oma kustannus",
    "addACalendarTo": "Lisää kalenteri aloittaaksesi tapaamisten varaamisen.",
    "addselectAContactTo": "Lisää/valitse kontakti tapaamisten aikatauluttamista varten",
    "appointmentSlotIsNot": "Tapaamisen aikaväliä ei ole vielä valittu",
    "loading1": "Ladataan...",
    "teamMemberIsRequired1": "Tiimin jäsen on pakollinen",
    "currentPlan": "Nykyinen suunnitelma",
    "features1": "Ominaisuudet",
    "upgrade": "Päivittää; korottaa tasoa",
    "viewLess": "Näytä vähemmän",
    "viewMoreCount": "Näytä lisää (+{count})",
    "cardNumber": "Kortin numero",
    "expiryDate": "Päättymispäivä",
    "paymentMethods": "Maksutavat",
    "primaryCard": "Ensisijainen kortti",
    "removeCurrentCard": "Poista nykyinen kortti",
    "AddBalance": "+ Lisää saldoa",
    "complimentaryCredits": "Ilmaiset krediitit:",
    "expiringOnDate": "Vanhenee {date}",
    "apiVersion": "API-versio",
    "application": "Sovellus",
    "ipAddress": "IP-osoite",
    "related": "Liittyvät",
    "request": "Pyydä",
    "yourAccountIncludingAll": "Tilisi, mukaan lukien kaikki lähtevät toiminnot, kuten ajoitetut viestit ja sähköpostit, keskeytetään välittömästi.",
    "yourAccountIncludingAll1": "Tilisi, mukaan lukien kaikki lähtevät toiminnot, kuten ajoitetut viestit ja sähköpostit, keskeytetään välittömästi.",
    "nextBillingDateDate": "Seuraava laskutuspäivämäärä: {date}",
    "scheduledForCancellation": "Peruutus on ajoitettu",
    "abandoned": "Hylätty",
    "add1": "Lisää",
    "addOpportunity": "Lisää mahdollisuus –",
    "addOpportunityName": "Lisää mahdollisuuden nimi",
    "Task": "+ Tehtävä",
    "bookupdateAppointment": "Varaa/päivitä tapaaminen",
    "companyName": "Yrityksen nimi",
    "areYouSureYou1": "Haluatko varmasti poistaa tämän mahdollisuuden?",
    "contactInfo": "Yhteystiedot",
    "editOpportunity": "Muokkaa mahdollisuutta --",
    "enterValue": "Anna arvo",
    "goToContactDetail": "Siirry kontaktitietosivulle",
    "leads": "Liidit",
    "lost": "Menetetty",
    "nameIsRequired": "Nimi on pakollinen.",
    "youreNotAllowedTo": "Et saa muuttaa asiakkaan nimeä! Tarkista käyttöoikeutesi toimiston ylläpitäjältä.",
    "open": "Avaa",
    "opportunity": "Mahdollisuus",
    "opportunityAlreadyExistsIn": "Mahdollisuus on jo olemassa tässä prosessissa",
    "opportunityInfo": "Mahdollisuuden tiedot",
    "opportunityName": "Mahdollisuuden nimi",
    "opportunitySource": "Mahdollisuuden lähde",
    "owner": "Omistaja",
    "pipeline": "Prosessi",
    "removeOwner": "Poista omistaja",
    "selectPipeline": "Valitse prosessi",
    "selectStage": "Valitse vaihe",
    "stage": "Vaihe",
    "countTasks": "{count} tehtävää",
    "won": "Toteutunut",
    "and": "ja ",
    "addASubscription": "Lisää tilaus",
    "noSaasPlanEnabled": "Ei SaaS-aikataulua käytössä",
    "per": "per",
    "assignTo": "Määritetty henkilölle",
    "assignedTo1": "Määritetty kohteelle:",
    "areYouSureYou2": "Haluatko varmasti poistaa tämän tehtävän?",
    "due": "Eräpäivä:",
    "dueDateIsRequired": "Määräpäivä on pakollinen",
    "dueIn": "Eräpäivään on",
    "dueToday": "Erääntyy tänään",
    "late": "Myöhässä",
    "notAssigned": "Ei määritetty",
    "taskDescription": "Tehtävän kuvaus",
    "taskTitle": "Tehtävän nimi",
    "annually": "vuosittain",
    "attachments": "Liitteet",
    "areYouSureYou3": "Haluatko varmasti poistaa tämän massapyynnön?",
    "startImmediately": "Aloita heti",
    "customers": "Asiakkaat",
    "tag": "Tagi",
    "pickType": "Valitse tyyppi",
    "whoShouldItRun": "Kenelle se pitäisi suorittaa?",
    "addBulkRequest": "Lisää massapyyntö",
    "editBulkRequest": "Muokkaa massapyyntöjä",
    "scheduledDateIsRequired": "Ajoituspäivämäärä on pakollinen",
    "newCampaignName": "Uusi kampanjan nimi",
    "areYouSureYou4": "Haluatko varmasti poistaa tämän kampanjan?",
    "moveToFolder": "Siirrä kansioon",
    "pleaseRename": "nimeä uudelleen",
    "removeFromFolder": "Poista kansiosta",
    "photoPreview": "valokuvan esikatselu",
    "pleaseWait": "Odota...",
    "customValues": "Mukautetut arvot",
    "whatActionShouldWe": "Mitä toimia meidän tulisi suorittaa?",
    "entitynameName": "{entityName}: nimi",
    "useLcEmail": "Käytä LC Emailia",
    "21Jun2018": "21. kesäkuuta 2018",
    "930Am": "klo 9.30",
    "Via": " kautta ",
    "createdTrackingNumbers": "Luodut seurantanumerot",
    "iUnderstandImBuyingadding": "Ymmärrän, että olen ostamassa/lisäämässä {count} uutta puhelinnumeroa.",
    "forwardCallsTo": "Siirrä puhelut",
    "numberName": "Numeron nimi",
    "numberPoolName": "Numeroryhmän nimi",
    "numberToSwap": "Vaihdettava numero",
    "sameAsForwardingNumber": "Sama kuin edelleenlähetysnumero",
    "callFromSource": "Puhelu kohteesta [Source].",
    "callRecording": "Puhelutallennus",
    "84Complete": "84 % valmis",
    "thisCallWillBe": "Tämä puhelu nauhoitetaan laadunvarmistusta varten.",
    "whisperMessage": "Kuiskausviesti",
    "allExceptDirect": "Kaikki paitsi suorat",
    "allExceptDirectOrganic": "Kaikki paitsi suora ja orgaaninen",
    "allSearch": "Kaikki haut",
    "allVisitorsRecommended": "Kaikki vierailijat (suositeltu)",
    "bing": "Bing",
    "direct": "Suora",
    "visitorsWithoutAReferring": "Vierailijat ilman viittaavaa sivustoa",
    "for": "–",
    "google": "Google",
    "landingPageOrUrl": "Aloitussivu tai URL-parametri",
    "organic": "Orgaaninen",
    "paid": "Maksettu",
    "pickOneYouCan": "Valitse yksi – voit aina muuttaa tätä myöhemmin.",
    "ppcSearch": "PPC-haku",
    "visitorsFromGoogleBing": "Kävijät Googlen, Bingin ja Yahoon PPC-hauista",
    "referringPage": "Viittaava sivu",
    "visitorsFrom": "Vierailijat kohteesta",
    "visitorsFromGoogleAds": "Google Mainokset -kävijät",
    "visitorsWhoAreReferred": "Vierailijat, jotka on ohjattu",
    "visitorsWhoLandOn": "Vierailijat, jotka saapuvat sivustolle",
    "whichVisitorsDoYou": "Keitä kävijöitä haluat seurata?",
    "yahoo": "Yahoo",
    "17Complete": "17 % valmis",
    "callTimeoutS": "Puhelun aikakatkaisu (s)",
    "callWhisper": "Soita kuiskauspuhelu",
    "disableVoicemailDetect": "Poista vastaajan tunnistus käytöstä",
    "eventName": "Tapahtuman nimi",
    "timeoutSeconds": "Aikakatkaisu (sekunnit)",
    "editCall": "Muokkaa puhelua",
    "callWillPatchInstantly": "Puhelu yhdistetään välittömästi, emme kuuntele, onko puheluun vastattu liidin puolella. Tämä tarkoittaa, että kampanja merkitään vastatuksi, vaikka vastaaja poimisi puhelun.",
    "thisIsTheMessage": "Tämä on viesti, jonka haluat puhelimeen vastaavan henkilön kuulevan. Voit mukauttaa tätä mukautetuilla muuttujilla.",
    "pleaseCheckTheLinks": "Tarkista linkit, joissa on mukautettu arvo. {{ ja mukautettujen_arvojen välissä on ylimääräinen '%20'.",
    "anErrorOcurredPlease": "Tapahtui virhe, yritä uudelleen.",
    "pleaseInsertATo": "Anna vastaanottajan osoite.",
    "pickEmailTemplate": "Valitse sähköpostimallipohja",
    "sendTest": "Lähetä testi",
    "composeEmail": "Kirjoita sähköposti",
    "composeEmailTemplate": "Laadi sähköpostimallipohja",
    "toAddress": "Käsittelemään",
    "addFileThroughUrl": "Lisää tiedosto URL-osoitteen kautta",
    "appCharacters": "Sovelluksen merkit:",
    "approximateCost": "Arvioitu kustannus:",
    "estimatedCostForUs": "Arvioitu veloitus vain Yhdysvalloista Yhdysvaltoihin lähetettäville tekstiviesteille.",
    "mobilePhoneNumber": "Matkapuhelinnumero",
    "numSegments": "Segmenttien määrä",
    "pickMessageTemplate": "Valitse viestin mallipohja",
    "pleaseProvideAPhone": "Anna puhelinnumero, johon testi lähetetään.",
    "composeEventtype": "Laadi {eventType}",
    "composeEventtypeTextTemplate": "Laadi {eventType} -tekstimallipohja",
    "unsupportedSmsContentType": "Ei-tuettu SMS-sisältötyyppi {fileType}",
    "countOfTheProvided": "{count} annetuista URL-liitteistä {plural} ei ole kuva. Tämä voi aiheuttaa virheitä Twiliossa. Haluatko tallentaa joka tapauksessa?",
    "dropFileHereOr": "Pudota tiedosto tähän tai lataa palvelimeen napsauttamalla",
    "ifYouHaveAdditional": "Jos sinulla on lisäkysymyksiä, katso vastaajaviestien lähetyksen UKK ohjeosiossa.",
    "editVoicemail": "Muokkaa vastaajaviestiä",
    "selectAMp3Or": "Valitse mp3- tai wav-tiedosto. Emme tue muita muotoja.",
    "voicemailFile": "Vastaajatiedosto",
    "warningVoicemailDropsAre": "Varoitus: Vastaajaviestien lähetykset ovat paras mahdollinen järjestelmä ja toimivat noin 70 % ajasta.",
    "youNeedToPick": "Sinun on valittava vähintään yksi päivä",
    "editWait": "Muokkaa odotusta",
    "url": "URL",
    "customTime": "Mukautettu aika",
    "executeThisActionIf": "Suorita tämä toiminto, jos nykyinen aika osuu tähän ikkunaan. Jos nykyinen kellonaika on tämän ikkunan ulkopuolella, ohita tämä vaihe ja siirry seuraavaan toimintoon.",
    "pickDays": "Valitse päivät",
    "pickTime": "Valitse aika",
    "noRecordsFound1": "Tietueita ei löytynyt.",
    "formAnalyze": "Lomakkeen analysointi",
    "totalSubmission": "Lähetys yhteensä",
    "forgotPassword": "Unohtuiko salasana?",
    "orContinueWith": "Tai jatka kohteella",
    "signIn": "Kirjaudu sisään",
    "signIntoYourAccount": "Kirjaudu tilillesi",
    "thePasswordYouPicked": "Valitsemasi salasana",
    "yourEmailAddress": "Sähköpostiosoitteesi",
    "newEmailFrom": "Uusi sähköposti lähettäjältä",
    "newMessageFrom": "Uusi viesti lähettäjältä",
    "hasLeftANew": "on jättänyt uuden arvostelun.",
    "repliedToTheReview": "vastasi arvosteluun.",
    "loaded": "Ladattu",
    "snapshot": "Tilannevedos",
    "appointment": "Tapaaminen",
    "appointmentDueInMinutes": "Tapaaminen {minutes} minuutin kuluttua henkilölle {contactName}",
    "appointmentReminder": "Tapaamisen muistutus",
    "completedCount": "Tehty: {count}",
    "conversation": "Keskustelu",
    "facebookReview": "Facebook-arvostelu",
    "failedCount": "Epäonnistunut: {count}",
    "googleReview": "Google-arvostelu",
    "internalChatMessage": "Sisäinen keskustelu -viesti",
    "usernameMentionedYouIn": "{userName} mainitsi sinut keskustelussa, jossa on mukana {contactName}",
    "newAppointmentAssigned": "Uusi tapaaminen on määritetty",
    "aNewAppointmentWith": "Sinulle on osoitettu uusi tapaaminen henkilön {contactName} kanssa.",
    "newAppointmentBooked": "Uusi tapaaminen on varattu",
    "youHaveNewAppointment": "Sinulla on uusi tapaaminen varattuna henkilön {contactName}kanssa",
    "newCall": "Uusi puhelu",
    "aNewChatWith": "Uusi keskustelu henkilön {contactName} kanssa on osoitettu sinulle.",
    "newEmail": "Uusi sähköpostiosoite",
    "newMention": "Uusi maininta",
    "newReviewReceivedFrom": "Uusi arvostelu saatu henkilöltä {contactName}",
    "aNewTypeIs": "Uusi {type} on vastaanotettu henkilöltä {contactName}",
    "notification": {
      "noRecentActivity": "Ei viimeaikaista aktiivisuutta."
    },
    "subAccount": "Alatili",
    "subaccount1": "Alitili:",
    "titleOnDateAt": "{title} {date} kello {time} henkilölle {contactName}",
    "titleDueInDuetime": "{title} erääntyy {dueTime} {unitOfTime} mennessä henkilölle {contactName}",
    "taskReminder": "Tehtävämuistutus",
    "youHaveCountTasks": "Sinulla on {count} tänään erääntyvää tehtävää",
    "youHaveCountTasks1": "Sinulla on {count} toistaiseksi myöhässä olevaa tehtävää",
    "droppedVoicemailTo": "Jätetty vastaajaviesti kohteeseen",
    "errorWhileCloningProduct": "Virhe tuotteen kloonauksessa!",
    "productName": "Tuotteen nimi",
    "selectLocations": "Valitse sijainnit",
    "selectUptoMaxselectablelocatio": "Valitse enintään {maxSelectableLocations} sijaintia",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} lisää",
    "emails": "Sähköpostit",
    "accountNotification": "Tilin ilmoitus",
    "customerCare": "Asiakaspalvelu",
    "deliveryNotification": "Toimitusilmoitus",
    "fraudAlertMessaging": "Petosvaroitusviesti",
    "higherEducation": "Korkeakoulutus",
    "lowVolumeMixedRecommended": "Vähäinen määrä hybridi (suositeltu)",
    "mixed": "Hybridi",
    "pollingAndVoting": "Kyselyt ja äänestykset",
    "publicServiceAnnouncement": "Julkinen tiedote",
    "securityAlert": "Turvallisuushälytys",
    "mixedRecommended": "Hybridi (Suositeltu)",
    "australiaCompanyNumberFrom": "Australia: yritysnumero – ASIC:ltä (ACN)",
    "canadaCanadianBusinessNumber": "Kanada: kanadalainen yritystunnus (CBN)",
    "indiaCorporateIdentityNumber": "Intia: yritystunnusnumero",
    "greatBritainCompanyNumber": "Iso-Britannia: yritystunnus",
    "usaEmployerIdentificationNumbe": "USA: Työnantajan tunnistenumero (EIN)",
    "other": "Muu",
    "israelRegistrationNumber": "Israel: Rekisteröintinumero",
    "estoniaVatNumber": "Viro: ALV-tunnus",
    "cooperative": "Osuuskunta",
    "corporation": "Yritys",
    "limitedLiabilityCompanyOr": "Osakeyhtiö vai toiminimi",
    "nonprofitCorporation": "Voittoa tavoittelematon yritys",
    "partnership": "Kumppanuus",
    "ceo": "Toimitusjohtaja",
    "cfo": "Talousjohtaja",
    "director": "Johtaja",
    "generalCounsel": "Lakiasiainjohtaja",
    "onlineTrainingEducation": "Online-kurssit ja koulutus",
    "financialServices": "Rahoituspalvelut",
    "fitnessLifestyle": "Kunto & elämäntyyli",
    "healthMedical": "Terveys ja lääketiede",
    "homeServices": "Kotipalvelut",
    "legalServices": "Lakipalvelut",
    "marketingAdvertising": "Markkinointi ja mainonta",
    "others": "Muut",
    "realEstate": "Kiinteistöala",
    "restaurants": "Ravintolat",
    "retailEcommerce": "Vähittäismyynti ja verkkokauppa",
    "yourInformationHasBeen": "Tietosi on lähetetty onnistuneesti.",
    "somethingWentWrong1": "Jokin meni pieleen",
    "newPassword": "Uusi salasana",
    "proceedToLogin": "Siirry kirjautumiseen",
    "anyTime": "milloin tahansa.",
    "callUsHighlevelSupport": "Soita meille HighLevel-tukeen numeroon",
    "troubleLoggingIn": "Ongelmia sisäänkirjautumisessa?",
    "sendSecurityCode": "Lähetä vahvistuskoodi",
    "sendCodeToEmail": "Lähetä koodi sähköpostiin",
    "verifySecurityCode": "Vahvista vahvistuskoodi",
    "privacyPolicy": "Tietosuojaseloste",
    "businessProfile": "Yritysprofiili",
    "reserveWithGoogleIntegration": "Varata Google-integroinnilla",
    "friendlyName": "Kutsumanimi",
    "updateCallerId": "Päivitä soittajan tunnistetieto",
    "internationalFormat": "Kansainvälinen muoto",
    "localFormat": "Paikallinen muoto",
    "poolNumbers": "Ryhmänumerot",
    "swappingNumbers": "Numeroiden vaihto",
    "selectField": "Valitse kenttä",
    "surveyAnalyze": "Kyselyn analysointi",
    "locationIsRequired": "Sijainti on pakollinen.",
    "newSurveyName": "Uusi kyselyn nimi",
    "copySurvey": "Kopioi kysely",
    "primaryCalendar": "Ensisijainen kalenteri",
    "cloneEntityname": "Kloonaa {entityName}",
    "youHaveSuccessfullySubmitted": "Olet lähettänyt tiedostot onnistuneesti",
    "addCustomValue": "Lisää mukautettu arvo",
    "value": "Arvo",
    "youHaveSuccessfullyDeleted": "Olet poistanut paketin onnistuneesti.",
    "bundleDeletedSuccessfully": "Paketti poistettu onnistuneesti",
    "thereIsAnIssue": "Yhdessä tukiasiakirjassasi on ongelma. Tarkista tukiasiakirjat ja niiden hylkäysperusteet.",
    "connect1": "Muodosta yhteys!",
    "itSeemsEitherThe": "Vaikuttaa siltä, että joko Google-yhteys on katkennut tai sitä ei ole yhdistetty tämänhetkiseen sijaintiin. Tarkista integraatioasetukset ja integroi uudelleen, jos yhteys on jo olemassa.",
    "selectPage": "Valitse sivu",
    "somethingWentWrongPlease": "Jokin meni pieleen, yritä uudelleen",
    "accept": "Hyväksy",
    "moreThan1Phone": "Yli yksi puhelinnumero sallittu.",
    "byContinuingToUse": "Jatkamalla HighLevel-alustan käyttöä hyväksyt nämä uudet {termsLink} ja {privacyLink}.",
    "byContinuingToUse1": "Jatkamalla HighLevel-alustan käyttöä hyväksyt nämä uudet",
    "termsOfService": "Käyttöehdot",
    "weHaveUpdatedOur": "Tutustu päivitettyihin käyttöehtoihin ja tietosuojakäytäntöön.",
    "newTriggerName": "Uusi käynnistimen nimi",
    "triggerName": "Käynnistimen nimi",
    "disableDndForSpecific": "Poista DND käytöstä tietyillä kanavilla",
    "selectAdAccount": "Valitse mainostili",
    "selectAppointmentStatus": "Valitse tapaamisen tila",
    "below1": "alla.",
    "Required": "* vaaditaan",
    "whenYouGetA": "Kun saat uuden arvostelun, julkaisemme sen automaattisesti Facebook-sivullasi. Muista, että paras käytäntö on julkaista enintään kolme arvostelua päivässä tilillesi.",
    "skip": "Ohita",
    "copyShareLink": "Kopioi jakolinkki",
    "agencyRelationshipNumbers": "Toimiston suhdenumerot",
    "alteast1AgencyRelationship": "Vähintään yksi toimistonäkymän lukumäärä on pakollinen.",
    "alteast1SubaccountId": "Vähintään yksi alatili ID on pakollinen.",
    "somethingWentWrongWhile": "Jokin meni pieleen tallennuksessa. Yritä myöhemmin uudelleen!",
    "5PerPage": "5 per sivu",
    "10PerPage": "10 per sivu",
    "amountMustGreaterOr": "Summan on oltava suurempi tai yhtä suuri kuin 1 AUD.",
    "regions": {
      "africa": "Afrikka",
      "asia_pacific": "Aasia / Tyynenmeren alue",
      "europe": "Eurooppa",
      "latin_america": "Latinalainen Amerikka",
      "usa_and_canada": "USA ja Kanada",
      "asia": "Aasia",
      "latinAmerica": "Latinalainen Amerikka",
      "usaCanada": "USA ja Kanada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Ei näytettäviä merkintöjä",
    "clear": "Tyhjennä",
    "filter": "Suodata",
    "test": "Testaa",
    "createNewTwilioSubAccountText": "Sinun täytyy luoda uusi Twilio-tili, päivittää tämän tilin tunnukset Twilio-asetuksiin ja siirtää puhelinnumerot ennen uudelleenlaskutuksen käyttöönottoa.",
    "viewing": "Katselu",
    "makeSmsCompliantByAddingASenderInformation": "Tee SMS-viestistä vaatimustenmukainen lisäämällä lähettäjän tiedot.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Tee sähköpostista vaatimustenmukainen lisäämällä sähköpostiisi Peruuta tilaus -linkki",
    "enableMissedCallTextBack": "Ota vastaamattomien puheluiden viestivastaukset käyttöön",
    "productInventory": "Tuotevarasto",
    "viewProductVariants": "Näytä tuotevaihtoehdot",
    "smtpSettings": "SMTP-asetukset",
    "locationOPMTrafficStatis": "Sijainti OPM-liikennetilastot",
    "locationGPMTrafficStatis": "Sijainti GPM liikennetilastot",
    "blacklistMonitorReports": "Estolistan valvontaraportit",
    "twoFactorAuthentication": "Kaksivaiheinen todennus (2FA)",
    "recent": "Viimeaikainen",
    "noPermission": "Sinulla ei ole lupaa hallita tämän tuotteen malleja. Uudelleenohjataan kojelautaan.",
    "tasksNowHave": "Tehtävillä on nyt",
    "option": "Vaihtoehto",
    "facebookAdsReporting": "Facebook-mainosten raportointi",
    "googleAdsReporting": "Google Ads -raportointi",
    "adsDatePicker": "Mainosten päivämäärän valitsin",
    "feedbackSubmitBtn": "Lähetä palaute",
    "ifYouThinkMistakePleaseContact": "Jos luulet, että kyseessä on virhe, ota yhteyttä",
    "forResolution": "ratkaisua varten.",
    "live": "Reaaliaikainen",
    "payouts": "Maksut",
    "greatChoice": "Erinomainen valinta!",
    "toNavigate": "navigoida",
    "teams": "Tiimit",
    "role": "Rooli",
    "searchAccounts": "Hakutilit",
    "searchByNameEmailPhone": "Hae nimellä, sähköpostiosoitteella tai puhelinnumerolla",
    "addEmployee": "Lisää työntekijä",
    "removeFromLocation": "Poista sijainnista",
    "knowMore": "Lisätietoja",
    "usingNumberPool": "Numeroryhmän käyttäminen",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Arvostelija",
    "cancel1": "Peruuta",
    "delete1": "Poista",
    "call1": "Soita",
    "message1": "Viesti",
    "name1": "Nimi",
    "voicemail1": "Vastaaja",
    "title1": "Otsikko",
    "choose_one": "Valitse yksi",
    "select_page": "Valitse sivu",
    "confirm1": "Vahvista",
    "conversations1": "Keskustelut",
    "copied1": "Kopioitu",
    "timeOfDay": {
      "am": "ap.",
      "pm": "ip."
    },
    "back1": "Takaisin",
    "details1": "Tiedot",
    "month1": "/kuukausi",
    "select1": "Valitse",
    "share1": "Jaa",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Estolistan valvontaraportit",
      "domainPurchase": "Verkkotunnusosto"
    },
    "confirmDelete": "Haluatko varmasti poistaa {name}?",
    "clicked1": "Napsautettu",
    "delivered1": "Toimitettu",
    "invalid1": "Ei voimassa",
    "open_options": "Avaa asetukset",
    "_add_account": "Lisää tili",
    "setTimezoneWarning": "Aseta aikavyöhyke sijaintiisi saadaksesi oikeat vapaat aikavälit.",
    "save1": "Tallenna",
    "action1": "Toiminta",
    "actions1": "Toiminnot",
    "all1": "Kaikki",
    "previous1": "Edellinen",
    "results1": "Tulokset",
    "next1": "Seuraava",
    "payments1": "Maksut",
    "settings1": "Asetukset",
    "total_js_heap": "JS-keon kokonaismäärä",
    "table": {
      "pagination": {
        "previous": "Edellinen",
        "next": "Seuraava"
      },
      "rowsSelected": "{count} riviä valittu",
      "cantRearrange": "{type} ei voida järjestää uudelleen"
    },
    "ivrCall": "IVR-puhelu",
    "sms": "SMS",
    "username": "Käyttäjätunnus",
    "stay": "Pysy",
    "placeholders": {
      "selectCountry": "Valitse maasi",
      "nameOfBusiness": "Yrityksen nimi",
      "line1": "Osoiterivi 1",
      "line2": "Osoiterivi 2",
      "enterState": "Anna osavaltio",
      "enterCity": "Anna kaupunki",
      "enterPostalCode": "Anna postinumero",
      "chooseCountry": "Valitse maa..."
    },
    "addressLine1": "Osoiterivi 1",
    "addressLine2": "Osoiterivi 2",
    "postalCode": "Postinumero",
    "nameOfBusiness": "Yrityksen nimi",
    "dispute_this_review": "Riitauta tämä arvostelu",
    "story_mention": "Tarinan maininta",
    "story_reply": "Vastaus tarinaan",
    "no": "Ei",
    "yes": "Kyllä",
    "annual": "vuosittainen",
    "plan": "Suunnitelma",
    "errors": {
      "somethingWrong": "Jokin meni pieleen"
    },
    "zero": "0",
    "perMonth": "kuukaudessa",
    "emailCheckLinks": "Tarkista linkit, joissa on mukautettu arvo. Merkkien {{ ja custom_values-välissä on ylimääräinen \"%20\".",
    "fileSizeTooLarge": "Tiedoston koko on yli 5 Mt",
    "fileSizeTooLargeDescription": "Lataamasi tiedosto on liian suuri. Kokeile pienemmällä tiedostokoolla.",
    "minMaxLength40Characters2048Characters": "Minimipituus: 40 merkkiä. Enimmäispituus: 2 048 merkkiä.",
    "sampleMessage2": "Malliviesti nro 2*",
    "pleaseSelectWorkflow": "Valitse työnkulku",
    "childrens": "Lasten",
    "brandAndCampaignRegistration": "Brändin ja kampanjan rekisteröinnistä veloitetaan kertaluontoisesti 20,95 $. TCR-sääntöjen mukaisesti sovelletaan kampanjan lisämaksua, joka on enintään 2,25 $ kuukaudessa.",
    "einRequiredForRegistration": "EIN-tunnus on pakollinen rekisteröintiä varten",
    "changed_props": "Muutetut rekvisiitat",
    "total_memory": "Kokonaismuisti",
    "total_store_size": "Myymälän kokonaispinta-ala",
    "total_watchers": "Yhteensä seuraajia",
    "update_count": "Päivitysmäärä"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Massatoiminnot",
      "clickHere": "Napsauta tästä nähdäksesi massatoimintojen luettelon.",
      "mergedMessage": "Tämä sivu on yhdistetty massatoimintojen luetteloon.",
      "title": "Yhteydenottopyynnöt"
    }
  },
  "conversations": {
    "noConversationsFound": "Ei löytynyt {status} -keskusteluja",
    "create_new": "Luo uusi viesti​",
    "validations": {
      "minCharsRequired": "Vähintään 3 merkkiä vaaditaan",
      "twoMoreCharsRequired": "Tarvitaan vielä kaksi merkkiä",
      "oneMoreCharRequired": "Tarvitaan vielä yksi merkki"
    },
    "sortLabels": {
      "latestAllMessages": "Viimeisimmät – kaikki viestit",
      "oldestAllMessages": "Vanhimmat – kaikki viestit",
      "latestManualMessages": "Viimeisimmät – manuaaliset viestit",
      "oldestManualMessages": "Vanhimmat – manuaaliset viestit",
      "latestAll": "Uusimmat – kaikki",
      "oldestAll": "Vanhimmat – kaikki",
      "latestManual": "Uusimmat – manuaalinen",
      "oldestManual": "Vanhimmat – manuaalinen",
      "highToLow": "{name} (korkeasta matalaan)",
      "manualMessagesTooltip": "Lajitteluvaihtoehto tulee voimaan 18. toukokuuta 2023 jälkeen viesteissä."
    },
    "deleteConversation": {
      "title": "Vahvistus",
      "confirmWithName": "Haluatko varmasti poistaa keskustelun {name} kanssa pysyvästi? Tätä ei voi kumota.",
      "confirmWithoutName": "Haluatko varmasti poistaa tämän keskustelun pysyvästi? Tätä ei voi kumota."
    },
    "makeCall": {
      "enterPhoneNumber": "Voit soittaa syöttämällä puhelinnumeron tähän kenttään.",
      "invalidPhoneNumber": "Twilio Lookup merkitsi tämän puhelinnumeron virheelliseksi."
    },
    "actions": {
      "markAsStarred": "Merkitse tähdellä",
      "unarchive": "Palauta arkistosta",
      "unmarkAsStarred": "Poista tähdellä merkitty"
    },
    "send": {
      "perMonthPerIp": "/ Kuukausi / IP",
      "perIp": "/ IP",
      "replyingTo": "Vastataan henkilölle",
      "requestClientsPaymentDetails": "Pyydä asiakkailta maksutiedot",
      "saasModeCreditCardRequired": "SaaS-tila vaatii asiakkaalle luottokortin.",
      "please": "Ole hyvä",
      "firstBeforeEnablingSaaS": "ensin ennen kuin otat SaaS-tilan käyttöön.",
      "shareALink": "Jaa linkki",
      "shareLinkInstructions": "Jaa linkki asiakkaasi kanssa maksutietojen keräämiseksi",
      "requestViaEmail": "Pyyntö sähköpostitse",
      "twilioRebillingDescription": "Uudelleenlaskuta Twilio-kustannukset ({twilioCopy}) asiakkaillesi ja lisää niihin kate.",
      "seeHow": "Katso ohjeet",
      "phoneRebillingCardInfoRequired": "Puhelinlaskutus edellyttää, että asiakkaan korttitiedot ovat tallessa.",
      "clientsCompanyBillingPage": "asiakkaan yrityksen laskutussivu",
      "ifYouPayForTwilioKeepUsing": "Jos maksat Twiliosta, jatka saman Twilio-tilin käyttöä",
      "ifClientPaysForTwilioCreateNew": "Jos asiakas maksaa Twiliosta, luo uusi Twilio-tili",
      "learnHow": "Tutustu miten",
      "createNewTwilioAccountInstructions": "Luo uusi Twilio-tili tälle sijainnille",
      "learnHowToMovePhoneNumbers": "Opi siirtämään puhelinnumeroita",
      "thisIsMyClientsTwilioCreateNew": "Tämä on asiakkaani Twilio, luo uusi tili",
      "featureUnderDevelopment": "Tämä ominaisuus on kehityksen alla.",
      "emailRebillingDescription": "Laskuta sähköpostikulut asiakkaillesi ja lisää niihin marginaali",
      "emailRebillingCardInfoRequired": "Sähköpostin uudelleenlaskutus edellyttää, että asiakkaan korttitiedot ovat tallessa.",
      "emailRebillingMarginsDescription": "Nämä ovat marginaaleja, jotka laskutetaan asiakkailtasi sähköpostikustannusten lisäksi",
      "provider": "Palveluntarjoaja",
      "morePlanCustomizationsAvailable": "Enemmän suunnitelman mukautuksia saatavilla",
      "plansAndPricing": "Suunnitelmat ja hinnoittelu",
      "connectYourStripeAccountFirst": "Yhdistä ensin Stripe-tilisi",
      "createRecommendedPlansOnStripe": "Luo suositeltuja suunnitelmia Stripe-palvelussa",
      "createdPlanInStripe": "Luotiin suunnitelma Stripe-palvelussa",
      "customizeYourSaasPlans": "Mukauta SaaS-suunnitelmiasi",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Voit tarjota suositeltuja suunnitelmia tai luoda omasi",
      "trialPeriod": "Kokeilujakso",
      "enterNumberOfDaysForTrial": "Anna kokeilujakson päivien lukumäärä",
      "nameCantBeEmpty": "Nimi ei voi olla tyhjä",
      "showStripeProductDetails": "Näytä Stripen tuotetiedot",
      "addEmail": "Lisää sähköpostiosoite",
      "resetMountCounts": "Nollaa asennuslaskurit",
      "connectReconnectGoogleForGbp": "Yhdistä tai yhdistä uudelleen Google GBP:lle.",
      "downloadFile": "Lataa tiedosto",
      "showOnlySlowQueries": "Näytä vain hitaat kyselyt",
      "gmbMessagingAvailable": "GMB-viestit ovat nyt saatavilla",
      "reconnectGbpPageToEnable": "Yhdistä GBP-sivusi uudelleen, jotta viestit voidaan ottaa käyttöön",
      "failedPaymentsCheckBilling": "Maksujen epäonnistuminen havaittu. Tarkista laskutus.",
      "onlyAgencyAdminsCanSeeWarning": "Vain toimiston ylläpitäjät voivat nähdä tämän varoituksen.",
      "filter": "Suodata",
      "stopDeleteOperation": "Pysäytä poistamistoiminto",
      "summary": "Yhteenveto",
      "enableTracking": "Ota seuranta käyttöön.",
      "exportAll": "Vie kaikki",
      "newConversationStarted": "Uusi keskustelu on aloitettu.",
      "startNewConversation": "Aloita uusi keskustelu",
      "subAccountScheduledForDeletion": "Alatili on ajoitettu poistettavaksi.",
      "deleteSubAccountOnScheduledTime": "Poista alatili aikataulutettuna aikana",
      "componentUpdatesDebuggerAlpha": "Komponenttipäivitysten virheenkorjaus (alfa)",
      "componentUpdateTrackingDisabled": "Komponentin päivitysseuranta on poistettu käytöstä",
      "deleteSubAccount": "Poista alatili",
      "subAccountHasNumbersAndCampaigns": "Tällä alatilillä on {phoneNumberCount} puhelinnumeroa ja {campaignsCount} kampanjaa.",
      "subAccountNoNumbersOrCampaigns": "Tällä alatilillä ei ole puhelinnumeroita eikä kampanjoita.",
      "areYouSureDeleteSubAccount": "Haluatko varmasti poistaa tämän alatilin?",
      "confirmDiscussedWithClient": "Vahvistan, että olen keskustellut tästä asiakkaani kanssa.",
      "understandActionIrreversible": "Ymmärrän, että tätä toimintoa ei voi kumota",
      "confirmDisconnectCloseLcPhone": "Vahvistan, että haluan katkaista yhteyden ja sulkea LC Phone -tilin.",
      "choosingNotDeleteLcPhoneWarning": "Varoitus: Jos et poista LC Phone -tiliä, sinulta veloitetaan edelleen tähän alatiliin liittyvistä puhelinnumeroista.",
      "deleteAccount": "Poista tili",
      "send": "Lähetä",
      "typeMessage": "Kirjoita viesti",
      "requestPayment": "Pyydä maksua",
      "reply": "Vastaa",
      "retry": "Yritä uudelleen",
      "analyzeMemory": "Analysoi muistia",
      "memoryAnalysisApproximate": "🚧 Muistianalyysi on likimääräinen eikä 100 % tarkka.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Tämä alatili on ajoitettu poistettavaksi. Se poistetaan",
      "youCanChangeYourMindBeforeThisTime": "Voit muuttaa mieltäsi ennen tätä ajankohtaa.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Ohita",
          "cannotIdentifyContact": "Kontaktia ja sen sijaintia ei voida tunnistaa.",
          "contactNotSelected": "Yhteyshenkilöä ei ole valittu.",
          "messageRequired": "Varmista, että olet kirjoittanut viestin tai valinnut mallipohjan.",
          "noPhoneNumber": "Kontaktilla ei ole puhelinnumeroa.",
          "genericError": "{message}",
          "stayPrompt": "Pysy"
        },
        "scheduledSuccess": "Sähköposti ajoitettu onnistuneesti",
        "confirmDelete": "Haluatko varmasti poistaa käyttäjän {name}?"
      },
      "clear": "Tyhjennä",
      "edit": "Muokkaa",
      "sendNow": "Lähetä nyt",
      "schedule": "Ajoita",
      "useTemplate": "Käytä mallipohjaa (katkelma)",
      "mergeFields": "Yhdistä kentät",
      "customVariablesError": "Mukautetuissa muuttujissasi on ongelmia. Korjaa ne ennen lähettämistä.",
      "sendLater": "Lähetä myöhemmin",
      "scheduledFor": "Ajoitettu päivämäärälle {date}",
      "call": "Soita",
      "leftVoicemail": "Jätti vastaajaviestin",
      "pleaseSelectCampaign": "Valitse kampanja",
      "whatsapp": {
        "no24HourMessage": "Voitte lähettää malliviestejä vain 24 tunnin aikarajan ulkopuolella. Valitse lähetettävä mallipohja."
      },
      "attachFile": "Liitä tiedosto",
      "email": {
        "fromEmail": "Lähettäjän sähköposti",
        "fromName": "Lähettäjän nimi",
        "smtpWarning": "SMTP-palveluntarjoajilla on joitain rajoituksia. Napsauta tätä saadaksesi lisätietoja.",
        "subject": "Aihe",
        "errors": {
          "cannotIdentifyContact": "Kontaktia ja sen sijaintia ei voida tunnistaa.",
          "contactNotSelected": "Yhteyshenkilöä ei ole valittu.",
          "genericError": "{message}",
          "bodyRequired": "Sähköpostin lähettämiseen vaaditaan viestirunko.",
          "noEmailAddress": "Kontaktilla ei ole sähköpostiosoitetta."
        },
        "scheduledSuccess": "Sähköposti ajoitettu onnistuneesti"
      },
      "addCalendarToSchedule": "Sinun on lisättävä kalenteri, jotta voit aloittaa tapaamisten ajoittamisen.",
      "slotRequired": "Aikaväli on pakollinen",
      "teamMemberRequired": "Tiimin jäsen on pakollinen"
    },
    "added": "lisätty",
    "loadMore": "Lataa lisää",
    "admin": "Ylläpitäjä",
    "aiEmployee": {
      "popupBlockedAlert": "Olet poistanut ponnahdusikkunan käytöstä. Ota käyttöön ponnahdusikkunat, jotta tämä sijainti ohjautuu automaattisesti Zoom-puheluun. Napsauttamalla \"liity nyt\" pääset suoraan Zoom-puheluun."
    },
    "alsoCloseAssociatedSubAccount": "Myös läheisesti liittyvä",
    "analyzeMemory": "Analysoi muistia",
    "announcements": "Ilmoitukset",
    "apply": "Käytä",
    "appointment": {
      "pickDay": "Valitkaa päivä",
      "pickSlot": "Valitse tapaamisen aikaväli",
      "selectDate": "Valitse päivä",
      "selectSlot": "Valitse aikaväli",
      "slot": "Aikaväli",
      "day": "Päivä"
    },
    "areYouReallySureDeleteSubAccount": "Haluatko varmasti poistaa tämän alatilin?",
    "areYouSureDeleteSubAccount": "Haluatko varmasti poistaa tämän alatilin?",
    "assignedContactOwner": "Määritetty (kontaktin {contact} omistaja)",
    "assignedToMe": "Minulle määritetty",
    "audio": {
      "browserNotSupported": "Selaimesi ei tue äänielementtiä.",
      "loadingTranscription": "Ladataan transkriptio...",
      "viewTranscript": "Näytä transkriptio",
      "stop": "Pysäytä",
      "playPause": "Toista/keskeytä",
      "timePlayed": "Toistoaika : Kokonaisaika",
      "mute": "Mykistys",
      "playbackSpeed": "Toistonopeus",
      "download": "Lataa",
      "remove": "Poista"
    },
    "automated": "Automatisoitu",
    "avatar": {
      "aiGenerated": "Tämä viesti on luotu Conversation AI:n avulla",
      "messengerAutomation": "Messenger-automaatio",
      "workflowGenerated": "Tämä viesti on luotu Conversation AI:n työnkulkutoiminnan avulla",
      "messageByAI": "Tämä viesti on luotu Conversation AI:n avulla",
      "messageByWorkflow": "Tämä viesti on luotu Conversation AI:n työnkulkutoiminnan avulla",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Ole osa nopeimmin kasvavaa yhteisöä.",
    "callHighlevelAt": "Soita HighLevelille numeroon +1(888)732-4197",
    "callQueueTooltip": "Tämä puhelu odottaa käsittelyä käyttäjän puhelujonossa.",
    "callTranscript": "Puhelun transkriptio",
    "clearFilters": "Tyhjennä suodattimet",
    "clientsCompanyBillingPage": "asiakkaan yrityksen laskutussivu",
    "closeChat": "Sulje keskustelu",
    "closeConversation": "Sulje keskustelu",
    "component": {
      "dismissMessage": "Hylkää tämä viesti",
      "unblock": "Kumoa esto",
      "inboundDndActive": "Saapuvien DND on otettu käyttöön tälle kontaktille",
      "fetchOlderMessages": "Hae vanhoja viestejä",
      "conversationBegan": "Keskustelu alkoi.",
      "celebrationTitle": "Hienoa! Keskustelut virtaavat nyt.",
      "celebrationBody": "Asiat ovat vasta alussa, tutkitaan, miten GHL voi auttaa kasvattamaan liiketoimintaasi.\nSillä välin voit jatkaa viestien lähettämistä."
    },
    "componentUpdateTrackingDisabled": "Komponenttien päivitysten seuranta on tällä hetkellä poistettu käytöstä",
    "componentUpdatesDebuggerAlpha": "🚧 Komponenttipäivitysten virheenkorjaus (Alpha) - Työn alla",
    "confirmDelete": "Poistetaanko keskustelu(t)?",
    "confirmDeleteTextLine11": "Haluatteko varmasti poistaa tämän keskustelun? Tätä toimintoa ei voi peruuttaa.",
    "confirmDeleteTextLine12": "keskustelut valittu",
    "confirmDeleteTextLine21": "Tätä toimintoa ei voi peruuttaa. Haluatko jatkaa?",
    "confirmDisconnectedAllIntegrations": "Vahvistan, että olen poistanut kaikki integraatiot (esim. twilio, mailgun, gmb, verkkotunnukset, facebook, zoom)",
    "confirmStoppedAllAutomations": "Vahvistan, että olen pysäyttänyt kaikki automaatiot tällä alatilillä",
    "connectReconnectGoogleForGbp": "Yhdistä / yhdistä uudelleen Google-tilisi saadaksesi GBP-viestit!",
    "connectWithCertifiedAdmin": "Ota yhteyttä sertifioituun ylläpitäjään",
    "connectWithTeamForHelp": "Ota yhteyttä tiimiimme saadaksesi apua live-videopuhelun kautta!",
    "connectWithUs": "Ota yhteyttä meihin",
    "connectZoomAccount": "Yhdistä Zoom-tili",
    "contactEngagementScore": "Käyttäjän {contact} sitoutumispistemäärä",
    "dailyBrainstormingSessions": "Päivittäiset aivoriihisessiot HighLevelin kanssa",
    "deleteAccount": "Poista tili",
    "deleteSubAccountOnScheduledTime": "Poista alatili valittuna ajankohtana",
    "disableSaasMode": "Poista SaaS-tila käytöstä",
    "dnd": {
      "configure": "MÄÄRITÄ",
      "status": {
        "on": "PÄÄLLÄ",
        "partial": "Osittainen"
      }
    },
    "editAppointment": {
      "updateButton": "Päivitä tapaaminen",
      "scheduleAppointment": "Ajoita tapaaminen",
      "editAppointment": "Muokkaa tapaamista",
      "calendar": "Kalenteri",
      "selectCalendar": "Valitse kalenteri",
      "roundRobin": "Vuorottelujako",
      "pickTeamMember": "Valitse tiimin jäsen",
      "selectTeamMember": "Valitse tiimin jäsen",
      "teamMemberRequired": "Tiimin jäsen on pakollinen",
      "slotRequired": "Aikaväli on pakollinen",
      "appointmentTitle": "Tapaamisen otsikko",
      "appointmentTitleTooltip": "Voit jättää tämän kohdan tyhjäksi, jos päätät käyttää ennalta määritettyä tapaamisen otsikkoa",
      "contactName": "Kontaktin nimi",
      "name": "Nimi",
      "nameRequired": "Nimi on pakollinen",
      "emailAddress": "Sähköpostiosoite",
      "phoneNumber": "Puhelinnumero",
      "phoneNumbers": "Puhelinnumerot",
      "dateOfBirth": "Syntymäaika",
      "contactTimezone": "Kontaktin aikavyöhyke (käytetään muistutusta varten)",
      "chooseOne": "Valitse yksi",
      "meetingLocation": "Tapaamispaikka",
      "meetingLocationTooltip": "Voit jättää tämän kohdan tyhjäksi, jos päätät käyttää ennalta määritettyä tapaamispaikkaa",
      "status": "Tila",
      "appointmentStatus": "Tapaamisen tila",
      "additionalNotes": "Lisätiedot",
      "notes": "Muistiinpanot",
      "actionRequired": "Toimia vaaditaan",
      "confirmed": "Vahvistettu",
      "invalid": "Virheellinen",
      "cancelled": "Peruutettu",
      "showed": "Osallistunut",
      "noShow": "Ei osallistunut",
      "busy": "Varattu",
      "free": "Ilmainen",
      "noCalendarMessage": "Sinun on lisättävä kalenteri, jotta voit aloittaa tapaamisten ajoittamisen."
    },
    "email": {
      "errors": {
        "bodyRequired": "Sähköpostissa pitää olla lähetettävä runkoteksti.",
        "cannotIdentifyContact": "Kontaktia ja sen sijaintia ei voida tunnistaa.",
        "contactNotSelected": "Kontaktia ei ole valittu.",
        "noEmailAddress": "Kontaktilla ei ole sähköpostiosoitetta."
      },
      "thread": {
        "failedToFetch": "Sähköpostin sisältöä ei voitu hakea",
        "forward": "Välitä"
      },
      "reply": "Vastaa",
      "share": "Jaa",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Lisää tili",
      "respond": "Vastaa",
      "retry": "Yritä uudelleen",
      "moreEmailsInThread": "{count} lisää sähköposteja keskusteluketjussa",
      "fromName": "Lähettäjän nimi",
      "fromEmail": "Lähettäjän sähköposti",
      "subject": "Aihe",
      "attachFile": "Liitä tiedosto",
      "useTemplate": "Käytä mallipohjaa (lyhyt video)",
      "requestPayment": "Pyydä maksua",
      "clear": "Tyhjennä",
      "sendNow": "Lähetä nyt",
      "schedule": "Ajoita",
      "send": "Lähetä",
      "smtpWarning": "SMTP-palveluntarjoajilla on joitain rajoituksia. Napsauta tätä saadaksesi lisätietoja.",
      "chooseOne": "Valitse yksi",
      "deliveredCount": "{delivered}/{total} lähetetty",
      "typeMessage": "Kirjoita viesti",
      "sendLater": "Lähetä myöhemmin",
      "scheduledFor": "Ajoitettu päivämäärälle {date}"
    },
    "emailRebillingCardInfoRequired": "Jotta voit ottaa sähköpostilaskutuksen käyttöön, sinun on syötettävä asiakkaasi korttitiedot.",
    "emailRebillingDescription": "Tämä mahdollistaa sähköpostikulujen uudelleenlaskutuksen asiakkaillesi ja marginaalin sisällyttämisen.",
    "emailRebillingMarginsDescription": "Nämä ovat marginaaleja, jotka laskutetaan asiakkailtasi sinun maksamiesi kustannusten vuoksi",
    "enableTracking": "Ota seuranta käyttöön.",
    "exploreHighlevelExperts": "Tutustu HighLevel-asiantuntijoihin, jotka voivat auttaa järjestelmäsi määrittämisessä, työnkulkujen automatisoinnissa tai projektisi mukauttamisessa.",
    "exportAll": "Vie kaikki",
    "facebook": {
      "errors": {
        "generalError": "Tapahtui virhe. Yrittää uudelleen tai tarkista Facebook-integrointi. Epäonnistunut viesti:",
        "noFacebookId": "Kontaktilla ei ole Facebook‑ID:tä."
      }
    },
    "failedPaymentsCheckBilling": "Sinulla on yksi tai useampi epäonnistunut maksu. Tarkista laskutushistorianne.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Yläpuolella",
      "aiActionLogs": "AI-toimintalokit",
      "inRange": "Alueella",
      "invoice": "Lasku",
      "messageDirectionTooltip": "Suodatin koskee 9.5.2023 jälkeen lähetettyjä viestejä",
      "appointments": "Tapaamiset"
    },
    "followed": "Jota seuraa",
    "followedByMe": "Minun seuraamia",
    "followedBySpecificUser": "Tietyn käyttäjän seuraama",
    "follower": "Seuraaja",
    "followerAssignmentContact": "Seuraaja ({contact} tehtävä)",
    "gbp": {
      "errors": {
        "generalError": "Tapahtui virhe. Yritä uudelleen tai tarkista Google Business Profile -integraatio. Virheviesti:",
        "noGBPId": "Kontaktilla ei ole GBP-ID:tä."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile -keskustelu ei ole enää käytettävissä",
    "getAccessToHighlevelWelcomeCourse": "Hanki pääsy HighLevel-tervetulokurssille",
    "getPriorityTroubleshooting": "Saat priorisoitua vianmääritystä, asiantuntijaohjausta ja suoran yhteyden tekniseen tiimiimme Slackin kautta.",
    "gmbMessagingAvailable": "Google Business Messaging on käytettävissä tilillänne.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Arvio:",
      "replyDate": "Vastauspäivämäärä:",
      "replyFrom": "Vastaus:",
      "review": "Arvostelu",
      "reviewDate": "Arvostelupäivämäärä:",
      "reviewFrom": "Arvostelu käyttäjältä:"
    },
    "highlevelEvents": "HighLevel-tapahtumat",
    "igMessengerDM": "IG Messengerin DM-viestit",
    "includeSignatureBeforeQuotedText": "Sisällytä tämä allekirjoitus vastauksiin ennen lainattua tekstiä",
    "instagram": {
      "errors": {
        "generalError": "Tapahtui virhe. Yrittäkää uudelleen tai tarkistakaa Instagram-integraatio. Epäonnistunut viesti:",
        "noInstagramId": "Kontaktilla ei ole Instagram-ID:tä."
      }
    },
    "joinOurFacebookGroup": "Liity Facebook-ryhmäämme",
    "keepUpToDateWithLatestNews": "Pysy ajan tasalla kaikista uusimmista uutisista ja julkaisuista!",
    "lastMessageChannel": "Viimeisen viestin kanava",
    "lastMessageDirection": "Viimeisen viestin suunta",
    "lastOutboundMessageType": "Viimeisen lähtevän viestin tyyppi",
    "learnHow": "Haluatko tietää miten?",
    "leftComment": "jätti kommentin",
    "leftPanel": {
      "recents": "Viimeisimmät",
      "unread": "Lukemattomat",
      "createNewMessage": "Luo uusi viesti",
      "minCharsRequired": "Vähintään 3 merkkiä vaaditaan",
      "twoMoreCharsRequired": "Tarvitaan vielä kaksi merkkiä",
      "oneMoreCharRequired": "Tarvitaan vielä 1 merkki"
    },
    "liveChat": {
      "endLiveChat": "Lopeta livekeskustelu",
      "errors": {
        "generalError": "Tapahtui virhe. Yritä uudelleen tai tarkista Google My Business -integraatio. Virheviesti:"
      },
      "requestContact": "Pyydä kontaktia"
    },
    "live_chat_message": "Live-chat-viesti",
    "made": "tehty",
    "memoryAnalysisApproximate": "🚧 Muistianalyysi on likimääräinen eikä 100 % tarkka.",
    "mentioned": "Mainittu kohteelle",
    "mentions": "Maininnat",
    "mentionsOfMe": "Maininnat minusta",
    "mentionsOfSpecificUser": "Maininnat tietystä käyttäjästä",
    "message": {
      "replyAll": "Vastaa kaikille",
      "details": "Tiedot",
      "reply": "Vastaa",
      "unsuccessful": "Epäonnistunut",
      "pending": "Kesken",
      "inboundCall": "Saapuva puhelu",
      "outboundCall": "Lähtevä puhelu",
      "ivrCall": "IVR-puhelu",
      "leftVoicemail": "Jätti vastaajaviestin",
      "storyReply": "Vastaus tarinaan",
      "storyMention": "Tarinan maininta",
      "replyAsDM": "Vastaa DM:llä",
      "newCommentOnPost": "Uusi kommentti {pageName}-julkaisussa.",
      "goToPost": "Siirry julkaisuun",
      "replyNotAvailable": "Yli seitsemän päivää vanhoihin kommentteihin ei voi vastata DM-viestillä.",
      "addToDocuments": "Lisää asiakirjoihin",
      "attachmentsAddedSuccess": "Liitteiden lisääminen asiakirjoihin onnistui",
      "attachmentsAddedFailed": "Liitteiden lisääminen asiakirjoihin epäonnistui",
      "reportFeedbackForAI": "Anna AI-palautetta",
      "sms": "Tekstiviesti"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Haluatko varmasti peruuttaa tämän aikataulun?",
      "cancelScheduledMessage": "Peruutetaanko ajoitettu viesti?",
      "cancelSend": "Peruuta lähetys",
      "cancelScheduledSuccess": "Ajoitetun viestin peruuttaminen onnistui",
      "cancelScheduledError": "Ajoitetun viestin peruuttamisessa tapahtui virhe",
      "cc": "CC",
      "channel": "Kanava",
      "createdBy": "Luonut",
      "direction": "Suunta",
      "emailCampaign": "Sähköpostikampanja",
      "facebookMessage": "Facebook-viesti",
      "instagramMessage": "Instagram-viesti",
      "messageId": "Viestin tunnus",
      "messageIdLabel": "Viestin tunnus: ",
      "trigger": "Käynnistin",
      "unanswered": "Vastaamaton",
      "yes": "Kyllä",
      "messageDetails": "Viestin tiedot",
      "from": "Lähettäjä",
      "fromLabel": "Lähettäjä:",
      "to": "Vastaanottaja",
      "toLabel": "Vastaanottaja:",
      "unknown": "Tuntematon",
      "unknownFrom": "Tuntematon lähettäjä",
      "unknownTo": "Tuntematon vastaanottaja",
      "unknownDirection": "Tuntematon suunta",
      "dateUnknown": "Päivämäärä tuntematon",
      "emailFromUnknown": "Sähköposti tuntemattomalta lähettäjältä",
      "smsFromUnknown": "Tekstiviesti tuntemattomalta lähettäjältä",
      "callFromUnknown": "Puhelu tuntemattomalta",
      "voicemailFromUnknown": "Vastaajaviesti tuntemattomalta",
      "emailToUnknown": "Sähköposti tuntemattomalle vastaanottajalle",
      "smsToUnknown": "Tekstiviesti tuntemattomalle vastaanottajalle",
      "callToUnknown": "Puhelu tuntemattomalle",
      "voicemailToUnknown": "Vastaajaviesti tuntemattomalle",
      "failed": "Epäonnistunut",
      "datetime": "Päivämäärä ja kellonaika",
      "manual": "Manuaalinen",
      "automation": "Automaatio",
      "workflow": "Työnkulku",
      "campaign": "Kampanja",
      "bulkRequest": "Massapyyntö",
      "delivered": "Toimitettu",
      "bounced": "Palautunut",
      "opened": "Avattu",
      "sent": "Lähetetty",
      "scheduled": "Ajoitettu",
      "pageName": "Sivun nimi",
      "gbpMessage": "GBP-viesti",
      "no": "Ei",
      "eventsTrackedForContactOnly": "Vain kontaktin sähköpostiosoitteen tapahtumat tallennetaan tällä hetkellä.",
      "completed": "Valmis",
      "voicemail": "Vastaaja",
      "busy": "Varattu",
      "pending": "Kesken",
      "read": "Lue",
      "nativeIntegrations": "Natiivi-integroinnit",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "Sähköposti",
      "sms": "Tekstiviesti",
      "phoneCall": "Puhelu",
      "voiceMail": "Ääniviesti",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Arvostelut",
      "others": "Muut",
      "partialDetailsWarning": "Osittaiset tiedot ovat saatavilla ennen 15.7.2022 lähetetyistä viesteistä.",
      "agencySystem": "Toimistojärjestelmä",
      "reply": "Vastaa"
    },
    "multiplePhone": {
      "chooseNumber": "Valitse numero aloittaaksesi keskustelun:",
      "continue": "Jatka",
      "noPhones": "Ei puhelinnumeroita saatavilla"
    },
    "myChat": "Oma keskustelu",
    "myInbox": "Oma sähköpostilaatikko",
    "newConversationStarted": "Uusi keskustelu on aloitettu.",
    "newMessage": {
      "title": "Uusi viesti:",
      "errors": {
        "phoneRequired": "Puhelinnumero on pakollinen"
      }
    },
    "noConversationSelected": "Keskustelua ei valittu",
    "noResultsToShow": "Ei näytettäviä tuloksia",
    "onboardingVideoTutorials": "Perehdytysvideot",
    "onlyAgencyAdminsCanSeeWarning": "Vain toimiston ylläpitäjät voivat nähdä tämän varoituksen. Lisätietoja",
    "onlyVisibleToUsers": "Näkyvissä vain käyttäjille",
    "perMonthPerIp": "/ Kuukausi / IP",
    "phone": {
      "call": "Soita kohteelle {name}.",
      "callingOptions": "{count} soittovaihtoehtoa",
      "phoneNumbers": "Puhelinnumerot",
      "callOptions": "{count} soittoasetukset",
      "dndActive": "DND on käytössä puheluita varten",
      "primary": "Ensisijainen"
    },
    "pleaseDisableSaasMode": "Poista SaaS-tila käytöstä tällä alatilillä",
    "pleaseSelectCampaign": "Valitse kampanja",
    "premiumSupport": "Premium-tuki",
    "quickFilters": "Pikasuodattimet",
    "reconnectGbpPageToEnable": "Yhdistä GBP-sivusi uudelleen, jotta se voidaan ottaa käyttöön.",
    "replyAsDMTooltip": "Vastaa tähän kommenttiin yksityisellä DM-viestillä.",
    "replyingTo": "Vastataan henkilölle",
    "resetMountCounts": "Nollaa asennuslaskurit",
    "review": {
      "errors": {
        "generalError": "Tapahtui virhe. Epäonnistunut viesti:",
        "googleIntegrationError": "Arvosteluun ei voi vastata. Google-integraatiossasi näyttää olevan virhe. Yhdistä se uudelleen kohdassa Asetukset -> Integraatiot.",
        "noReviewId": "Keskustelulla ei ole arvostelu-Id:tä."
      },
      "reviewPostTo": "Arvostele julkaisu kohteeseen {network}",
      "sharedOn": "Arvostelu jaettu kohteessa {network}",
      "disputeReview": "Riitauta tämä arvostelu",
      "learnHow": "(Opi miten?)",
      "seeOnGBP": "Katso tämä arvostelu GBP:ssä",
      "alreadyShared": "Tämä arvostelu on jo julkaistu kohteessa {network}. Oletko varma, että haluat julkaista sen uudelleen?"
    },
    "reviewId": "Arvostelun tunnus",
    "schedule": {
      "sendSchedule": "Lähetä aikataulu",
      "timezone": "Aikavyöhyke ({heading})",
      "title": "Aikatauluta {type}"
    },
    "scheduling": "Aikataulutetaan...",
    "seeHow": "Katso ohjeet",
    "selectFilter": "Valitse suodatin",
    "selected": "valittu",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Aihe:",
      "subjectPlaceholder": "Sähköpostin aihe",
      "to": "Vastaanottaja:",
      "sending": "Lähetetään...",
      "sendButton": "Lähetä sähköpostiviesti"
    },
    "setupAccountWithFreeTutorials": "Luo tili ilmaisten opetusohjelmien avulla",
    "showOnlySlowQueries": "Näytä vain hitaat kyselyt (> {threshold}ms)",
    "sms": {
      "confirmSending": "Vahvista viestin lähettäminen",
      "editModal": {
        "compose": "Kirjoita tekstiviesti"
      },
      "errors": {
        "customVariablesIssue": "Mukautetuissa muuttujissasi on ongelmia. Korjaa ne ennen lähettämistä.",
        "messageOrTemplateRequired": "Varmista, että olet kirjoittanut viestin tai valinnut mallipohjan.",
        "noPhoneNumber": "Kontaktilla ei ole puhelinnumeroa."
      },
      "scheduledSuccessfully": "SMS-viesti ajoitettu onnistuneesti.",
      "sendAnyway": "Lähetä silti",
      "spamWarning": "SMS-sisältösi voi sisältää viittauksia kannabikseen, SHAFTiin, sähkötupakkaan tai muihin kiellettyihin aiheisiin. Tällaisen sisällön lähettäminen SMS-viestillä on ehdottomasti kielletty ja voi johtaa tilin rajoituksiin. Tarkista sisältösi huolellisesti ennen kuin jatkat.",
      "send": "Lähetä"
    },
    "startNewConversation": "Aloita uusi keskustelu",
    "subAccountAndDeleteAllPhoneNumbers": "alatili ja poistaa kaikki puhelinnumerot",
    "subAccountScheduledForDeletion": "Tämä alatili on ajoitettu poistettavaksi",
    "subAccountScheduledForDeletionItWillBeDeleted": "Tämä alatili on ajoitettu poistettavaksi. Se poistetaan",
    "teamInbox": "Tiimipostilaatikko",
    "threshold": "Kynnysarvo",
    "understandActionIrreversible": "Ymmärrän, että toiminto on peruuttamaton ja kaikki tällä alatilillä olevat tiedot poistetaan",
    "unstarred": "Tähtimerkintä poistettu",
    "use_a_template": "Käytä mallipohjaa",
    "userAvailability": "Käyttäjän saatavuus",
    "userCalendarConfiguration": "Käyttäjäkalenterin asetukset",
    "userInfo": "Käyttäjätiedot",
    "userRoles": "Käyttäjäroolit",
    "viewSupportTickets": "Katso omat tukipyyntösi, tukiartikkelimme ja hyödylliset usein kysytyt kysymykset!",
    "visitOurHelpCenter": "Vieraile ohjekeskuksessamme",
    "welcomeCourse": "Tervetulokurssi",
    "whatsapp_logo": "WhatsApp-logo",
    "youCanChangeYourMindBeforeThisTime": "Voit muuttaa mieltäsi ennen tätä ajankohtaa.",
    "zoomAccount": "Zoom-tili",
    "deleteEmails": "Poista {count} sähköpostia",
    "fileAttachment": {
      "urlNotFound": "URL-osoitetta ei löytynyt",
      "unsupportedAttachment": "Näitä liitetiedostoja ei ehkä enää tueta.",
      "downloadFile": "Lataa tiedosto"
    },
    "composer": {
      "internalComment": "Sisäinen kommentti"
    },
    "dropdown": {
      "openOptions": "Avaa asetukset",
      "messageDetails": "Viestin tiedot"
    },
    "respond": "Vastaa",
    "selectTemplate": "Valitse mallipohja",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Olet poistanut ponnahdusikkunan käytöstä. Ota käyttöön ponnahdusikkunat, jotta tämä sijainti ohjautuu automaattisesti Zoom-puheluun. Napsauttamalla \"liity nyt\" pääset suoraan Zoom-puheluun.",
        "helpAndSupport": "Ohje ja tuki",
        "summerOfAI": "Tekoälyn kesä"
      }
    },
    "celebration": {
      "dismiss": "Hylkää",
      "body": "Asiat ovat vasta alussa, tutkitaan, miten GHL voi auttaa kasvattamaan liiketoimintaasi.\nSillä välin voit lähettää viestejä vapaasti",
      "title": "Jee! Keskustelut virtaavat nyt sujuvasti."
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "ohjeartikkeliimme tässä",
      "message": "Ota kolmannen osapuolen evästeet käyttöön, jotta voit tarkastella tätä sivua oikein. Voit tutustua",
      "ok": "OK",
      "title": "Kolmannen osapuolen evästeet eivät toimi"
    }
  },
  "crash": {
    "message": "Valitettavasti jotain odottamatonta tapahtui. Yritä päivittää sivu.",
    "refresh": "Päivitä sivu",
    "title": "Hups! Jokin meni pieleen"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Poistamisen keskeyttäminen kohteelle {name}",
      "confirmAbort": "Kyllä, peruuta",
      "keepDeleting": "Ei, jatka poistamista",
      "message": "Haluatko varmasti peruuttaa?",
      "scheduledForDeletion": "Tämä sijainti on ajoitettu poistettavaksi {date}",
      "title": "Peruuta poisto",
      "warning": "Viesti: sijainti poistetaan ajoitettu päivämääränä, ellet keskeytä poistamista."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Lataa tiedostot pudottamalla ne tähän",
      "uploadError": "Järjestelmävirhe: pyyntöä ei voitu lähettää AWS:lle. (Mahdollinen CORS-virhe)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Lisää {entityName}",
      "clonedMessage": "{entityName} Kopioitu! Vaihda tilille, jolle se kloonattiin, ja etsi se kohteen {entityName} välilehdeltä.",
      "errorGettingDetails": "Näyttää siltä, että kohteen {entityName} tietojen hakemisessa on virhe. Tarkista URL-osoite tai yritä uudelleen!",
      "permissionError": "Valtuutusvirhe: Tämä on suojattu suppilo, eikä sitä voi luoda tässä."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar-logo"
    },
    "printful": {
      "logo": "Printful-logo",
      "title": "Printful: Tulosta tilauksesta"
    },
    "printify": {
      "logo": "Printify-logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation-logo",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Shippo-logo",
      "title": "Shippo: toimitusintegraatio"
    },
    "tikTok": {
      "accountNotConnected": "Tiliä ei ole yhdistetty",
      "accountNotConnectedMessage": "Tilisi ei ole yhdistetty TikTok-mainostiliin. Tarkastele lomakkeita ja yhdistä kenttiä suorittamalla integrointi.",
      "advertiserId": "Mainostajan ID",
      "companyFields": "{companyName} -kentät",
      "editFields": "Muokkaa kenttiä",
      "errorSubscribing": "Virhe sivun tilaamisen yhteydessä.",
      "formsNotAvailable": "Lomakkeet eivät ole saatavilla",
      "mandatoryFieldsNote": "Huom: Yhdistä jokin seuraavista pakollisista kentistä, jotta saat liidit tilillesi onnistuneesti. Kentät: Etunimi, Sukunimi, Sähköposti, Puhelinnumero",
      "noFormsMessage": "TikTok-mainostililläsi ei ole tällä hetkellä luotuna yhtään liidien luontilomaketta. Siirry TikTok-mainostilillesi ja aloita luomalla sellainen.",
      "pageId": "Sivun tunnus",
      "selectAdvertiserAccount": "Valitse mainostajan tili"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Muu / en tiedä",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Sinun on käytävä läpi muutama helppo vaihe, jotta voit keskeyttää tämän alatilin"
    },
    "transfer": {
      "chooseDescription": "Valitse siirtotapa",
      "chooseMethod": "Siirrä tämä alatili",
      "eject": {
        "description": "Ansaitse toistuva 40 %:n provisio uuden tilin tilauksesta.",
        "title": "Muunna uudeksi tiliksi"
      },
      "modal": {
        "confirmDetails": "Vahvista tiedot ennen siirtoa",
        "confirmNomineePrefix": "Nimeä omistaja tehtävään",
        "confirmTransfer": "Vahvista siirto",
        "consentText": "Olen lukenut ja ymmärtänyt yllä olevat ohjeet ja hyväksyn kaikki rajoitukset",
        "ejectErrorTitle": "Alatilin poistaminen ei onnistu.",
        "ejectGenericError": "Alatiliä, jota yrität poistaa, ei voi poistaa. Ota yhteys tukeen.",
        "ejectGuidelines": "Alatilin poistamisohjeet",
        "ejectSubject": "Alatilin poistaminen edellyttää, että käyttäjä hyväksyy pyynnön uuden toimiston luomisesta.",
        "ejectSuccessTitle": "Alatilin muuntopyyntö lähetetty valitulle käyttäjälle",
        "enterPassword": "Vahvista antamalla salasanasi",
        "genericError": "Alatiliä, jota yrität siirtää, ei voi siirtää. Ota yhteys tukeen.",
        "guidelines": "Alitilien siirtämisohjeet",
        "guidelinesConsent": "Lue ja hyväksy",
        "hipaaDisclaimer": "Vastuuvapauslauseke",
        "hipaaText": "Kannattaa ilmoittaa tälle alatilille, että sillä on tällä hetkellä HIPAA-kattavuus, mutta se eivät välttämättä saa samaa kattavuutta toimistossa, johon se siirretään.",
        "noUsersDescription": "Tähän tiliin ei ole yhdistetty käyttäjiä. Lisää alatilille käyttäjä, ennen kuin jatkat.",
        "noUsersSearch": "Käyttäjiä ei löydetty.",
        "noUsersTitle": "Käyttäjiä ei löytynyt",
        "nomineeInstructions": "Ehdokas saa linkin HighLeveliin ilmoittautumiseen",
        "passwordError": "Virheellinen salasana",
        "passwordErrorDescription": "Antamasi salasana on virheellinen. Yritä uudelleen.",
        "relationshipError": "Anna oikea suhdenumero",
        "relationshipNumber": "Vastaanottavan toimiston asiakassuhdenumero",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Pyydä siirtoa",
        "seeAllRequests": "Näytä kaikki pyynnöt",
        "successMessage": "Alitili siirretään, kun vastaanottava toimisto on hyväksynyt siirtopyyntösi.",
        "successTitle": "Alatilin siirtopyyntö on lähetetty vastaanottavalle toimistolle",
        "title": "Siirrä alatili",
        "transferSubject": "Alatilin siirtäminen edellyttää, että vastaanottava toimisto hyväksyy sen tililleen.",
        "confirmNomineeSuffix": " että "
      },
      "transferExisting": {
        "description": "Siirrä tämä koko alatili toiselle tilille.",
        "title": "Siirrä olemassa olevalle tilille"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Seuraava suoritus",
      "title": "Massapyynnöt"
    },
    "campaign": {
      "account": "Tili",
      "accountBuffer": "Tilin puskuri",
      "accountBufferDescription": "Tähän kampanjaan päivittäin lisättävien vastaanottajien määrää (luettelosta) ei ole rajoitettu.",
      "accounts": "Tilit",
      "activity": "Toiminta",
      "acquire": "Peri",
      "acquisitionDescription": "Asiakashankintakampanjat auttavat sinua tuottamaan lisää \"kuumia\" myyntiliidejä, jotka ovat valmiita sitoutumaan.",
      "addEvent": "Lisää tapahtuma",
      "addUser": "Lisää käyttäjä",
      "allMarket": "Kaikki markkinat",
      "allowMultiple": "Salli useat",
      "assignedToTooltip": "Kun tämä kampanja alkoi, tämä kontakti määritettiin tälle käyttäjälle. Kontaktin \"Määritetty henkilölle\" -muutokset näkyvät tapahtumille, mutta eivät muuta tätä alkuperäistä arvoa.",
      "atLeastOneEvent": "Vähintään yksi tapahtuma on pakollinen.",
      "automations": "Automaatiot",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod differentio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero Miinus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Palautunut",
      "buffering": "Puskurointi",
      "campaignActivity": "Kampanjatoiminta",
      "campaignConfiguration": "Kampanjan asetus",
      "campaignConfigurationWarning": "Kampanjan asetus vaikuttaa kaikkiin markkinoihin. Varmista, että sinun on tehtävä muutoksia näihin asetuksiin.",
      "campaignCreation": "Kampanjaluominen",
      "campaignId": "Kampanjan tunnus",
      "campaignStatusByRecipients": "Kampanjan tila vastaanottajien mukaan",
      "clickThroughRate": "Klikkausprosentti",
      "clickedThrough": "Klikattu",
      "conditionIfExplanation": "Suorita tämä kampanja tai tapahtuma, jos nykyinen aika on tämän ajanjakson sisällä. Jos nykyinen aika on tämän ajanjakson ulkopuolella, ohita kampanja tai tapahtuma ja siirry seuraavaan.",
      "conditionWhenExplanation": "Suorita tämän kampanjan tapahtumat, kun nykyinen aika osuu tähän ikkunaan, muussa tapauksessa odota seuraavaa ikkunaa tapahtumien suorittamiseksi.",
      "createCampaign": " Luo kampanja",
      "ctr": "CTR",
      "customerAcquisition": "Asiakashankinta",
      "dateAdded": "Lisäämispäivä",
      "dateAddedTooltip": "Tarkka päivämäärä ja aika, jolloin kontakti lisättiin tähän kampanjaan. Ensimmäisen tapahtuman alkamisaika voi vaihdella kokoonpanosta riippuen.",
      "deletedRestorePrompt": "Tämä kampanja on poistettu! Haluatko nollata sen?",
      "delivered": "Toimitettu",
      "deliveryRate": "Toimitusprosentti",
      "draftMode": "Luonnostila",
      "draftModeDescription": "Tämä kampanja on luonnos. Sitä ei voida käyttää ennen kuin se on julkaistu.",
      "dropped": "Poistettu",
      "emailActivity": "Sähköpostitoiminta",
      "emailActivityFilterExample": "Sähköpostitoiminta: klikattu",
      "event": "Tapahtuma",
      "eventFilterExample": "Tapahtuma: 10X sähköposti 4 (listauksen toimitus)",
      "filters": "Suodattimet",
      "emailPerformanceByAccount": "Sähköpostin suorituskyky tilin mukaan",
      "emailsNotSentOnDays": "Sähköposteja ei lähetetä lauantaina eikä sunnuntaina.",
      "emailsSentOnDays": "Sähköpostit lähetetään maanantaina, tiistaina, keskiviikkona, torstaina ja perjantaina.",
      "eventStartDate": "Tapahtuman alkamispäivä",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8. toukokuuta 2017 13.27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Varmista, että tiedot ovat enintään 30 päivää vanhoja.",
      "exampleEventName": "10X Email 4 (Listauksen toimitus)",
      "getMoreCustomers": "Hanki lisää asiakkaita",
      "inProgress": "Käsittelyssä",
      "includedDays": "Sisältyvät päivät",
      "internalSource": "Sisäinen lähde",
      "lastUpdate": "Viimeisin päivitys",
      "leadValuePlaceholder": "$ liidin arvo",
      "loopDetected": "Tämä kampanja on lukittu Luonnos-tilaan, koska se aiheuttaa silmukan. Voit aktivoida tämän kampanjan, ottamalla yhteyttä asiakastukeen.",
      "market": "Markkinat",
      "moreDetails": "Lisätietoja",
      "myCampaigns": "Omat kampanjat",
      "na": "–",
      "newFolder": " Uusi kansio",
      "nextCampaign": "Seuraava kampanja",
      "nextExecutionTime": "Seuraavan suorituksen ajankohta",
      "opened": "Avattu",
      "openRate": "Avausaste",
      "option2": "Vaihtoehto 2",
      "option3": "Vaihtoehto 3",
      "pageNavigation": "Esimerkki sivunavigoinnista",
      "processed": "Käsitelty",
      "published": "Julkaistu",
      "recipient": "Vastaanottaja",
      "recipients": "Vastaanottajat",
      "sampleCampaign": "Esimerkkikampanja ",
      "scheduling": "Ajoitus",
      "seeHotLeads": "Katso kuumat liidit",
      "selectDateRange": "Valitse ajanjakso",
      "selectTimeZone": "Napsauttaa Aikavyöhyke",
      "separator": " / ",
      "showingCount": "Esittely {current} / {total}",
      "spamReport": "Roskapostiraportti",
      "startByAddingEvent": "Aloita lisäämällä tapahtuma tähän kampanjaan.",
      "stopOnResponse": "Pysäytä vastauksen jälkeen",
      "stopped": "Pysähtynyt",
      "time": "Aika",
      "timeConditionNote": "Viesti: jos kampanjoiden ensimmäinen Vaihe on asetettu \"Heti\", aikaehto ei koske kyseistä ensimmäistä vaihetta.",
      "timeZoneDescription": "Tämä asetus vaikuttaa siihen, milloin sisältösi lähetetään.",
      "totalLeads": "Liidejä yhteensä",
      "undeliverable": "Toimittamaton",
      "unsubscribe": "Peruuta tilaus",
      "upNext": "Seuraavaksi",
      "utc": "UTC",
      "window": "Ikkuna"
    },
    "embed": {
      "copyLinkInstructions": "Kopioi alla oleva linkki ja jaa se helposti missä vain.",
      "embed": "Upota",
      "iframeEmbed": "Iframe-upotus",
      "integrateInstructions": "Käytä seuraavia vaihtoehtoja integroidaksesi mukautetun lomakkeesi verkkosivustollesi",
      "integrateYourForm": "Integroi lomakkeesi",
      "link": "Linkki",
      "saveAndExit": "Tallenna ja poistu"
    },
    "jotbox": {
      "deleteSubmission": "Poista vastauslähetys",
      "downloadPdf": "Lataa PDF",
      "ofSubmissions": " {total} lähetyksestä",
      "pages": "sivua",
      "records": "tietuetta",
      "searchPlaceholder": "Hae nimellä, sähköpostiosoitteella, puhelinnumerolla tai kontaktin tunnuksella",
      "selectYourForm": "Valitse lomake",
      "timeSigned": "Allekirjoitusaika:",
      "totals": "Yhteensä:"
    },
    "survey": {
      "createNewSurvey": "Luo uusi kysely",
      "integrateYourSurvey": "Integroi kyselysi",
      "noSurveysForAnalyze": "Sinulla ei ole vielä yhtään kyselyä. Luo ensin kysely, jotta näet analyysin täällä.",
      "noSurveysForSubmission": "Sinulla ei ole vielä yhtään kyselyä. Luo ensin kysely, jotta näet lähetyksen täällä.",
      "noSurveysYet": "Sinulla ei ole vielä yhtään kyselyä.",
      "refreshData": "Päivitä tiedot",
      "searchSurveys": "Hae kyselyitä",
      "surveyBuilder": "Kyselytyökalu",
      "toCreateFirstSurvey": "ja luo ensimmäinen kyselysi."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Tuote kloonattu! Vaihda tilille, jossa se on kloonattu, ja etsi se Jäsenyys > Tuotteet-välilehdeltä.",
      "errorGettingDetails": "Näyttää siltä, että tuotetietojen hakemisessa on virhe. Tarkista URL-osoite tai yritä uudelleen!"
    },
    "resetPassword": {
      "title": "Vaihda salasana",
      "button": "Vaihda salasana",
      "newPassword": "Uusi salasana",
      "generateStrongPassword": "Luo vahva salasana",
      "sendEmailNotification": "Lähetä myös sähköposti-ilmoitus.",
      "errorMessage": "Salasanan nollaamisen aikana tapahtui virhe. Yritä uudelleen.",
      "updating": "Päivitetään..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ kirjoittanut",
      "combo": {
        "signedUp": "rekisteröitynyt ProveSourceen viimeisten 24 tunnin aikana",
        "verifiedBy": "vahvistanut "
      },
      "conversions": {
        "recentlyBought": "osti tämän äskettäin",
        "timeAgo": "viimeisten 16 minuutin aikana ",
        "visitorsCount": "50 vierailijaa"
      },
      "pageVisits": {
        "description": "näyttävät olevan nälkäisiä myös.",
        "timeAgo": "viimeisen 21 minuutin aikana                        ",
        "title": "50 foodieta"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessage",
        "rating": "Viiden tähden arvio",
        "recently": "Äskettäin",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "rekisteröitynyt ProveSourceen",
        "location": "(Lontoo, Yhdistynyt kuningaskunta)",
        "name": "Mike ",
        "timeAgo": "40 minuuttia sitten                        "
      },
      "visitors": {
        "description": "musiikin ystävät online"
      }
    },
    "step1": {
      "combo": {
        "description": "Näytä tiettyä toimintoa 24 tunnin, 7 päivän tai 30 päivän aikana suorittaneiden henkilöiden kokonaismäärä.",
        "title": "Yhdistelmä"
      },
      "conversions": {
        "description": "Luo sosiaalista vahvistusta näyttämällä, kuinka monta asiakasta on suorittanut tietyn toiminnon."
      },
      "liveReviews": {
        "description": "Näyttää kävijöillesi reaaliaikaiset vähintään neljän tähden arvostelut viimeisin kuuden kuukauden ajalta."
      },
      "liveVisitors": {
        "beta": "Beeta",
        "description": "Näyttää, kuinka monta kävijää nyt katsoo koko sivustoasi reaaliajassa."
      },
      "pageVisits": {
        "description": "Näyttää kävijöillesi, etteivät he ole ainoita juhlissa korostamalla viimeaikaisia sivukäyntejä."
      },
      "stream": {
        "description": "Mikä olisikaan parempaa kuin antaa kasvot sosiaaliselle todisteelle? Näyttää viimeaikaiset asiakkaat ja niiden toiminnot."
      }
    },
    "step2": {
      "captureDescription2": "Jokaisella Sivun URL-osoitteella on oltava sähköpostin lomakekenttä",
      "captureDescription3": " ja ProveSource asennettu. ",
      "comboType": "Yhdistelmätyyppi",
      "connectAccounts": "Varmista, että yhdistät tilit, joista haluat hakea arvosteluja.",
      "connectGoogleAccount": "Yhdistä sijaintisi Google-tili",
      "formSubmissions": "Lomakkeiden lähetykset",
      "googleAccount": "Google-tili",
      "howToTrack": "Seuraaminen",
      "howToTrackDescription": "Miten meidän pitäisi seurata konversioitasi?",
      "pageUrl": "Sivun URL-osoite",
      "productPurchase": "Tuoteosto",
      "trackAllUrls": "Seuraa kaikkia sivun URL-osoitteita, jotka sisältävät seuraavan lausekkeen. ",
      "trackVisitors": "Seuraa kävijöitä",
      "trackVisits": "Seuraa vierailuja",
      "urlTip": " Käsittelemme http://-, https://-, www- ja ei-www-osoitteita erillisinä URL-osoitteiden ja sivujen versioina. ",
      "urlValidationError": "Sinun on lisättävä vähintään yksi URL. URL-osoite on virheellinen. Muista sisällyttää http:// tai https://",
      "userSignup": "Käyttäjän rekisteröityminen",
      "visits": " Käynnit",
      "webhookDescription": "Soita seuraavaan päätepisteeseen ja ilmoita meille tapahtumasta tai konversiosta, joka on tapahtunut sinun puolellasi ja liittyy tähän ilmoitukseen. Me hoidamme loput.",
      "webhookRequest": "Webhook-pyynnöt",
      "whatToTrack": "Mitä haluaisit seurata?",
      "whereToCapture": "Missä kaapata",
      "whereToCaptureDescription": "Missä kaappaat konversiot?",
      "whichPagesToTrack": "Mitä sivuja haluat meidän seuraavan?",
      "yourWebhookUrl": "Webhook-URL-osoitteesi"
    },
    "step3": {
      "allPages": " Kaikki sivut",
      "displayOnAllPages": "Näytä kaikki sivun URL-osoitteet, jotka sisältävät seuraavan lausekkeen: ",
      "whereToDisplay": "Missä näytetään",
      "whereToDisplayActivity": "Missä haluaisitte meidän näyttävän tämän toiminnan?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "kauniita kuvakkeita varten (napsauta kuvaketta hiiren oikealla painikkeella -> Kopioi kuvan osoite)",
      "messageSettings": "Viestiasetukset",
      "messageText": "Viestin teksti",
      "referToVisitorsAs": "Kutsu vierailijoita nimellä",
      "visitIcons8": "Vieraile"
    },
    "step5": {
      "allowUsersToClose": " Salli käyttäjien sulkea ilmoitus ",
      "behavior": "Käyttäytyminen",
      "bottomLeft": "Alhaalla vasemmalla",
      "bottomRight": "Alhaalla oikealla",
      "clickableNotification": " Napsautettava ilmoitus ",
      "customizeDescription": "Muuta seuraavia asetuksia hallitaksesi ilmoitusten käyttäytymistä ja ulkoasua",
      "design": "Muotoilu",
      "displayNotificationFor": "Näytä ilmoitus kohteelle",
      "displayRules": "Näyttösäännöt",
      "hideOnMobileScreens": " Piilota mobiilinäytöillä ",
      "linkRelativeNote": " Jos http:// on ohitettu, linkki avautuu suhteessa näytettyyn sivuun. ",
      "minimumEventsToDisplay": "Näytettävät vähimmäistapahtumat",
      "notificationLink": "Ilmoituslinkki",
      "notificationPosition": "Ilmoituksen sijainti",
      "openLinkInNewTab": "Avaa linkki uudessa välilehdessä",
      "selectPosition": "Valitse sijainti",
      "showOnlyOncePerSession": " Näytä vain kerran per istunto ",
      "titleBackground": "Otsikon tausta",
      "titleColor": "Otsikon väri",
      "topLeft": "Ylhäällä vasemmalla",
      "topRight": "Ylhäällä oikealla",
      "typeUrlHere": "Kirjoita URL-osoite tähän"
    },
    "step6": {
      "identifyNotification": "Tunnista ilmoituksesi",
      "launchMessage": "Lähdemme pian. Istu alas ja kiinnitä turvavyösi.",
      "notificationName": "Ilmoituksen nimi",
      "notificationNamePrompt": "Mikä on ilmoituksesi nimi?",
      "wellDone": "Hyvin tehty."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Tilaus luotiin onnistuneesti",
      "youCanNowSetupWordPress": "Voitte nyt perustaa WordPress-sivustonne",
      "subscriptionFailed": "Tilauksen epäonnistuminen",
      "resubscriptionSuccessful": "Uudelleentilaus onnistui",
      "successfullyReactivated": "WordPress-tilauksesi on onnistuneesti aktivoitu uudelleen.",
      "reactiveSub": "Tilausta ei voida aktivoida uudelleen",
      "resubscriptionFailed": "Uudelleentilaus epäonnistui"
    },
    "v2": {
      "viewDetails": "Näytä tiedot",
      "chatConversationAssigned": "Chat-keskustelu on määritetty",
      "internalChat": "Sisäinen keskustelu",
      "newTask": "Uusi tehtävä",
      "appointmentReminder": "Tapaamisen muistutus",
      "facebookReview": "Facebook-arvostelu",
      "googleReview": "Google-arvostelu",
      "internalChatMessage": "Sisäinen keskustelu -viesti",
      "newAppointmentAssigned": "Uusi tapaaminen on määritetty",
      "newAppointmentBooked": "Uusi tapaaminen on varattu",
      "newCall": "Uusi puhelu",
      "newEmail": "Uusi sähköpostiosoite",
      "newMention": "Uusi maininta",
      "newReviewReceived": "Uusi arvostelu saatu henkilöltä {contactName}",
      "taskReminder": "Tehtävämuistutus",
      "completed": "valmis",
      "failed": "epäonnistunut",
      "subAccount": "Alatili",
      "newMessage": "Uusi viesti",
      "newAppointmentBookedWith": "Uusi tapaaminen on varattu henkilön {contactName}kanssa",
      "newAppointmentAssignedTo": "Uusi nimitys määritetty kontaktille {contactName}",
      "appointmentDueIn": "Tapaaminen erääntyy {minutes} minuutin kuluttua kontaktin{contactName} kanssa",
      "newTypeReceived": "Uusi {type} vastaanotettu kontaktilta {contactName}",
      "newChatAssigned": "Uusi keskustelu on osoitettu kontaktilta {contactName}",
      "taskDueDate": "Tehtävä ”{title}” erääntyy {date} klo {time} kontaktille {contactName}",
      "tasksDueToday": "{count} tehtävää erääntyy tänään",
      "tasksOverdue": "{count} tehtävää myöhässä",
      "taskDueIn": "Tehtävä ”{title}” erääntyy {dueTime} {unitOfTime} kuluttua kohteelle {contactName}",
      "mentionedInConversation": "{userName} mainitsi sinut keskustelussa {contactName}",
      "now": "nyt"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Yrityksen logo"
      },
      "bestExperience": "parhaan kokemuksen.",
      "optimizedFor": "Tämä sivu on optimoitu",
      "portraitMode": "kasvokuvatilalle",
      "toGiveYou": "tarjotakseen sinulle"
    }
  },
  "pagination": {
    "goToFirstPage": "Siirry ensimmäiselle sivulle",
    "goToLastPage": "Siirry viimeiselle sivulle",
    "goToNextPage": "Siirry seuraavalle sivulle",
    "goToPreviousPage": "Palaa edelliselle sivulle",
    "itemsSelected": "{count} kohdetta valittu",
    "showingEntries": "Näytetään {from} – {to} {total} merkinnästä"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "Lisää maksutapa kohteelle!",
    "_segment": "/ segmentti",
    "ad_manager": "Ad Manager",
    "add": "[LISÄÄ:",
    "ai_employee": "AI-työntekijä",
    "billing": {
      "incompleteBillingInfo": "Sinulla on keskeneräisiä laskutustietoja tällä tilillä. Päivitä ne heti.",
      "updateNow": "Päivitä nyt"
    },
    "charge": "Veloitus",
    "contactLimit": {
      "message": "Olet saavuttanut tämänhetkisen suunnittelusi rajan kontaktin {contact} lisäyksille. Voit jatkaa päivittämällä tilauksesi ja avaamalla lisää kapasiteettia.",
      "upgradeNow": "Päivitä heti",
      "warningMessage": "Sinulla on {current} kontakti(a), kun taas suunnitelmasi sallii enintään {limit}.",
      "warningTitle": "Tilin käyttö on ylittänyt rajan. Päivitä, jotta voit jatkaa työskentelyä keskeytyksettä."
    },
    "cost_borne_by_you": "sinun maksamasi kustannukset",
    "dedicated_ip": "Erillinen IP-osoite",
    "electeditem": "valittu kohde",
    "feedback": "Palaute:",
    "hello": "Hei",
    "helpDrawer": {
      "aiSupportAssistant": "Tuen tekoälyavustaja",
      "clickToCopy": "Kopioi suhdelukumäärä napsauttamalla",
      "clickToCopyToClipboard": "Kopioi suhdelukumäärä leikepöydälle napsauttamalla",
      "companyRelationshipNumber": "Yrityksen suhdelukumäärä",
      "hiImHighly": "Hei, olen Highly!",
      "implementation": "Käyttöönotto",
      "joinImplementationVideo": "Liity käyttöönotto-videopuheluun",
      "joinTrialZoom": "Liity kokeilun Zoom-puheluun",
      "kickoff": "Aloita",
      "needHelpChatVideo": "Tarvitsetko apua? Aloita Keskustelu tai Videopuhelu kanssamme nyt!",
      "openAIAssistant": "Open AI -tuen avustaja",
      "premium": "Premium",
      "priority": "Prioriteetti",
      "raiseSupportTicket": "Tee tukipyyntö",
      "raiseTicket": "Tee tukipyyntö",
      "relationshipNumber": "Suhdenumero",
      "startAISupportChat": "Aloita AI-tukikeskustelu",
      "startAgentChatWait": "Aloitus keskustelu asiakaspalvelijan kanssa 2-5 minuutin odotusajalla",
      "startChatChoose": "Aloita keskustelu – valitse AI-tuki tai agenttikeskustelu",
      "startImplementationVideo": "Aloita käyttöönotto-videopuhelu",
      "startZoom": "Aloita Zoom",
      "startZoomCall": "Aloita Zoom-puhelu",
      "subtitle": "Halusitpa sitten keskustella kanssamme tai yhteisön kanssa tai oppia omin päin, me hoidamme asian!",
      "title": "Ohje ja tuki",
      "trialExperience": "Kokeilukokemus",
      "useButtonsBelow": "Käytä mitä tahansa alla olevista painikkeista saadaksesi apua!",
      "videoCallReward": "Osallistu videopuheluun tilisi määrittämiseksi – ja saat {amount} hyvityksen lompakkoosi, kun osallistut.",
      "videoCallType": "Osallistu videopuheluun kanssani {type} -puhelua varten.",
      "yourPremiumSupportSpecialist": "{type} -ammattimainen tukesi",
      "yourSpecialist": "{type} -ammattilaisesi",
      "yourSupportSpecialist": "Tukiasiantuntijasi",
      "videoCall": "Videopuhelu",
      "active": "Aktiivinen",
      "announcementsAria": "Ilmoitukset – napsauttamalla avaat uuteen välilehteen",
      "chat": "Keskustele",
      "accessWelcomeCourseAria": "Napsauta päästäksesi HighLevelin aloituskurssille",
      "clickToUpgrade": "Päivitä napsauttamalla",
      "connectCertifiedAdminAria": "Yhdistä sertifioituun ylläpitäjään – napsauta avataksesi uudessa välilehdessä",
      "connectWithUsAria": "Ota yhteyttä meihin – aloita live-keskustelu",
      "contactUsAria": "Ota yhteyttä – soita HighLevelille numeroon +1(888)732-4197",
      "copied": "Kopioitu",
      "highlevelEventsAria": "Korkean tason tapahtumat – napsauta avataksesi uuteen välilehteen",
      "joinFacebookGroupAria": "Liity Facebook-ryhmäämme – napsauta avataksesi uudessa välilehdessä",
      "onboardingVideoTutorialsAria": "Perehdytysvideo-oppaat – napsauta avataksesi uudessa välilehdessä",
      "recommended": "Suositeltu",
      "visitHelpCenterAria": "Vieraile ohjekeskuksessamme – napsauta avataksesi uudessa välilehdessä",
      "contactUs": "Ota meihin yhteyttä",
      "agentChatWaitTime": "Asiakaspalvelijan chat-keskustelu (odotusaika ~2–5 min)",
      "aiSupportChat": "Tekoälytuen chat-keskustelu",
      "startChat": "Aloita chat-keskustelu",
      "announcements": "Ilmoitukset",
      "fastestGrowingCommunity": "Ole osa nopeimmin kasvavaa yhteisöä.",
      "callHighlevelPhone": "Soita HighLevelille numeroon +1(888)732-4197",
      "connectCertifiedAdmin": "Ota yhteyttä sertifioituun ylläpitäjään",
      "connectTeamVideoCall": "Ota yhteyttä tiimiimme saadaksesi apua live-videopuhelun kautta!",
      "connectWithUs": "Ota yhteyttä meihin",
      "dailyBrainstormingSessions": "Päivittäiset aivoriihisessiot HighLevelin kanssa",
      "certifiedAdminDescription": "Tutustu HighLevel-asiantuntijoihin, jotka voivat auttaa järjestelmäsi määrittämisessä, työnkulkujen automatisoinnissa tai projektisi mukauttamisessa.",
      "getAccessWelcomeCourse": "Hanki pääsy HighLevel-tervetulokurssille",
      "premiumSupportDescription": "Saat priorisoitua vianmääritystä, asiantuntijaohjausta ja suoran yhteyden tekniseen tiimiimme Slackin kautta.",
      "highlevelEvents": "HighLevel-tapahtumat",
      "joinFacebookGroup": "Liity Facebook-ryhmäämme",
      "onboardingVideoTutorials": "Perehdytysvideot",
      "premiumSupport": "Premium-tuki",
      "setupAccountFreeTutorials": "Luo tili ilmaisten opetusohjelmien avulla",
      "viewSupportTicketsArticles": "Katso omat tukipyyntösi, tukiartikkelimme ja hyödylliset usein kysytyt kysymykset!",
      "visitHelpCenter": "Vieraile ohjekeskuksessamme",
      "welcomeCourse": "Tervetulokurssi",
      "beta": "Beeta",
      "closeHelpSupportDrawer": "Sulje Apu ja Tuki -laatikko",
      "upgradePlanToEnable": "Sinun täytyy päivittää tilaustyyppi, jotta tämä ominaisuus voidaan ottaa käyttöön",
      "premiumSupportActive": "Premium-tukesi on aktiivinen",
      "premiumSupportClickUpgrade": "Premium-tuki – päivittä tilauksesi napsauttamalla",
      "premiumSupportActiveAria": "Premium-tuki – Premium-tukesi on aktiivinen",
      "keepUpToDateNews": "Pysy ajan tasalla kaikista uusimmista uutisista ja julkaisuista!"
    },
    "hi": "Hei",
    "is_scheduled_for_deletion_on": "on aikataulutettu poistettavaksi",
    "k": "K",
    "limit_updated_from": "rajaa päivitetty alkaen",
    "minimum_must_be": "Vähimmäismäärän on oltava",
    "more_emails_in_thread": "Lisää sähköposteja ketjussa",
    "multipleUsers": {
      "chooseAccount": "Jatka valitsemalla tili"
    },
    "must_be_in_range_of_0": "Sen täytyy olla alueella 0–",
    "numbers_and": "numero(t) ja",
    "premiumSupport": {
      "assigningManager": "Teknisen asiakkuuspäällikön nimeäminen...",
      "bookCall": "Varaa puhelu",
      "hiIm": "Hei, olen {name}",
      "joinZoomNow": "Osallistu Zoom-puheluun nyt",
      "quickActions": "Pikatukitoiminnot",
      "quickLinks": "Pikalinkit",
      "raiseFeatureRequest": "Esitä ominaisuuspyyntö",
      "slackChannelCreating": "Odota hetki – Premium Slack -kanavasi käynnistyy parhaillaan! 🚀",
      "technicalAccountManager": "Tekninen asiakkuuspäällikkö",
      "viewRoadmap": "Katso tuotteen etenemissuunnitelma"
    },
    "prospecting": "Prospektointi",
    "reloadPopup": {
      "message": "Olemme huomanneet, että et ole päivittänyt sivua vähään aikaan. Lataa sivu uudelleen, jotta saat parhaan käyttökokemuksen sovelluksesta.",
      "refreshNow": "Päivitä nyt"
    },
    "resell_settings": "Uudelleenmyyntiasetukset",
    "row": "rivi",
    "select_upto": "Valitse jopa",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Saat henkilökohtaista tukea sinulle sopivana ajankohtana.",
      "title": "Varaa puhelu Highlevel-tukipalvelun kanssa"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Nämä ovat katteita, jotka laskutetaan asiakkailtasi",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Anna meidän hallinnoida Twilioa puolestasi vaivattomasti",
        "benefit2": "Tukiryhmämme huolehtii Twilio-ongelmistasi",
        "button": "Tehkää se puolestani",
        "drawback": "Maksa {price} enemmän VAS:sta verrattuna sen tekemiseen itse",
        "title": "Teemme sen puolestasi"
      },
      "lowCreditsMessage": "Sinun on yhdistettävä Twilio-tili hallinnoidaksesi puheluita ja tekstiviestejä, jotka on lähetetty tai vastaanotettu HighLevelissä.",
      "lowCreditsTitle": "Ilmaiset Twilio-krediittisi ovat vähissä, mutta me olemme tukenasi!",
      "selfSetup": {
        "benefit1": "Hallitse menojasi",
        "benefit2": "Hallinnoi Twilio-palveluasi tehokkaammin",
        "button": "Minä hoidan asian",
        "drawback1": "Palkkaa joku hallinnoimaan Twilio-palvelua",
        "drawback2": "Ota yhteyttä Twilion tukeen, kun jokin ei toimi.",
        "title": "Tee-se-itse"
      },
      "wip": {
        "button": "Määritä Twilio nyt",
        "fallback": "Toistaiseksi sinun pitää hallinnoida omaa Twilio-tiliäsi.",
        "message": "Kiitos, että valitsit meidät. Työskentelemme edelleen tämän ominaisuuden kehittämiseksi. Kuulet meistä heti, kun voimme ottaa tämän käyttöön tililläsi.",
        "title": "Työskentelemme sen parissa edelleen!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Ladataan lisää vaihtoehtoja...",
      "noElementsFound": "Hups! Elementtejä ei löydetty. Harkitse hakukyselyn muuttamista.",
      "noLocationsFound": "Sijainteja ei löydetty. Kokeile eri hakua.",
      "typeToSearch": "Hae kirjoittamalla",
      "enterUserEmail": "Syötä käyttäjän sähköpostiosoite"
    },
    "updating": "Päivitetään",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Käytä mallipohjaa"
    },
    "validEmail": {
      "andYouCan": "Ja voit",
      "as": "nimellä",
      "canReverify": "Voit vahvistaa sähköpostiosoitteesi uudelleen",
      "emailIs": "Tämä sähköposti on",
      "emailMarkedAs": "Tämä sähköposti on merkitty seuraavasti",
      "markedAsInvalid": "Tämä sähköposti on merkitty nimellä",
      "notVerified": "Ei vahvistettu",
      "reverifyHere": "Vahvista uudelleen tässä",
      "verifyHere": "Vahvista tässä"
    },
    "will_give_you_about": "antaa sinulle noin",
    "checkout": {
      "confirm": "Vahvista",
      "cardInformation": "Kortin tiedot",
      "cardNumberInvalid": "Korttinumerosi on virheellinen.",
      "commitment": "sitoutuminen",
      "paymentConsent": "Vahvistamalla annat LeadConnectorille luvan veloittaa korttiasi tästä maksusta.",
      "subscriptionConsent": "Vahvistamalla tilauksesi annat LeadConnectorille luvan veloittaa kortiltasi tämän maksun ja tämän tilauksen tulevat maksut.",
      "endingIn": "päättyy",
      "month": "Kuukausi",
      "pay": "Maksa",
      "payWithCard": "maksa kortilla",
      "paymentBeingProcessed": "Maksua käsitellään. Älä lataa sivua uudelleen tai paina Takaisin-painiketta",
      "proceedWithExistingCard": "Jatka olemassa olevalla kortilla",
      "proceedWithNewCard": "Jatka uudella kortilla",
      "purchase": "osto",
      "subscribe": "Tilaa",
      "subscribeTo": "Tilaa",
      "pleaseUpdateCardDetails": "Päivitä korttitiedot",
      "zip": "postinumero",
      "retry": "yritä uudelleen",
      "initialChargesProrated": "Alkumaksut ovat suhteutettuja, ja säännöllinen laskutus alkaa",
      "youWillBeChargedFor": "Sinulta veloitetaan",
      "days": "päivää",
      "rightNowForPeriodTill": "Juuri nyt seuraavaan ajanjaksoon asti",
      "startGettingChargedFullAmount": "ja ala veloittaa koko summa",
      "perMonthStartingFrom": "/kuukausi alkaen",
      "nameOnCard": "Kortissa oleva nimi",
      "somethingWentWrong": "Jokin meni pieleen",
      "errorImg": "error img",
      "networkError": "Verkkovirhe. Yritä uudelleen jonkin ajan kuluttua.",
      "paymentCouldNotBeProcessed": "Maksua ei voitu käsitellä. Yritä lisätä kortti uudelleen."
    },
    "deleteLocation": {
      "back": "Takaisin",
      "delete": "Poista",
      "completeStepsToDelete": "Sinun on käytävä läpi muutama helppo vaihe, jotta voit poistaa sijainnin",
      "alsoCloseAssociated": "Myös läheisesti liittyvä",
      "scheduling": "Aikataulutetaan...",
      "subAccountAndDeletePhoneNumbers": "alatili ja poistaa kaikki puhelinnumerot",
      "somethingWentWrongTryAgain": "Jotain meni pieleen... Yritä uudelleen hetken kuluttua",
      "deleteSubAccount": "Poista alatili",
      "scheduleForDeletion": "Aikataulu poistettavaksi"
    },
    "productRebilling": {
      "enableRebilling": "Ota uudelleenlaskutus käyttöön",
      "ratesMayDifferUK": "Hinnat voivat vaihdella alueittain. Esitetyt laskelmat ovat Yhdistyneen kuningaskunnan hintojen mukaisia,",
      "examplePricingGpt4oMini": "Hinnoitteluesimerkki – GPT-4o Mini",
      "input": "Syöte",
      "output": "Tuloste",
      "supportDoc": "tukiasiakirja",
      "unsavedChanges": "Tallentamattomia muutoksia",
      "to": "kohteeseen",
      "chargedToCustomerLower": "Veloitettu asiakkaalta",
      "model": "Malli",
      "profit": "Voitto",
      "saving": "Tallennetaan...",
      "type": "Tyyppi",
      "updating": "Päivitetään...",
      "clickHere": "Napsauta tästä",
      "chargedToCustomer": "Veloitettu asiakkaalta",
      "enabling": "Otetaan käyttöön...",
      "forMoreDetails": "lisätietoja.",
      "tenDollarsWillGive": "10 $:lla saat noin",
      "yourCost": "Oma kustannus",
      "seeHow": "Katso ohjeet",
      "clientCompanyBillingPage": "asiakkaan yrityksen laskutussivu",
      "connectStripeToEnable": "Jotta voit ottaa uudelleenlaskutuksen käyttöön, sinun on yhdistettävä Stripe",
      "companyStripeIntegrationPage": "yrityksen Stripe-integraation sivulla",
      "enterClientCardInfo": "Jotta voit ottaa uudelleenlaskutuksen käyttöön, sinun on syötettävä asiakkaan korttitiedot",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(750 000 sanaa)",
      "words": "sanaa",
      "yourCostLower": "Kustannuksesi",
      "and": "ja",
      "or": "tai",
      "minimumMustBeBetween": "Vähimmäismäärän on oltava väliltä",
      "upgradeToAgencyPro": "päivitä Agency Pro -versioon",
      "planToSetMargins": "Suunnitelma marginaalien asettamiseksi"
    },
    "m": "m",
    "label": "Tunniste",
    "company_email_": "Yrityksen sähköposti (",
    "me_": "Minä (",
    "automation_type": "Automaation tyyppi",
    "calendar_groups": "Kalenteriryhmät",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Tuotteita ei ole saatavilla",
    "selectProduct": "Valitse tuote"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Ylimääräisistä {product} -viesteistä ei veloiteta sijainteja. Jos haluat laskuttaa asiakasta uudelleen, ota SaaS-tila ja uudelleenlaskutus käyttöön.",
      "agreementPrefix": "Hyväksyn käyttöönoton",
      "agreementSuffix": "tälle asiakkaalle ilman uudelleenmyyntiä ja hyväksyn, että minua veloitetaan",
      "buildResellerOffer": "Luo uudelleenmyyntitarjous",
      "deployDirectlyDescription": "Käytä tätä vaihtoehtoa, jos tarjoat {product} osana tarjoustasi tai jos haluat laskuttaa asiakastasi ulkoisesti",
      "deployPrefix": "Ota käyttöön",
      "directlySuffix": "Suoraan",
      "learnMore": "Lue lisää.",
      "offerPrefix": "Tarjous",
      "resellPrefix": "Myy uudelleen",
      "resellingPrefix": "Uudelleenmyynti",
      "subscriptionRestriction": "Määritystä ei voi muuttaa, koska sijainnilla on jo tilaus",
      "zero": "0",
      "highlevelPrice": "HighLevel-hinta",
      "howDoesItWork": "Miten se toimii?",
      "payNowButton": "Maksa heti",
      "priceValidationError": "Hinnan on oltava vähintään yhtä suuri kuin HighLevel-hinnan",
      "saving": "Tallennetaan",
      "yourPrice": "Oma hinta",
      "yourProfit": "Oma tuotto"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Saapuvien viestien vastaanottaminen ja niihin vastaaminen vapaalla tekstillä keskusteluikkunassa on ilmaista. Lähtevistä mallipohjaviesteistä peritään lisämaksuja, jos ne lähetetään.",
      "whatsappLocation": "WhatsApp-sijainti"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Määritystä ei voi muuttaa, koska sijainnilla on jo tilaus",
        "offerPrefix": "Tarjous ",
        "poweredByPrefix": " (Tarjoaja: Search Atlas)",
        "toggleTooltipDisable": "Tämä toiminto poistaa SEO-työkalun käytöstä kaikilta alatileiltä.",
        "toggleTooltipEnable": "Tämä toiminto ottaa SEO-työkalun käyttöön kaikilla alatileillä.",
        "resellPrefix": "Myy uudelleen ",
        "howDoesItWork": "Miten se toimii?",
        "buildResellerOffer": "Luo uudelleenmyyntitarjous",
        "yourPrice": "Sinun hintasi",
        "highlevelPrice": "HighLevel-hinta",
        "yourProfit": "Sinun tuottosi",
        "priceValidationError": "Hinnan on oltava vähintään yhtä suuri kuin HighLevel-hinnan",
        "saving": "Tallennetaan",
        "save": "Tallenna",
        "deployPrefix": "Ota käyttöön ",
        "directlySuffix": "Suoraan",
        "deployDirectlyDescription": "Käytä tätä vaihtoehtoa, jos tarjoat SEO:ta osana tarjoustasi tai jos haluat laskuttaa asiakastasi ulkoisesti",
        "agreementPrefix": "Hyväksyn käyttöönoton ",
        "agreementSuffix": " tälle asiakkaalle ilman uudelleenmyyntiä ja hyväksyn, että minua veloitetaan",
        "payNowButton": "Maksa heti",
        "subscriptionCreating": "Tilausta luodaan.<br/>Älä lataa sivua uudelleen tai paina Takaisin-painiketta",
        "subscriptionCreated": "Tilaus on luotu. Odota...",
        "subscriptionError": "Tilausta ei voi luoda, ota yhteyttä tukeen"
      },
      "adManager": {
        "subscriptionRestriction": "Määritystä ei voi muuttaa, koska sijainnilla on jo tilaus",
        "offerPrefix": "Tarjous ",
        "resellingPrefix": "Uudelleenmyynti",
        "resellPrefix": "Myy uudelleen ",
        "howDoesItWork": "Miten se toimii?",
        "bookACall": "Varaa puhelu",
        "bookCallTooltip": "Varatkaa puhelu tiimimme kanssa saadaksenne lisätietoja Ad Managerista",
        "buildResellerOffer": "Luo uudelleenmyyntitarjous",
        "yourPrice": "Sinun hintasi",
        "highlevelPrice": "HighLevel-hinta",
        "yourProfit": "Sinun tuottosi",
        "priceValidationError": "Hinnan on oltava vähintään yhtä suuri kuin HighLevel-hinnan",
        "loading": "Ladataan...",
        "save": "Tallenna",
        "deployPrefix": "Ota käyttöön ",
        "directlySuffix": "Suoraan",
        "deployDirectlyDescription": "Käytä tätä vaihtoehtoa, jos tarjoat Ad Manageria osana tarjoustasi tai jos haluat laskuttaa asiakastasi ulkoisesti",
        "agreementPrefix": "Hyväksyn käyttöönoton ",
        "agreementMiddle": " tälle asiakkaalle ilman uudelleenmyyntiä ja hyväksyn, että minua veloitetaan",
        "agreementSuffix": " kuukaudessa",
        "stripeNotConnectedLocationWarning": "Stripe ei ole yhdistetty tähän sijaintiin. Yhdistä Stripe ottaaksesi tämän ominaisuuden käyttöön.",
        "stripeNotConnectedAgencyWarning": "Stripe ei ole yhdistetty tähän toimistoon. Yhdistä Stripe ottaaksesi tämän ominaisuuden käyttöön.",
        "underSubAccountReselling": "kuukaudessa alatilin jälleenmyynnin alaisuudessa"
      },
      "dedicatedIp": {
        "description": "Tämän avulla voit uudelleenlaskuttaa asiakkailtasi erillisen IP:n kustannukset (käytetään lähtevän sähköpostin lähettämiseen) ja sisällyttää siihen marginaalin",
        "numberOfIps": "IP-osoitteiden määrä:",
        "yourCost": "Oma kustannus:",
        "chargedToCustomer": "Veloitus asiakkaalta:",
        "profit": "Voitto:",
        "monthlyProfit": "Kuukausittainen tuotto:",
        "loading": "Ladataan...",
        "save": "Tallenna",
        "revokeDedication": "Peruuta omistusoikeus",
        "revokeDescription": "Käytä tätä asetusta, jos haluat lopettaa uuden erillisen IP-osoitteen tarjoamisen veloittamatta asiakkaalta.",
        "existingSubscriptionsNote": "Nykyisiin IP-tilauksiin ei tule muutoksia",
        "revoke": "Peruuta",
        "provideDirectlyTitle": "Tarjoa erillinen IP-osoite sähköpostikäyttöön suoraan",
        "provideDirectlyDescription": "Käytä tätä asetusta, jos haluat tarjota erillisen IP-osoitteen asiakkaallesi veloittamatta asiakastasi.",
        "agreeToProvideText": "Suostun tarjoamaan IP-osoitteen tälle asiakkaalle ilman lisämyyntiä",
        "acknowledgeChargeText": "Hyväksyn, että minulta veloitetaan 59 $/kk jokaisesta IP-osoitteesta",
        "agree": "Hyväksyn",
        "yourMonthlyCost": "Kuukausittainen IP-kustannus:",
        "monthlyChargeToCustomer": "Kuukausittainen asiakkaan veloitus:",
        "resellingSettingsSuffix": " Uudelleenmyyntiasetukset",
        "ipRebillingAmount": "IP-uudelleenlaskutussumma"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Vahvistan, että olen keskustellut tästä asiakkaani kanssa ja saanut häneltä suostumuksen",
        "confirmQuestion": "Haluatko varmasti poistaa käytöstä SaaS-tilan tältä tililtä?",
        "dataLossAck": "Ymmärrän, että kaikki uudelleenlaskutustiedot, SaaS-tilaustiedot ja transaktiorekisteri poistetaan",
        "disableSaas": "Poista SaaS käytöstä",
        "irreversibleAck": "Ymmärrän, että tätä toimintoa ei voi kumota"
      },
      "confirmationModal": {
        "cancelSubscription": "Peruuta myös tähän liittyvä SaaS-tilaus",
        "confirmDisable": "Vahvista käytöstä poisto",
        "confirmQuestion": "Haluatko varmasti poistaa SaaS-tilan käytöstä?",
        "somethingWentWrong": "Jotain meni pieleen... Yritä uudelleen hetken kuluttua"
      },
      "processingModal": {
        "closeNow": "Sulje nyt",
        "closeWindowInstructions": "Voit sulkea tämän ikkunan. Ilmoitamme sinulle sähköpostitse, kun prosessi on valmis.",
        "title": "SaaS poistetaan pian käytöstä tässä sijainnissa.",
        "typicalTime": "Tämä kestää tyypillisesti enintään 10 minuuttia."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Lisää mukautettu kenttä",
      "fieldKey": "Kenttäavain",
      "fieldName": "Kentän nimi",
      "idWillBeAdded": "ID lisätään, kun menetyksen syy on luotu",
      "lostReasonID": "Menetyksen syyn ID",
      "placeholder": "Paikkamerkki"
    },
    "locationMailGun": {
      "bccAddress": "BCC-osoite",
      "clearError": "Poista virhe",
      "deleteConfirmationMessage": "Tämä toiminto poistaa Mailgun-yhteyden.",
      "deleteConnection": "Poista yhteys",
      "domain": "Verkkotunnus",
      "domainsAvailable": "{count} saatavilla",
      "invalidApiKey": "Virheellinen API-avain",
      "selectDomain": "Valitse verkkotunnus"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Virhe transaktioiden tietojen noutamisessa",
      "transactions": "Transaktiot"
    },
    "noShowSMS": {
      "smsWithImage": "Ilmestymättä jäänyt SMS kuvalla",
      "title": "Mukauta arvostelu-SMS"
    },
    "optOut": {
      "addKeywords": "Lisää jokin seuraavista kieltäytymisavainsanoista: PYSÄYTÄ, PYSÄYTÄ KAIKKI, PERUUTA TILAUS, PERUUTA, LAKKAUTA tai LOPETA.",
      "customizeTitle": "Mukauta kieltäytymisviestiä",
      "disableConfirm": "Haluatko varmasti poistaa kieltäytymisviestin käytöstä?",
      "disableOptOut": "Poistaa kieltäytyminen käytöstä",
      "disableTitle": "Poistetaanko kieltäytymisviesti käytöstä?",
      "optInConfirmClient": "Vahvistan varmistavani, että SMS-viestejä lähetetään vain niille kontakteille, jotka ovat antaneet suostumuksensa.",
      "quickTipMessage": "Ensimmäisessä viestissä, jonka lähetät henkilölle, on oltava jokin seuraavista vakiomuotoisista kieltäytymissanoista: STOP, STOPKAIKKI, PERUUTATILAUS, PERUUTA, PERU tai LOPETA.",
      "reallyDisableConfirm": "Oletko täysin varma, että haluat poistaa kieltäytymisviestin käytöstä?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Pyynnön JULKAISUN runko",
        "requestQueryParameters": "Pyynnön kyselyparametrit",
        "responseBody": "Vastauksen runko"
      },
      "logs": "Lokit",
      "logsPage": {
        "clearAll": "Tyhjennä kaikki",
        "loadMore": "Lataa lisää",
        "price": "Hinta",
        "product": "Tuote",
        "tabsAriaLabel": "Maksulokit-välilehdet"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Lisää yleinen teksti kohtaan",
      "beginning": "Aloitus",
      "complianceConfirm": "Vahvistan, että varmistan kaikkien tältä tililtä lähetettävien SMS-viestien olevan tämänhetkisten säännösten mukaisia.",
      "customizeTitle": "Mukauta yleistä tekstiä",
      "disableConfirm": "Haluatko varmasti poistaa soittajan tunnuksen käytöstä?",
      "disableSenderID": "Poista soittajan tunnus käytöstä",
      "disableTitle": "Poistetaanko SenderID käytöstä?",
      "end": "Loppu",
      "pleaseAdd": "Sisällytä {text} kuten pikavinkissä on mainittu.",
      "quickTipMessage": "Ensimmäisessä viestissä, jonka lähetät jollekulle, on oltava lähettäjän tunnistetiedot. Lisää {text} yleiseen tekstikenttään.",
      "reallyDisableConfirm": "Oletko täysin varma, että haluat poistaa soittajan tunnuksen käytöstä?",
      "senderID": "Lähettäjätunnus"
    },
    "shopify": {
      "adminApiAccessToken": "Ylläpitäjä-API:n pääsyvaltuus",
      "apiTokenRequired": "API:n pääsyvaltuus on pakollinen",
      "checkDocumentation": "Katso lisätietoja tästä dokumentaatiosta",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Mukautetun sovelluksen API:n pääsyvaltuus",
      "deleteWarning": "Tämän poistaminen poistaa olemassa olevan yhteyden.",
      "existStoreAlertTitle": "Shopify-kaupan integrointi on jo olemassa",
      "integration": "Shopify-integrointi",
      "integrationHealth": "Integroinnin tila",
      "orders": "Tilaukset",
      "scopePermissionsWarning": "Varmista, että sovelluksellesi on myönnetty käyttöoikeudet, jotka on merkitty punaisella ristillä.",
      "scopes": "Laajuus",
      "scopesDescription": "Hyväksynnän laajuudet ovat välttämättömiä Shopify-tietojen käyttämiseksi. Shopifyn viimeaikaisten muutosten vuoksi read_customers on nyt pakollinen saadakseen täydet yksityiskohdat asiakkailta, koska Shopify suojaa asiakastilastoja.",
      "storeConnectedMessage": "Shopify-kauppa on jo yhdistetty alatiliin {locationName}",
      "storeNameHelp": "Kauppasi nimi on löydetty Shopify-tilisi URL-osoitteessa – https:// jälkeen ja ennen .myshopify.",
      "storeNameLabel": "Shopify-kauppasi nimi",
      "storeNamePlaceholder": "Kaupan nimi",
      "storeNameRequired": "Kaupan nimi on pakollinen",
      "typeRemoveConfirm": "Vahvista kirjoittamalla 'REMOVE'",
      "webhooks": "Webhookit",
      "webhooksDescription": "Jotta voimme vastaanottaa kaikki Shopifyn tapahtumat, meidän on rekisteröitävä nämä Shopify-webhookit integrointiprosessin aikana. Nämä webhookit ovat välttämättömiä Shopify-ominaisuuksien moitteettoman toiminnan varmistamiseksi."
    },
    "slack": {
      "accountConnected": "Tili yhdistetty",
      "accountsConnected": "Yhdistetyt tilit",
      "accountsList": "Luettelo kaikista Slack-tileistä",
      "added": "Lisätty {date}",
      "connectChannel": "Yhdistä Slack-kanavasi",
      "description": "Saat välittömät ilmoitukset Slack-kanavallesi. Lisää Slack-kanava napsauttamalla Yhdistä.",
      "manage": "Hallinnoi",
      "manageAccounts": "Hallinnoi Slack-tilejä",
      "noIntegrations": "Slack-integraatioita ei löydetty."
    },
    "smtpService": {
      "addFirstService": "Lisää ensimmäinen SMTP-palvelu.",
      "addService": "Lisää palvelu",
      "bccEmails": "BCC-sähköpostit",
      "cannotDeleteDefaultProvider": "Et voi poistaa oletuspalveluntarjoajaa.",
      "contactDeveloper": "Ota yhteyttä tämän sovelluksen kehittäjään.",
      "customProvider": "Mukautettu palveluntarjoaja",
      "defaultProvider": "Oletuspalveluntarjoaja",
      "defaultProviderUpdated": "Oletuspalveluntarjoaja on päivitetty onnistuneesti!",
      "emailDomain": "Sähköposti / verkkotunnus",
      "emailService": "Sähköpostipalvelu",
      "enableReplyTracking": "Ota vastausseuranta käyttöön",
      "forwardToAssignedUser": "Lähetä uudelleen määritetylle käyttäjälle",
      "providerType": "Palveluntarjoajatyyppi",
      "smtpConnectionIssue": "Tässä SMTP-yhteydessä on ongelma. Yhdistä tämä Integrointi uudelleen.",
      "useLcEmailMessage": "Käytä LC Emailia lähettääksesi sähköpostia toimistollesi ja asiakkaillesi."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automaattinen julkaisu on käytössä",
      "dailyPostLimit": "Päivittäinen julkaisurajoitus",
      "directoriesDescription": "Kun saat uuden arvostelun, julkaisemme sen automaattisesti yli 80 online-hakemistoon, jotka auttavat kasvattamaan brändiäsi ja parantamaan SEO:ta.",
      "directoriesTitle": "Yli 80 hakemistoa ja verkkosivustoa",
      "fivePosts": "5 julkaisua",
      "fiveStars": "5 tähteä",
      "fourPosts": "4 julkaisua",
      "fourStars": "4 tähteä",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Määritä, miten ja milloin arvostelusi julkaistaan automaattisesti kussakin sosiaalisessa verkostossasi.",
      "manageSettingsTitle": "Hallinnoida sosiaalisen median asetuksia.",
      "postReviewsForRating": "Julkaise arvosteluja tästä tähtiluokituksesta tai sitä korkeammista.",
      "searchEngines": "Hakukoneet",
      "threePosts": "3 julkaisua",
      "threeStars": "3 tähteä",
      "title": "Sosiaalinen julkaisu"
    },
    "tags": {
      "addNewTag": "Lisää uusi tagi",
      "allTags": "Kaikki tagit",
      "deletedTags": "Poistetut tagit",
      "here": "tästä.",
      "newTag": "Uusi tagi",
      "noTagsYet": "Ei vielä näytettäviä tageja",
      "searchTags": "Etsi tageja",
      "viewDeletedTags": "Voit katsoa ja nollata poistettuja tageja Jäljityslokit-sivulta"
    },
    "templateMessage": {
      "addEmailTemplate": "Lisätä sähköpostin mallipohja (katkelma)",
      "addTemplate": "Lisää mallipohja (katkelma)",
      "addTextTemplate": "Lisää tekstimallipohja (katkelma)",
      "body": "Runko",
      "deleteTemplateConfirmation": "Haluatko varmasti poistaa tämän mallipohjan?",
      "templatesCount": "{count} mallipohjaa",
      "title": "Viestipohjat (katkelmat)"
    },
    "unsubscribe": {
      "content": "Sisältö",
      "contentTooltip": "Tämän viestin sisältö lisätään automaattisesti kaikkiin sähköposteihin.",
      "customizeTitle": "Mukauta tilauksen peruutuksen sisältöä",
      "disableConfirm": "Haluatko varmasti poistaa sähköpostien tilauksen peruutuslinkin käytöstä?",
      "disableTitle": "Poistetaanko Peruuta tilaus -linkki käytöstä?",
      "disableUnsubscribe": "Poista tilauksen peruutus käytöstä",
      "pleaseAddTag": "Lisää /*peruutatilaus*/-tagi",
      "reallyDisableConfirm": "Haluatko varmasti poistaa sähköpostin tilauksen peruutuslinkin käytöstä?",
      "subscribedConfirm": "Vahvistan, että sähköpostia lähetetään vain kontakteille, jotka ovat tilanneet sähköpostien vastaanottamisen.",
      "subscribedConfirmClient": "Vahvistan varmistavani, että sähköpostia lähetetään vain kontakteille, jotka ovat tilanneet sähköpostien vastaanottamisen.",
      "suspensionWarning": "Vaatimusten vastainen toiminta voi johtaa tilisi sähköpostiominaisuuksien keskeyttämiseen.",
      "tagRequirement": "Alkuperäisen sähköpostiviestin, jonka lähetät jollekulle, on sisällytettävä /*peruutatilaus*/-tagi"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Tämä on oletusvastaajaviesti kaikille Twilio-numeroille tässä sijainnissa, ellei sitä ole mukautettu kohdassa",
      "forwardCallsToWebApp": "Välitä puhelut verkkosovellukseen",
      "forwardCallsToMobileApp": "Siirrä puhelut mobiilisovellukseen.",
      "dedicatedNumberRequiredInfo": "Tämä vaaditaan vain, jos käyttäjät tarvitsevat erillisen numeron. Ei vaadita vastaajaa varten eikä puhelun ohjaamiseen määritetylle käyttäjälle.",
      "voicemailMessageInfo": "Tämä vastaajaviesti toistetaan puhelinoperaattorin viestin sijasta. Suosittelemme aikakatkaisua, joka on enintään 20 sekuntia.",
      "noTimeout": "Ei aikakatkaisua",
      "10Secs": "10 sekuntia",
      "20Secs": "20 sekuntia",
      "voicemailMessageDuration": " Tallennamme vastaajaviestin, jos puheluun ei vastata ennen tämän ajan umpeutumista",
      "saveCallSettings": "Tallenna puheluasetukset"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Kun tämä tunniste on yhteystiedossa, viestejä EI toimiteta Elizalle.",
      "sendToElizaNote": "Oletusarvoisesti kaikki keskustelut toimitetaan Elizalle. Jos tämä tagi on määritetty, <br />uudet keskustelut lähetetään Elizalle vain, kun tämä tagi on läsnä yhteystiedossa.<br /> Jos sekä Eliza-ohitustagi että Lähetä Elizalle -tagi on määritetty, vain Lähetä Elizalle -tagi otetaan huomioon.",
      "permissionNote": "Käyttäjäoikeuksiasi ei ole otettu käyttöön tälle sivulle. <br />Ota yhteyttä järjestelmänvalvojaan",
      "addFAQ": "Lisää UKK"
    },
    "locationSettings": {
      "ownCardWarning": "Älä lisää omaa korttiasi alatileille!",
      "addClientCardWarning": "Lisää asiakkaasi (alatilin) kortti, älä omaasi, sillä tätä korttia käytetään laskuttamaan asiakastasi puolestasi.",
      "stripeConnectMissing": "Stripe-yhteys puuttuu",
      "pleaseContactAgencyToAddPaymentMethods": "Ota yhteyttä toimistoon ({email}) lisätäksesi maksutavat"
    },
    "integrations": {
      "connectWaveAccount": "Yhdistä sijaintisi Wave-tili",
      "connectXeroAccount": "Yhdistä sijaintisi Xero-tili"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP-puheluiden seuranta on otettu käyttöön toisella alatilillä. Puheluiden seuranta voidaan ottaa käyttöön yhdellä alatilillä kerrallaan.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP-puheluiden seuranta on aktivoitu toisella sivulla ({pageName}). Puheluiden seuranta voidaan ottaa käyttöön yhdellä alatilillä ja yhdellä sivulla sijaintia kohden kerrallaan.",
      "gbpCallsProperlySetup": "GBP-puhelut on määritetty oikein ja puhelut tulevat numerosta",
      "tooManyEditsToPrimaryPhone": "Olet tehnyt liian monta muokkausta yrityksen ensisijaiseen puhelinnumeroon. Yritä myöhemmin uudelleen.",
      "setupTwilioToStartCallTracking": "Aloita puhelujen seuranta määrittämällä Twilio",
      "twoSecondaryNumbersSetupAlready": "Sinulla on jo kaksi toissijaista numeroa asetettuna, numeroa ei voi vaihtaa",
      "yourAgentIDIs": "Agenttitunnuksesi on"
    },
    "numberPool": {
      "title": "Mitä seurattavaa",
      "tracking": {
        "percentComplete": "34 % valmis",
        "searchLower": "haku"
      },
      "create": {
        "title": "Luo seurantanumero"
      }
    },
    "phoneNumbers": {
      "title": "Mitä seurattavaa",
      "tracking": {
        "percentComplete": "34 % valmis",
        "heading": "Luo seurantanumero"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Syötä arvo",
      "selectOption": "* Valitse vaihtoehto"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Vähintään yksi {filterName} on pakollinen",
      "select": "Valitse {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Aikaleima"
    },
    "recordsNav": {
      "clickToReloadList": "Napsauta ladataksesi luettelon uudelleen."
    },
    "reviewRequestActions": {
      "emailReviewReq": "Sähköpostitse lähetetty arvostelupyyntö",
      "smsReviewReq": "Tekstiviestitse lähetetty arvostelupyyntö",
      "whatsappReviewReq": "WhatsApp-arvostelupyyntö"
    },
    "smartListFilters": {
      "clearAllFilters": "Tyhjennä kaikki suodattimet",
      "noneFound": "Ei löydetty mitään.",
      "saveChangesToList": "Tallenna suodattimen muutokset tähän älykkääseen luetteloon",
      "saveCombinationAsNew": "Tallenna suodattimien, sarakkeiden ja lajittelun yhdistelmä uutena älykkäänä luettelona",
      "saveCurrentAsNew": "Tallenna tämänhetkiset suodattimet uutena älykkäänä luettelona",
      "searchAndAddFilter": "Hae ja lisää suodatin",
      "searching": "etsitään...",
      "undoUnsavedChanges": "Peruuta tallentamattomat muutokset"
    },
    "smsStatsPanel": {
      "smsStats": "SMS-tilastot"
    },
    "manageDuplicates": "Hallinnoi kopioita",
    "emailAction": {
      "attachFiles": "Liitä tiedostot",
      "customValues": "Mukautetut arvot",
      "triggerLinks": "Triggerilinkit"
    },
    "atLeastOneRequired": "* Vähintään yksi {filterName} on pakollinen",
    "arrayInput": {
      "searchPlaceholder": "Hae {filterName}a",
      "searching": "Haetaan..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Virhe tilannevedoksen sisältöä haettaessa",
      "overwriteAll": "Korvaa kaikki",
      "skipAll": "Ohita kaikki",
      "somethingWentWrongWhileFindingConflicts": "Jokin meni pieleen ristiriitoja etsittäessä",
      "step": "Vaihe"
    },
    "confirmOverwrite": {
      "confirmButton": "Vahvista korvaaminen",
      "description": "Tämä toiminto on peruuttamaton ja voi muuttaa kampanjoiden, mahdollisuuksien, myyntiputkien jne. asetuksia. Vahvista toiminto kirjoittamalla seuraava teksti syöttökenttään.",
      "title": "Haluatko varmasti korvata valitut tiedot?"
    },
    "conflicts": {
      "noConflictsDetected": "Ristiriitoja ei havaittu",
      "overwrite": "Korvaa"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Linkitetyt resurssit löydetty",
      "checkingConflicts": "Tarkistetaan ristiriitojen varalta",
      "chooseSnapshot": "Valitse tilannevedos",
      "copyingDataNotification": "Tietojen kopiointi valittuihin sijainteihin. Odota...",
      "linkedLocations": "Linkitetyt sijainnit",
      "noConflictsFound": "Ristiriitoja ei löytynyt",
      "notAuthorizedMessage": "Vain toimiston ylläpitäjät voivat suorittaa tämän toiminnan",
      "overwriteConflicts": "Korvaa ristiriidat",
      "pickSnapshot": "Valitse tilannevedos",
      "response": "Vastaus",
      "selectAssetsToPush": "Valitse siirrettävät resurssit",
      "selectLocationsToUpdate": "Valitse päivitettävät sijainnit",
      "snapshotNotAuthorized": "Tätä tilannevedosta ei ole valtuutettu tähän sijaintiin",
      "snapshotNotSelected": "Tilannevedosta ei ole valittu"
    },
    "share": {
      "agencyRestrictedLink": "Toimiston rajoitettu linkki",
      "deleteShareLink": "Poista jakolinkki",
      "editShareLink": "Muokkaa jakolinkkiä",
      "permanentLink": "Pysyvä linkki",
      "subaccountRestrictedLink": "Alatilin rajoitettu linkki"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Lisää pilkku (<span class='text-base font-bold'> , </span>) jokaisen suhdenumeron jälkeen)",
      "addCommaAfterEachSubAccount": "(Lisää pilkku (<span class='text-base font-bold'> , </span>) jokaisen alatilin ID:n jälkeen)",
      "atLeast1EmailRequired": "Tarvitaan vähintään yksi sähköpostiosoite.",
      "emailShareLink": "Sähköpostin jakolinkki",
      "enterOnePerLine": "Syötä yksi per rivi",
      "errorGettingLink": "Linkin noutamisessa tapahtui virhe. Yritä myöhemmin uudelleen!",
      "getAgencyRestrictedLink": "Hae toimiston rajoitettu linkki",
      "getLink": "Hae linkki",
      "getOneTimeLink": "Hanki kertakäyttöinen jakolinkki",
      "getPermanentLink": "Hae pysyvä linkki",
      "getSubAccountRestrictedLink": "Hae alatilin rajoitettu linkki",
      "shareType": "Jaa tyyppi",
      "title": "Jaa tilannevedos"
    },
    "snapshot": {
      "copySnapshotID": "Kopioi tilannevedoksen ID",
      "deleteSnapshot": "Poista tilannevedos",
      "editSnapshot": "Muokkaa tilannevedosta",
      "pushUpdate": "Push-päivitys linkitettyihin tileihin",
      "refreshSnapshot": "Päivitä tilannevedos"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Lisää pilkku jokaisen suhdenumeron jälkeen)",
      "addCommaAfterEachSubAccount": "(Lisää pilkku jokaisen alatilin tunnuksen jälkeen)",
      "title": "Päivitä jakamislinkki"
    }
  },
  "socialMedia": {
    "engagement": "Sitoutuminen",
    "potentialReach": "Mahdollinen tavoitettavuus",
    "storiesCreated": "Luodut tarinat",
    "recentPosts": "Uusimmat julkaisut",
    "notConnected": "Ei yhteyttä (Yhdistä nyt!)",
    "totalAudience": "Kokonaisyleisö",
    "activeAudience": "Aktiivinen yleisö",
    "socialMediaOverview": "Sosiaalisen median yleiskatsaus"
  },
  "suspendModal": {
    "currentStatus": "Tilauksen tämänhetkinen tila: keskeytetty",
    "instructions": "Sinun on käytävä läpi muutama helppo vaihe, jotta voit {action} tämän alatilin",
    "nextBillingDate": "Seuraava laskutuspäivämäärä:",
    "noKeepCharging": "Ei, jatka asiakkaan veloittamista.",
    "pauseSubscriptionQuestion": "Haluatko keskeyttää tilauksen myös alatilillä?",
    "resumeSubAccount": "Jatka alatiliä",
    "resuming": "Jatketaan...",
    "saasSubscriptionActive": "Tällä alatilillä on aktiivinen SaaS-tilaus.",
    "saasSubscriptionResumed": "Tämän tilin SaaS-tilausta jatketaan.",
    "yesPause": "Kyllä, keskeytä tilaus"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per sivu",
      "10": "10 per sivu",
      "15": "15 per sivu",
      "20": "20 per sivu",
      "25": "25 per sivu",
      "50": "50 per sivu",
      "100": "100 per sivu"
    },
    "filterPlaceholder": "Haetaan...",
    "emptyText": "Tietueita ei löytynyt",
    "loading": "Ladataan...",
    "showingEntries": "Näytetään {from} – {to} {total} merkinnästä",
    "noEntriesToShow": "Ei näytettäviä merkintöjä"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Ladataan tilitietoja…",
      "toContinueWith": "jatka kohteella"
    },
    "switcherModal": {
      "comingSoon": "Tulossa pian!",
      "multiLocationMessage": "Tämä ominaisuus on nyt saatavilla vain yksilöllisille tileille. Teemme kovasti töitä tuodaksemme tämän pian usean sijainnin tileille."
    },
    "importedMessage": "{productName} Tuotu! Siirry Mallipohjakirjastoon ja etsi se {productName}-välilehdeltä.",
    "permissionErrorMsg": "Tämä vaihtoehto on saatavilla vain korkeammilla suunnitelmilla. Päivitä nyt avataksesi sen.",
    "errors": {
      "sourceDeleted": "Virhe: lähdemallipohja on poistettu. Se ei ole enää saatavilla. Tarkista mallipohjan tila tai ota yhteyttä lähteeseen, niin saat apua.",
      "sourceDraft": "Virhe: Lähdemalli on siirretty luonnokseksi. Tarkista mallipohjan tila tai ota yhteyttä lähteeseen, niin saat apua.",
      "linkedDeleted": "Virhe: Lähdemalli, joka on linkitetty jaettuun mallipohjaan, on poistettu. Tarkista mallipohjan tila tai ota yhteyttä lähteeseen, niin saat apua.",
      "fetchError": "Näyttää siltä, että kohteen {productName} tietojen hakemisessa on virhe. Tarkista URL-osoite tai yritä uudelleen!",
      "sameAgency": "Mallia ei voi jakaa saman viraston sisällä"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Lisää kontaktin tagi -toiminto vaatii tagin.",
    "addNotesRequiresData": "Lisää muistiinpanoja -toiminto vaatii muistiinpanotietoja.",
    "addTaskRequiresFields": "Lisätä tehtävä -toiminta vaatii otsikkoa ja Eräpäivää.",
    "addToCampaignRequiresCampaign": "Lisätä kampanjaan -toiminta vaatii kampanjan.",
    "addToCustomAudienceRequires": "Lisää mukautettuun yleisöön -toiminta vaatii mainostilin ja mukautetun yleisön.",
    "addTrigger": "Lisää käynnistin",
    "anyAction": "Mikä tahansa toiminto",
    "anyCondition": "Mikä tahansa tila",
    "brokenCustomVariables": "Jotkin kentät sisältävät rikkinäisiä mukautettuja muuttujia. Korjaa ne ennen tallentamista.",
    "conditionCannotBeEmpty": "Ehto \"{condition}\" ei voi olla tyhjä",
    "confirmDeleteTrigger": "Haluatko varmasti poistaa tämän käynnistimen?",
    "customDateFieldRequired": "Mukautettu päivämääräkenttäsuodatin on pakollinen mukautetun päivämäärämuistutuksen käynnistämiseksi",
    "detailPage": {
      "chooseTriggerPlaceholder": "Valitse käynnistin",
      "lastUpdate": "Viimeksi päivitetty:",
      "loopIdentifiedWarning": "Tämä käynnistin on lukittu luonnostelu-tilaan, koska se aiheuttaa silmukan. Voit aktivoida tämän käynnistimen ottamalla yhteyttä tukeen.",
      "ruleNotActiveWarning": "Tämä sääntö ei käynnisty, ennen kuin aktivoit sen.",
      "triggerCreation": "Käynnistimen luominen:",
      "triggerDeletedPrompt": "Tämä käynnistin on poistettu! Haluatko palauttaa sen?",
      "triggerRunDailyTooltip": "Käynnistä päivittäinen ajo klo 8.00",
      "whatTriggersRule": "Minkä pitäisi käynnistää tämä sääntö?",
      "whichEventTriggersAutomation": "Minkä tapahtuman pitäisi käynnistää tämä automaatio?"
    },
    "dndContactRequiresState": "DND-kontakti -toiminta vaatii, että DND-tila on asetettu.",
    "emptyConditionNotAllowed": "Tyhjä tila ei ole sallittu.",
    "emptyFieldNotAllowed": "Tyhjä kenttä ei ole sallittu.",
    "executeWebhookRequiresUrl": "Suorita webhook -toiminto vaatii webhookin URL-osoitteen.",
    "fieldCannotBeEmpty": "{field} ei saa olla tyhjä",
    "fillRequiredFields": "Täytä kaikki pakolliset kentät toiminnoissa.",
    "googleAdwordsRequiresConversion": "Lisää Google Adwords -toiminta vaatii muuntamisen.",
    "googleAnalyticsRequiresFields": "Lisää Google Analyticsiin -toiminta vaatii seurantatunnuksen, toimintatyypin ja toimintaluokan.",
    "membershipGrantOfferRequiresOffer": "Jäsenyyden myöntämistarjous -toiminta vaatii tarjouksen.",
    "membershipRemoveOfferRequiresOffer": "Jäsenyyden poistamistarjous -toiminta vaatii tarjouksen.",
    "newBasicRule": "Uusi yksinkertainen sääntö",
    "opportunitiesRequirePipeline": "Mahdollisuustoiminnot edellyttävät, että valitset prosessin.",
    "opportunityLoopWarning": "Tämä käynnistin aiheuttaa mahdollisuuden luomissilmukan. Poista käytöstä Salli päällekkäiset mahdollisuudet tai muuta viittaamaasi vaihetta.",
    "removeContactTagRequiresTag": "Poistaa kontaktin tagi -toiminto vaatii tagin.",
    "removeFromCampaignRequiresCampaign": "Poistaminen kampanjatoiminnosta vaatii kampanjan.",
    "removeFromCustomAudienceRequires": "Poistaminen mukautetusta yleisöstä -toiminta vaatii mainostilin ja mukautetun yleisön.",
    "rulesBasedOn": "sääntö, joka pohjautuu kohteeseen",
    "selectUserForNotification": "Valitse käyttäjä lähetysilmoitusta varten.",
    "sendEmailRequiresFields": "Lähetä sähköposti -toiminta vaatii lähettäjän, vastaanottajan, aiheen ja viestin.",
    "sendNotificationRequiresFields": "Lähetysilmoitus-toiminta vaatii otsikon, rungon ja käyttäjätyypin ilmoituksen lähettämiseen.",
    "sendSmsRequiresFields": "Lähetä tekstiviesti -toiminto vaatii numeron ja viestin.",
    "stripeMinAmountUSD": "Summan on oltava vähintään 0,5 USD.",
    "stripeRequiresFields": "Stripen kertaluontoinen veloitustoiminta vaatii asiakastunnuksen, summan ja valuutan",
    "thatWillFire": "joka laukeaa",
    "triggerCannotBeEmpty": "Käynnistin ei saa olla tyhjä",
    "updateContactFieldRequires": "Päivitä kontakti -kentällä pitää olla vähintään yksi kenttä asetettuna."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Maksa ${amount} ja tilaa",
      "commitment": "Ei sitoumuksia, voit peruuttaa milloin tahansa",
      "features": {
        "billedOnUsage": "Laskutetaan käytön perusteella rajan ylittymisen jälkeen",
        "externalAI": "Sulkee pois ulkoisen AI-mallin toiminnot, jotka laskutetaan erikseen.",
        "leadingPricing": "Alan johtava hinnoittelu!",
        "monthlyPurchase": "Voimassa yhdelle ostokselle kuukaudessa",
        "premiumActions": "Koskee Premium-tason toimintoja ja käynnistimiä"
      },
      "planDetails": "Suunnitelman tiedot",
      "subscribeAndSave": "Tilaa ja säästä tänään!",
      "title": "${amount} per {executions} suoritusta kuukaudessa"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Tämä asetus on siirretty kalenterisivulle.",
    "toNavigate": "navigoidaksesi. Tämä sivu poistetaan pian."
  },
  "attribution": {
    "description": "Ensimmäinen vuorovaikutus on käyttäjän ensimmäinen kosketuspiste. Joten jos joku löysi sinut ensin maksullisen haun (PPC) mainoksen kautta, kyseinen kanava saa luottamuksen muuntamisesta. Toisaalta viimeinen vuorovaikutus olisi viimeinen kanava.",
    "firstInteraction": "Ensimmäinen viestintä",
    "lastInteraction": "Viimeisin vuorovaikutus",
    "title": "Attribuutio"
  },
  "campaign": {
    "addEvent": "Lisää tapahtuma",
    "a2p": {
      "address": {
        "chooseState": "Valitse osavaltio...",
        "city": "Kaupunki*",
        "postalCode": "Postinumero*",
        "streetAddress": "Katuosoite*",
        "streetAddressHelper": "On oltava yritykseesi linkitetty kelvollinen osoite.",
        "title": "Yrityksen osoite"
      },
      "addressError": {
        "title": "Osoitteen lähetys epäonnistui"
      },
      "authorizedRep": {
        "jobPosition": "Työtehtävä*",
        "jobTitle": "Työtehtävä*",
        "title": "Valtuutetun edustajan tiedot"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Yksinyrittäjäbrändi",
          "point1": "Vain yksi puhelinnumero on sallittu",
          "point2": "EIN/SSN/DUNS ei ole pakollinen"
        },
        "solePropCampaign": {
          "heading": "Yksinyrittäjäkampanja",
          "point1": "Yksinyrittäjäkampanjaan saa liittää vain yhden numeron.",
          "point2": "Hyväksynnän jälkeen oletusnumerosi linkitetään automaattisesti",
          "infoText": "Voit myös päivittää numeron hyväksynnän jälkeen",
          "warningText": "Yksityisyrittäjäkampanjaan saa liittää vain yhden numeron. Kun hyväksyntä on saatu, oletusnumero yhdistetään automaattisesti. Voit myös päivittää numeron hyväksynnän jälkeen."
        },
        "solePropSubtitle": "Yksinyrittäjäbränditaulujen ja kampanjatiedot",
        "standardBrand": {
          "heading": "4,41 $ – Kertaluonteinen",
          "point1": "EIN/SSN/DUNS vaaditaan",
          "point2": "Yli yksi puhelinnumero on sallittu"
        },
        "standardCampaign": {
          "heading": "16,54 $ - kertaluonteinen",
          "point1": "Vakiokampanjaan voi liittää useamman kuin yhden numeron.",
          "point2": "EIN/SSN/DUNS vaaditaan",
          "infoText": "TCR-sääntöjen mukaisesti sovelletaan kampanjan lisämaksua, joka on enintään 12 $ kuukaudessa."
        },
        "standardSubtitle": "Tavalliset brändin ja kampanjan tiedot",
        "title": "Brändin ja kampanjan tiedot"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Kontaktin tiedot",
          "contactInfoSubtitle": "Tämä voi olla kuka tahansa henkilö, joka voi tarvittaessa vastata kysymyksiin tästä brändistä. Huomaa, että kontakteja ei voi käyttää uudelleen eri brändien välillä. Jokaisella luomallasi brändillä on oltava yksilölliset kontaktitiedot.",
          "emailHelper": "Älä käytä samaa sähköpostiosoitetta yli viidelle brändille.",
          "phoneNumberHelper": "Älä käytä samaa puhelinnumeroa yli viidelle brändille.",
          "profileName": "Yrityksen nimi tai etu- ja sukunimesi*",
          "profileNameHelper": "Käytä joko viestejä lähettävän organisaation virallista nimeä tai omaa nimeäsi, jos tämä brändi ei ole organisaatiolle.",
          "nextLoading": "Seuraava...",
          "invalidPhoneNumber": "Virheellinen puhelinnumero",
          "phoneNumberWithCountryCode": "Puhelinnumero (sisältäen maakoodin) *",
          "phoneNumberRequired": "Puhelinnumero on pakollinen.",
          "emailRequired": "Sähköpostiosoite on pakollinen.",
          "profileNameRequired": "Profiilinimi on pakollinen."
        },
        "standard": {
          "businessType": "Yritystyyppi*",
          "legalBusinessName": "Yrityksen virallinen nimi*",
          "legalBusinessNameHelper": "Syötä tarkka yrityksen nimi, sellaisena kuin se on valtion rekisterissä ja mainittu veroasiakirjoissasi (CP 575). esim. Leadconnector LLC eikä Leadconnector.",
          "regionsOfOperations": "Liiketoiminnan toiminta-alueet*",
          "registrationNumber": "Yrityksen rekisteröintinumero*",
          "registrationNumberHelper": "Yrityksesi tunnistamiseen käytettävä numero. Yhdysvaltain EIN-tunnuksen on oltava 9-numeroinen luku, esim. 12-3456789.",
          "registrationType": "Yritysrekisteröinnin tunnuslaji*",
          "website": "Yrityksen verkkosivusto*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Vaihe {currentStep} / {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Yritysprofiilisi on lähetetty onnistuneesti.",
        "startA2P": "Aloita A2P-rekisteröinti",
        "title": "Yritysprofiili toimitettu onnistuneesti",
        "tooltips": {
          "agency": "Toimiston käyttäjät voivat aloittaa A2P-rekisteröinnin",
          "location": "Sijaintikäyttäjät voivat aloittaa A2P-rekisteröinnin"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Sulje esimerkki",
          "optInKeywords": "Suostumuksen avainsanat*",
          "optInKeywordsHelper": "Enimmäispituus: 255 merkkiä.",
          "optInKeywordsPlaceholder": "Avainsanat pilkuin eroteltuina, esimerkki: TILAA, ALOITA.",
          "optInMessage": "Suostumusviesti*",
          "optInMessageInfo": "Täytyy sisältää yrityksen nimen ja kieltäytymissanan",
          "optInMessagePlaceholder": "Esimerkki: Olet onnistuneesti valinnut vastaanottaa ilmoitus- ja mainosviestejä yritykseltä company_name. Vastaa STOP, jos haluat kieltäytyä näistä jatkossa.",
          "placeholder": "Esimerkki: loppukäyttäjät liittyvät käymällä osoitteessa https://www.mycompany.com/book ja täyttämällä yksityiskohdat. Käyttäjät valitsevat valintaruudun vastaanottaakseen ilmoituksia ja mainosviestejä meiltä ja antaakseen suostumuksensa. Lisäksi loppukäyttäjät voivat lähettää tekstiviestin START numeroon +1 (213) 725-2867.",
          "question": "Miten loppukäyttäjät antavat hyväksynnän viestien vastaanottamiseen?*",
          "seeExample": "Katso esimerkki"
        },
        "messageDetails": {
          "embeddedLink": "Viesti sisältää upotetun linkin",
          "phoneNumbers": "Viesteihin sisällytetään puhelinnumerot",
          "sampleMessage1Placeholder": "Esimerkki: Hei John! Tässä on Jane yrityksestä company_name. Tapaamisemme 20. heinäkuuta klo 11.00 on vahvistettu. Jos haluat siirtää tapaamistasi, soita numeroon +1(213) 725-2867. Voit peruuttaa tilauksen vastaamalla STOP.",
          "sampleMessage2Placeholder": "Malli: Hei Brian! Tässä on Jane yrityksestä company_name. Huomaan, että et päässyt tapaamiseemme. Haluaisitko siirtää ajanvarausta? - https://www.mycompany.com/book. Vasta STOP peruuttaaksesi tilauksen.",
          "sampleMessageInfo": "Tulee sisällyttää liidin nimen, oman nimesi, yrityksen nimen ja kieltäytymiskielen.",
          "subtitle": "Lisää malliviestejä"
        },
        "useCaseDetails": {
          "explainInDetail": "Selitä yksityiskohtaisesti",
          "pickUseCase": "Valitse kampanjan käyttötapaus",
          "solePropLabel": "Yksityisyrittäjä",
          "subtitle": "Syötä kampanjan yksityiskohdat ja kuvaus",
          "useCase": "Kampanjan käyttötapaus*",
          "useCaseDescription": "Käyttötapauksen kuvaus*",
          "useCaseDescriptionPlaceholder": "Esimerkki: tämä kampanja lähettää asiakkaillemme tapaamisetiedot – vahvistus- ja muistutusviestit – kun he ovat varanneet tapaamisen verkkosivustollamme ja suostuneet vastaanottamaan meiltä mainos- ja ilmoitusviestejä tekstiviestitse."
        }
      },
      "einModal": {
        "disableNoEINText": "Vain yritykset, joilla on voimassa oleva osoite Yhdysvalloissa tai Kanadassa, voivat rekisteröidä A2P-brändin ilman verotunnusta.",
        "hasEIN": "Kyllä, yrityksellä, jota rekisteröin, on verotunnus (esim. EIN, CCN jne.).",
        "infoText": "Löydät US EIN -numerosi CP 575 -lomakkeestasi.",
        "noEIN": "Ei, yrityksellä, jota rekisteröin, ei ole verotunnusta (esim. EIN, CCN jne.).",
        "question": "Onko rekisteröitävällä yrityksellä verotunnus (esim. EIN, CCN jne.)?*",
        "title": "Määritä A2P-bränditarpeet"
      },
      "exampleModal": {
        "examples": "Esimerkit"
      },
      "otpError": {
        "message": "Kertakäyttöisen salasanan lähettämisessä oli ongelma.",
        "title": "Kertakäyttöisen salasanan (OTP) uudelleenlähettäminen epäonnistui"
      },
      "otpSuccess": {
        "title": "Kertakäyttöinen salasanasi on lähetetty onnistuneesti."
      },
      "validation": {
        "cityRequired": "Kaupunki on pakollinen.",
        "countryRequired": "Maa on pakollinen.",
        "invalidMobileNumber": "Virheellinen matkapuhelinnumero",
        "postalCodeRequired": "Postinumero on pakollinen.",
        "stateRequired": "Osavaltio on pakollinen.",
        "streetAddressRequired": "Katuosoite on pakollinen."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Toimiston omistaja",
      "agencyOwnerAndAdmins": "Toimiston omistaja ja ylläpitäjät",
      "contactAgencyOwner": "Jos tarvitset apua, ota yhteyttä",
      "firstPromoterAccessMessage": "Tähän FirstPromoter-raporttiin pääsevät käsiksi vain",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Suodattimillasi ei löytynyt kumppania. Napsauta",
      "paymentDetailsAccessMessage": "Tämä maksutietojen osio on käytettävissä ja muokattavissa vain",
      "toApplyPartner": "hakeaksesi kumppaniksi."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "DOC"
      },
      "loading": "Ladataan",
      "legalBusinessNameHelper": "Syötä tarkka yrityksen nimi, sellaisena kuin se on valtion rekisterissä ja mainittu veroasiakirjoissasi (CP 575). esim. Leadconnector LLC eikä Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Napsauta <span class='font-semibold'>Avaa HighLevel</span> käynnistääksesi työpöytäsovelluksen.<br>Eikö se toimi? Voit myös <a href=\"/\" class='!text-blue-700 hover:underline'>käyttää HighLevel selaimessasi</a>",
        "launchingTitle": "HighLevel Desktopin käynnistäminen",
        "launchButtonText": "Avaa HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Napsauta <span class='font-semibold'>Avaa LeadConnector</span> käynnistääksesi työpöytäsovelluksen.<br>Eikö se toimi? Voit myös <a href=\"/\" class='!text-blue-700 hover:underline'>käyttää LeadConnector selaimessasi</a>",
        "launchingTitle": "LeadConnector Desktopin käynnistäminen",
        "launchButtonText": "Avaa LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Valitse toiminto",
        "destination": "Kohde",
        "removeFromAllCampaigns": "Tämä toiminta poistaa liidit kaikista kampanjoista, paitsi tämänhetkisestä kampanjasta.",
        "triggerLinks": "Triggerilinkit"
      },
      "importTemplate": {
        "errorImporting": "Virhe mallipohjan tuonnissa!",
        "importTemplate": "Tuo mallipohja",
        "importing": "Tuodaan",
        "title": "Tuo {entityName} -mallipohja",
        "unnamedEntity": "Nimetön {entityName} -kopio"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "alla",
          "confirmByTyping": "Vahvista kirjoittamalla",
          "confirmWord": "VAHVISTA",
          "existingNotMoved": "Jos asiakkaallasi on jo Mailgun- tai SMTP-määritykset, häntä ei siirretä",
          "notNow": "Ei nyt",
          "pricingInfo": "LC Email on halvempi kuin Mailgun ja maksaa noin 0,68 $ tuhatta sähköpostia kohden",
          "setAsDefault": "Aseta LC Email oletuspalveluntarjoajaksi toimistollesi ja asiakkaillesi, joilla ei vielä ole Mailgunia tai SMTP:tä.",
          "thisWill": "Tämä tulee:",
          "title": "Siiryt Lead Connector -sähköpostiin",
          "useLcEmail": "Käytä LC Emailia"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Vedä tai pudota media tähän",
        "editPost": "Muokkaa julkaisua",
        "enterText": "Kirjoita teksti tähän",
        "exampleComment": "Mahtavaa! Odotan tätä innolla!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Vaatiiko tarkastelua?",
        "network": "Verkko",
        "photo": "Valokuva",
        "previewPost": "Esikatselu julkaisua",
        "selectNetwork": "Valitse sosiaalinen verkosto",
        "sizeExample": "245 kt",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Olet luonut {count} numeron numeroryhmän verkkosivustosi kävijöiden seuraamiseksi. <br />Puhelusi siirretään numeroon",
          "createdSingle": "Olet luonut {count} numeroa verkkosivustosi kävijöiden seuraamiseksi. <br />Puhelusi siirretään numeroon",
          "percentComplete": "100 % valmis"
        },
        "create": {
          "correctErrors": "Korjaa virheet!",
          "forwardHelp": "Kerro meille, minkä puhelimen pitäisi soida, kun asiakas soittaa seurantapuhelinnumeroosi. Tämä on yleensä ensisijainen yrityksesi puhelinnumero. Esimerkki: 404-555-1212.",
          "heading": "Numeroryhmät ja soitonsiirto",
          "nameHelp": "Viittaamme nimellä '{name}' tähän seurantanumeroon tililläsi. Valitse lyhyt ja mieleenpainuva nimi.",
          "newTrackingNumbers": "uutta seurantanumeroa.",
          "nextTracking": "Seuraava: seurantavaihtoehdot",
          "percentComplete": "50 % valmis",
          "pleaseConfirm": "Vahvista:",
          "poolSize": "Ryhmän koko",
          "poolSizeError": "Syötä ryhmän kooksi 4–30 seurantanumeroa.",
          "poolSizeHelp": "Numeroryhmän koko määrittää, kuinka monta samanaikaista kävijää voimme seurata sivustollasi milloin tahansa. Ryhmäsi koko tulisi olla neljäsosa Google Analyticsin mukaisesta tuntikohtaisesta liikennemäärästä, ja siinä tulee olla vähintään 4 numeroa.",
          "swappingHelp": "Kerro meille, mikä puhelinnumero tulisi vaihtaa verkkosivustolla. Esimerkki: 404-555-1212.",
          "swappingNumber": "Numeron vaihto",
          "validationError": "Lomakkeen vahvistamisessa tapahtui virhe"
        },
        "features": {
          "activateNumber": "Aktivoi numero",
          "address": "{type} -osoite",
          "addressHelp": "Joissakin maissa numeron ostaminen edellyttää osoitetietoja. Ota yhteyttä asiakastukeen, jos tarvitset apua osoitteen lisäämisessä.",
          "heading": "Numeron ominaisuudet",
          "leaveBlank": "Jätä tyhjäksi, jos ei ole viestiä",
          "recordingDescription": "Aktivoi puhelutallennus ja toista lyhyt viesti soittajalle.",
          "recordingHelp": "Joillakin lainkäyttöalueilla vaaditaan molempien osapuolten hyväksyntä tallennettuun keskusteluun. Näiden lakien noudattamisen helpottamiseksi voit ottaa käyttöön tervetuloviestin, joka ilmoittaa soittajalle, että puhelu saatetaan nauhoittaa.",
          "whisperDescription": "Lyhyt viesti, joka toistetaan ennen puhelua. Soittaja ei kuule tätä viestiä."
        },
        "tracking": {
          "heading": "Seurantavaihtoehdot",
          "nextCreatePool": "Seuraava: Luo ryhmä",
          "percentComplete": "34 % valmis",
          "searchLower": "haku"
        },
        "whatToTrack": {
          "heading": "Mitä haluat seurata verkkosivustollasi?",
          "trackCampaign": "Seuraa markkinointikampanjaa",
          "trackCampaignDescription": "Luo yksi puhelinnumero, joka seuraa kaikkia soittajia yhdessä markkinointikampanjassa.",
          "trackVisitor": "Seuraa kävijöiden aktiivisuutta",
          "trackVisitorDescription": "Luo useita numeroita, jotka yhdistävät puhelut sivuston kävijöihin, PPC-avainsanoihin ja muihin tekijöihin."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "päivitä napsauttamalla tästä.",
      "issuesLoadingApp": "Jos sinulla on ongelmia sovelluksen lataamisessa.",
      "loadingFreshData": "Ladataan tuoreita tietoja...",
      "loadingNewSubAccountData": "Ladataan uutta alatilidataa..."
    },
    "login": {
      "bySigningInYouAgree": "Kirjautumalla sisään hyväksyt <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>käyttöehdot</a>",
      "newPasswordSent": "Uusi salasana lähetetään sähköpostiisi."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Ohi:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Kumppanimerkki"
        },
        "checkout": {
          "cardInformation": "Kortin tiedot",
          "cardNumberInvalid": "Korttinumerosi on virheellinen.",
          "commitment": "sitoutuminen",
          "consentOneTime": "Vahvistamalla annat LeadConnectorille luvan veloittaa korttiasi tästä maksusta.",
          "consentSubscription": "Vahvistamalla tilauksesi annat LeadConnectorille luvan veloittaa kortiltasi tämän maksun ja tämän tilauksen tulevat maksut.",
          "defaultIntervalCount": "1",
          "endingIn": "päättyy",
          "errorImageAlt": "Virheen kuva",
          "intervalSuffix": "(s)",
          "month": "Kuukausi",
          "pay": "Maksa",
          "payWithCard": "maksa kortilla",
          "paymentProcessing": "Maksua käsitellään. Älä lataa sivua uudelleen tai paina Takaisin-painiketta",
          "proceedWithExistingCard": "Jatka olemassa olevalla kortilla",
          "proceedWithNewCard": "Jatka uudella kortilla",
          "prorationDetails": "Sinulta veloitetaan nyt {days} päivää ajanjaksosta {billingEnd} asti, ja koko summa ${amount}/kuukausi alkaen {billingDate}.",
          "prorationMessage": "Alustavat veloitukset ovat suhteutettuja, ja säännöllinen laskutus alkaa {billingDate}",
          "purchase": "osto",
          "subscribe": "Tilaa",
          "subscribeTo": "Tilaa",
          "updateCardDetails": "Päivitä korttitiedot",
          "zip": "postinumero"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "Varapresidentti"
          }
        },
        "registration": {
          "stepProgress": "Vaihe {currentStep} / 8",
          "successDescription": "A2P-brändisi ja kampanjasi on lähetetty.",
          "successMessage": "Huomaa: Saat OTP-viestin antamaasi matkapuhelinnumeroon vahvistusta varten TCR:ltä. Vastaa Kyllä 24 tunnin kuluessa tekstiviestin vastaanottamisesta.",
          "successWaitDays": "seitsemän päivää",
          "successWaitPrefix": "Saattaa kestää jopa ",
          "successWaitSuffix": " brändin hyväksyntään ja kampanjan hyväksyntä kestää 4–5 viikkoa lisää."
        },
        "reminder": {
          "noReplyYet": "Ei vielä vastausta",
          "patientConfirmed": "Potilas vahvistettu"
        },
        "sendGrid": {
          "apiKeyRequired": "API-avain on pakollinen"
        },
        "update": {
          "brandNameHelper": "Käytä viestit lähettävän organisaation virallista nimeä.",
          "businessVerticals": "Toimialat*",
          "resendOTP": "Lähetä kertakäyttöinen salasana uudelleen",
          "retryOTPTitle": "Yritä OTP-vahvistusta uudelleen"
        }
      },
      "addCustomEmailModal": {
        "title": "Lisää mukautettu sähköposti"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Lisää palveluntarjoaja",
        "clickHereForInfo": "Napsauta tästä saadaksesi lisätietoja.",
        "clickHereToFindOut": "Napsauta tässä saadaksesi lisätietoja niistä.",
        "createProviderError": "Jokin meni pieleen palveluntarjoajan luomisessa!",
        "gmailLimitations": "Gmaililla on joitakin rajoituksia.",
        "needHelp": "Tarvitsetko apua SMTP-palvelimen ja portin numeron löytämisessä?",
        "port25NotSupported": "Portti 25 ei ole tuettu! Käytä sen sijaan porttia 2525",
        "providerExists": "Tällä sähköpostiosoitteella tai käyttäjätunnuksella on jo palveluntarjoaja.",
        "providerName": "Palveluntarjoajan nimi",
        "selectProvider": "Valitse palveluntarjoaja",
        "smtpPortNumber": "SMTP-portin numero",
        "smtpProvider": "SMTP-palveluntarjoaja",
        "smtpServer": "SMTP-palvelin",
        "username": "Käyttäjätunnus",
        "usernameOrEmailRequired": "Joko käyttäjätunnus tai sähköposti on pakollinen.",
        "verifySmtpAccount": "Vahvista SMTP-tili"
      },
      "addTagModal": {
        "addTag": "Lisää tagi",
        "editTag": "Muokkaa tagia",
        "tagAlreadyExists": "Tagi {tag} on jo olemassa"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Tähän FirstPromoter-raporttiin pääsevät käsiksi vain <strong>toimiston omistaja ja ylläpitäjät</strong>. Jos tarvitset apua, ota yhteyttä <strong>toimistosi omistajaan ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-raporttinäkymä",
        "noPartnersFound": "Suodattimillasi ei löytynyt kumppania. Napsauta <a href='javascript:void(0);'>tästä</a> hakeaksesi kumppaniksi.",
        "paymentDetailsAccessMessage": "Tähän maksutiedot-osioon pääsee käsiksi ja sitä voi muokata vain <strong>toimiston omistaja</strong>. Jos tarvitset apua, ota yhteyttä <strong>toimistosi omistajaan ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Tapaamisen tiedot"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Lataa tilannevedos:",
        "loadSnapshotWarning": "Haluatko ladata tähän suunnitelmaan liittyvän tilannevedoksen? <br /> <strong class='text-danger'>Tämänhetkiset tiedot voidaan menettää</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Vaihda salasana",
          "confirmPassword": "Vahvista uusi salasana",
          "expired": "Salasanan palautuslinkkisi on vanhentunut.",
          "regenerateLink": "Luo linkki uudelleen",
          "success": "Salasanan vaihtaminen onnistui",
          "title": "Määritä uusi salasana",
          "passwordMismatch": "Salasanat eivät täsmää"
        },
        "forgotPassword": {
          "contactAgency": "ota yhteyttä toimistoon.",
          "contactSupport": "ota yhteyttä HighLevel-tukipalveluun 24/7 soittamalla",
          "supportMessage": "Jos sinulla ei ole pääsyä kyseiseen sähköpostilaatikkoon, ole hyvä ja",
          "successMessage": "Salasanan vaihtolinkki on lähetetty sähköpostiosoitteeseesi.",
          "rateLimitError": "Liian monta salasanan vaihtopyyntöä. Yritä myöhemmin uudelleen."
        },
        "login": {
          "inactivityMsg": "Huomasimme, että olet ollut inaktiivinen jonkin aikaa, joten olemme kirjanneet sinut ulos turvallisuutesi varmistamiseksi.",
          "loginButton": "Kirjaudu sisään",
          "resetPasswordMsg": "Salasanan vaihto -linkki lähetetään sähköpostiisi.",
          "signInWithGoogle": "Kirjaudu sisään Google-tilillä",
          "contactHighLevelSupport": " ota yhteyttä HighLevel-tukipalveluun 24/7 soittamalla"
        },
        "logout": {
          "loggingOut": "Kirjaudutaan ulos..."
        },
        "otp": {
          "enterBackupCode": "Anna varakoodisi",
          "resend": "Lähetä uudelleen",
          "resendIn": "Lähetä uudelleen seuraavan ajan kuluttua",
          "sendToPhone": "Lähetä koodi puhelimeen",
          "sending": "Lähetetään",
          "useAuthenticator": "Käytä todennussovellusta",
          "useBackupCode": "Käytä varakoodia",
          "verifyButton": "Vahvista varakoodilla"
        },
        "sso": {
          "agreeTerms": "Kirjautumalla sisään hyväksyt <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Käyttöehdot</a>",
          "and": ", ja",
          "loginDifferentMethod": "Kirjaudu sisään eri menetelmällä",
          "loginSuccessRedirecting": "Sisäänkirjautuminen onnistui, ohjataan uudelleen...",
          "processing": "Käsitellään pyyntöäsi...",
          "redirecting": "Uudelleenohjataan...",
          "redirectingToDashboard": "Uudelleenohjaus kojelautaan...",
          "signedIn": "Kirjautunut sisään",
          "signingIn": "Kirjaudutaan sisään...",
          "testFailedRedirecting": "Testaus epäonnistui, uudelleenohjataan...",
          "testSuccessRedirecting": "Testaus onnistui, uudelleenohjaus käynnissä..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Yrityksen osoite: {address}",
        "businessDetailsText": "Seuraavat yritystiedot lähetetään Googlen Paikalliset palvelut -mainoksiin Varaa Google-integroinnilla. Tarkista ja vahvista tai {link} päivittääksesi yritysprofiilisi.",
        "businessInfoRequired": "Edellä mainitut yritystiedot ovat pakollisia integrointia varten, {link} päivittääksesi puuttuvat tai virheelliset tiedot.",
        "businessName": "Yrityksen nimi: {name}",
        "businessNiche": "Liiketoiminnan erikoisala: {niche}",
        "city": "Kaupunki: {city}",
        "confirmDetails": "Vahvistan, että yllä mainitut tiedot ovat oikeat",
        "country": "Maa: {country}",
        "mustConfirmDetails": "Sinun on vahvistettava edellä mainitut tiedot.",
        "phoneNumber": "Puhelinnumero: {phone}",
        "state": "Osavaltio: {state}",
        "zipCode": "Postinumero: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Lisää tunteja",
        "applyAll": "Sovella kaikki"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Vastaa puheluun ja anna tämä vahvistuskoodi:",
          "leadConnectorCalling": "Lead Connector soittaa...",
          "title": "Lisää soittajan tunnistetieto äänen mukaan",
          "waitingForVerification": "Odottaa vahvistusta..."
        },
        "callerIdVerificationStatus": {
          "failed": "Soittajan tunnistetiedon vahvistaminen epäonnistui. Yritä uudelleen.",
          "success": "Olet onnistuneesti vahvistanut <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Lisää olemassa olevat numerot",
          "areaCode": "Suuntanumero:",
          "checkAvailability": "Tarkista saatavuus",
          "checkingAvailability": "Tarkistetaan numeron saatavuus.",
          "chooseAreaCode": "Valitse suuntanumero",
          "choosePhoneNumbers": "Valitse puhelinnumero(t)",
          "goBack": "Palaa takaisin",
          "localNumbers": "Paikallinen {type}",
          "nextNumberFeatures": "Seuraava: Numero-ominaisuudet",
          "noExistingNumbers": "Ei olemassa olevia numeroita lisättäväksi",
          "noNumbersAvailable": "Numeroita ei ole saatavilla",
          "notEnoughNumbers": "Ei tarpeeksi numeroita saatavilla",
          "numbersAvailable": "Numerot saatavilla",
          "numbersDifferentArea": "Numerot eri suuntanumerolla",
          "numbersLocalTo": "Paikalliset numerot alueella <strong>{number}</strong>",
          "problemChecking": "Ongelma numeron saatavuuden tarkistamisessa. Tarkista verkkoyhteys tai ota yhteyttä tukeen.",
          "somethingWentWrong": "Jokin meni pieleen. Tarkista Twilio-tilisi tunnistetiedot ja ota yhteyttä tukeen, jos tämä jatkuu.",
          "tollFreeNumbers": "Ilmaisnumerot (2,00 $ lisämaksu per numero per kuukausi)",
          "percentageComplete": "67 % valmis"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Ymmärrän seuraukset, poista ryhmä",
          "confirmText": "Vahvista kirjoittamalla <b>{name}</b>",
          "title": "Poista NumberPool - <strong>{name}</strong>",
          "warning": "Tätä toimintoa ei voi kumota. Tämä poistaa numerot pysyvästi Twilio-tililtäsi sekä numeroryhmästä tietokannastamme. Jos poistat numeroryhmän ongelman takia, ota yhteyttä tukiryhmäämme."
        },
        "editNumberFormatModal": {
          "description": "Voit päivittää vaihtonumeroiden ja ryhmänumeroiden muotoilun mieltymyksesi mukaan. Varmista, että vaihtonumerot näkyvät sivustolla samoin kuin ne on muotoiltu.",
          "title": "Päivitä numeron muotoilu – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Lisää/muokkaa ryhmän tunnus",
          "callConnectTooltip": "Tämä ominaisuus edellyttää, että vastaanottajan on painettava näppäintä puhelun yhdistämiseksi, mikä parantaa puheluraportoinnin tarkkuutta.",
          "createGroupIdDescription": "Luo/lisää yksilöllinen ryhmätunnus, jos haluat käyttää useita numeroryhmiä yhdellä JavaScript-koodinpätkällä.",
          "enableCallConnect": "Ota käyttöön Puhelun yhdistäminen -ominaisuus",
          "groupId": "Ryhmän tunnus",
          "outboundCallTimeout": "Lähtevän puhelun aikakatkaisu",
          "passCallerID": "Välitä soitettu numero soittajan tunnistetiedoksi",
          "passCallerIDTooltip": "Oletuksena järjestelmä välittää soittajan numeron, mutta jos haluat, että soittajan tunnistetieto on soittajan valitsema numero, voit ottaa käyttöön tämän ominaisuuden.",
          "selectCallerID": "Valitse soittajan tunnistetieto",
          "timeDuration": "Kesto sekunteina",
          "titleNumber": "Numero – <strong>{number}</strong>",
          "updateWhisperWarning": "Päivitä kuiskausviesti, koska tämä ominaisuus edellyttää, että vastaanottaja painaa näppäintä puhelun yhdistämiseksi.",
          "useVerifiedNumber": "Käytä vahvistettua numeroasi soittajan tunnistetietona lähteville puheluille",
          "useVerifiedNumberTooltip": "Koskee ainoastaan vahvistettuja puhelinnumeroita. Voit vahvistaa puhelinnumeron kohdassa Asetukset > Puhelinnumerot > Lisää vahvistettu soittajan tunnistetieto"
        },
        "emailOTPModal": {
          "confirmCode": "Vahvista koodi",
          "resendCode": "Jos et saanut koodia, lähetä se uudelleen napsauttamalla tästä",
          "unexpectedIssue": "Odottamaton ongelma ilmeni"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Mukautetun kentän tiedot",
          "customFieldTooltip": "Mukautetun kentän työkaluvihje: {options}",
          "field": "{companyName} -kenttä",
          "trackingParameters": "Seurantaparametrit",
          "zipCode": "Postinumero"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Lisää vaihtonumerot",
          "addingSnippets": "JavaScript-katkelmien lisääminen",
          "groupSnippet": "Ryhmän \"{id}\" koodi",
          "normalSnippet": "Tavallinen katkelma",
          "noswapDescription": "Jos et halua meidän vaihtavan numeroa tietyssä paikassa, lisää luokka \"noswap\".",
          "notReplacing": "Ei korvata tietyssä sijainnissa",
          "requiredSteps": "Pakolliset vaiheet",
          "snippetsDescription": "Kopioi alla oleva katkelma ja lisää se sulkevan runkotunnisteen yläpuolelle jokaisella sivulla, jolla olevat numerot haluat korvata.",
          "swappingDescription": "Ota puhelinnumeron vaihto käyttöön alla olevilla numeroilla. Valitse paikallinen tai kansainvälinen muoto tai vaikka molemmat."
        },
        "newPhoneNumberModal": {
          "areaCode": "Suuntanumero",
          "availableNumbers": "Saatavilla olevat numerot",
          "bundle": "Paketti",
          "chooseAddress": "Valitse osoite...",
          "chooseBundle": "Valitse paketti...",
          "createRegulatory": "Luo säädösten mukainen paketti / osoite tässä.",
          "monthlyFee": "Kuukausittainen veloitus",
          "noNumbersFound": "Numeroita ei löytynyt, kokeile toista suuntanumeroa.",
          "selectAddress": "Osta numero valitsemalla \"Osoite\".",
          "selectBundle": "Osta numero valitsemalla \"Paketti\".",
          "title": "Lisää puhelinnumero",
          "upgradeAccount": "Päivitä Twilio-tilisi, sillä vain päivitetyt tilit voivat ostaa puhelinnumeroita ja soittaa puheluja",
          "cardAuthenticationFailed": "Kortin todennus epäonnistui!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Sinun on hyväksyttävä ehdot ja tietosuojaehto.",
          "clickingProceed": "Kun napsautat Jatka-painiketta, LSA-linkityssivu avautuu uuteen välilehteen.",
          "configureCalendar": "Määritä vähintään yksi kalenteri jatkaaksesi varausta Google-integroinnilla",
          "configureCalendarBtn": "Määritä kalenteri",
          "linkOneAccount": "Varmista, että linkität vain yhden tilin. Ota yhteyttä tukeen, jos et pysty näkemään yllä olevan kuvakaappauksen sivua.",
          "readInstructions": "Olen lukenut edellä mainitut ohjeet"
        },
        "updateTrackingModal": {
          "title": "Päivitä seurantavaihtoehto"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Tämä näkyy vain toimiston ylläpitäjille)",
          "updatedEvery24Hours": "(päivittyy 24 tunnin välein)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Kalenteria ei ole valittu synkronointia varten",
          "check": "Tarkista {email}",
          "checkForConflicts": "Tarkista ristiriitojen varalta",
          "checkForConflictsTooltip": "Määritä kalenteri(t), jotka tarkistetaan ristiriitojen varalta päällekkäisten varausten estämiseksi.",
          "contactCreationAllowed": "Kontaktien luominen sallittu",
          "googleCalendar": "Google-kalenterin logo",
          "noGoogleAccounts": "Integrointiasetuksiin ei ole vielä lisätty Google- tai Outlook-tilejä.",
          "noGoogleAccountsTeamMember": "Tälle tiimin jäsenelle ei ole lisätty Google-/Outlook-tilejä nykyisessä sijainnissa. Pyydä tiimisi jäsentä kirjautumaan sisään tilinsä kautta ja lisäämään Google-yhteys integrointiasetuksistaan.",
          "outlookCalendar": "Outlook UserCalendar",
          "primaryCalendarTooltip": "Määritä kalenteri, johon haluat lisätä uusia tapahtumia, kun niitä ajoitetaan.",
          "runTriggerAllowed": "Käynnistäminen sallittu"
        },
        "warningModal": {
          "contactAgency": "Ota yhteyttä toimistoosi muuttaaksesi sähköpostiasetuksia.",
          "title": "Varoitus"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Nopeampi ympärivuorokautinen chat-tuki",
            "faster247Ticket": "Nopeampi 24/7-tukipyyntöjen käsittely ja vastausaika"
          },
          "highlight": {
            "description": "Ymmärrämme, että sinun on edettävä nopeammin. Kun sinulla on kysymys tai huolenaihe, haluat siihen vastauksen mahdollisimman pian! Ensisijainen tuki ‑päivityksen avulla voit ohittaa jonon ja nopeuttaa pyyntöjesi käsittelyä automaattisesti niin, että ne siirtyvät jonon kärkeen.",
            "heading": "Oletko valmis VIP-kohteluun?"
          },
          "name": "Priority-tuki",
          "success": {
            "description": "Priority-tuki on aktivoitu tilillesi. Et joudu enää jonottamaan jonon hännillä.",
            "heading": "Olet nyt Priority-asiakas!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Kloonaa {entityName}",
        "cloning": "Kloonaus käynnissä...",
        "cloningLimit": "Kloonaus on rajoitettu kolmeen paikkaan kerrallaan",
        "error": "Virhe suppilon kloonauksessa!",
        "locationsLabel": "Valitse sijainnit",
        "nameLabel": "Nimi kloonatulle kohteelle {entityName}",
        "namePlaceholder": "Anna nimi kloonatulle kohteelle {entityName}",
        "selectUpTo": "Valitse enintään {maxSelectableLocations} sijaintia",
        "title": "Kloonaa {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "CNAMin avulla yrityksen nimi näkyy soittajan tunnistetiedossa, jolloin puhelusi ovat heti tunnistettavia ja luottamus kasvaa. Anna asiakkaasi tietää, että soittaja olet sinä.",
          "title": "Saa puhelusi erottumaan!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Vahvista ja rekisteröidy",
          "description": "Näytä yrityksesi nimi puhelun vastaanottajille lisätäksesi luottamusta ja parantaaksesi vastausprosenttia.",
          "title": "Paranna puhelun luotettavuutta CNAM:n avulla",
          "warning": "Yrityksen nimen näkyminen ei ole taattu, erityisesti mobiililaitteissa."
        },
        "submitted": {
          "checkStatus": "Tarkista CNAM-tila",
          "description": "Yrityksesi nimi tulee näkyviin sopiville kontakteille noin 3–5 päivän kuluessa.",
          "subtitle": "CNAM-pyyntösi on nyt lähetetty.",
          "title": "Onnittelut!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Vahvista poisto",
        "confirmation": "Vahvistus"
      },
      "createAddress": {
        "successTitle": "Osoite lähetetty onnistuneesti",
        "underReview": "Lähetetty osoite on tarkastettavana"
      },
      "createEndUser": {
        "dateFormat": "Päivämäärän tulee olla muodossa VVVV-KK-PP.",
        "phoneExample": " Esimerkki: +14155552671",
        "title": "Yrityksen tiedot:"
      },
      "customValueModal": {
        "changingNameWarning": "Nimen muuttaminen ei vaikuta kenttäavaimeen.",
        "editCustomValue": "Muokkaa mukautettua arvoa",
        "fieldKeyCreatedWarning": "Kenttäavain luodaan nimen perusteella, eikä sitä voi muuttaa myöhemmin.",
        "nameRequired": "Nimi-kenttä on pakollinen",
        "nameValidation": "Nimen tulee olla aakkosnumeerinen ja sisältää vähintään yksi merkki",
        "valueRequired": "Arvo-kenttä on pakollinen"
      },
      "details": {
        "addressName": "Osoitteen nimi",
        "addressTitle": "Osoitetiedot",
        "bundleName": "Paketin nimi",
        "bundleTitle": "Sääntelypaketin tiedot",
        "countryFlag": "{country} -lippu",
        "id": "Tunnus",
        "organisation": "Organisaatio",
        "rejectionReason": "Hylkäämisen syy",
        "status": {
          "approved": "Hyväksytty",
          "notValidated": "Ei ole vahvistettu",
          "rejected": "Hylätty",
          "validated": "Vahvistettu"
        },
        "typeOfNumber": "Numeron tyyppi"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Valitse toimisto",
        "whichOffice": "Minkä toimiston haluat liittää tähän tiliin?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Salli kontaktien luominen:",
        "allowTrigger": "Salli käynnistin:",
        "doNotSync": "Älä synkronoi uusia tapahtumia ensisijaiseen kalenteriin",
        "primaryCalendarTooltip": "Voit valita vain kalenterin, johon sinulla on kirjoitusoikeudet ja jota et ole valinnut ristiriitojen tarkistukseen.",
        "selectDefaultCalendar": "Valitse oletuskalenteri",
        "whichCalendar": "Mitä kalenteria meidän pitäisi käyttää tapahtumien synkronointiin (luku ja kirjoitus)?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Tarkista nämä paikat ristiriitojen varalta",
        "howToCheckConflicts": "Kuinka meidän tulisi tarkistaa ristiriidat?"
      },
      "ejectModal": {
        "agencyClosing": "Elite Marketing -toimiston tili Highlevelissä suljetaan. Jos haluat säilyttää tilisi, ota yhteyttä käyttäjään {userName} siirtääksesi tilisi suoraan Highleveliin.",
        "cancelWarning": "Huomaa, että tilisi peruutetaan virallisesti 30. kesäkuuta 2025, eikä tietojasi voida palauttaa tämän päivämäärän jälkeen, jos siirtoa ei ole suoritettu loppuun.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Jos sinulla on kysyttävää, ota meihin yhteyttä osoitteessa",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Tukeaksemme sinua tämän ilmaisen siirtymävaiheen aikana, myönnämme sinulle {months} ilmaisen käyttöoikeuden uuteen tilaukseesi.",
        "intro": "Toistuvien HighLevelin käyttöehtojen rikkomusten vuoksi Elite Marketing Authority (EMA) on pysyvästi poistettu HighLevel-ympäristöstä.",
        "platformCommitment": "EMA:n palveluja tukevana alustana HighLevel on sitoutunut ylläpitämään turvallista, vaatimustenmukaista ja luotettavaa ympäristöä kaikille käyttäjille. Jotta tilisi toiminta ei häiriinny, autamme sinua siirtymään saumattomasti joko toiseen white label -palveluntarjoajaan tai suoraan HighLeveliin.",
        "questions": "Jos sinulla on kysyttävää,",
        "retainAccess": "Jos haluat säilyttää pääsyn nykyisiin tietoihisi ja työkaluihisi, napsauta alla olevaa painiketta ja seuraa ohjeita siirron aloittamiseksi.",
        "speakWithTeam": "keskustellaksesi ryhmämme kanssa.",
        "startTransfer": "Aloita Ilmainen siirto",
        "title": "Huomio Elite Marketing -asiakkaat",
        "viewFaqs": "Katso usein kysytyt kysymykset täältä:",
        "whiteLabel": "Jos haluat käyttää HighLevelia toisen white label -palveluntarjoajan kautta, voimme mielellämme toteuttaa tämän muutoksen tukipalvelujärjestelmämme kautta, kun olet siirtänyt tilisi suoraan HighLevel-palveluun."
      },
      "emailTemplate": {
        "createdOn": "Luotu",
        "updatedOn": "Päivitetty"
      },
      "error": {
        "title": "Sääntelypaketin lähetys on epäonnistunut"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Useammalla kuin yhdellä sivulla on tämä URL-osoite, muuta tämän sivun reittiä, jotta se toimii.",
          "urlNotFound": "Valitettavasti emme voi löytää etsimääsi URL-osoitetta"
        },
        "productRebilling": {
          "requestFailed": "Pyyntö epäonnistui"
        },
        "template": {
          "categoryNotFound": "Valitettavasti kategoriaa ei löytynyt.",
          "internalError": "Sisäinen virhe ilmeni!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Alatili, jota yrität siirtää, on HIPAA-yhteensopiva, eikä sitä voi siirtää muuhun kuin HIPAA-toimistoon."
          },
          "limitExceeded": {
            "message": "Toimistonäkymä, jolle yrität siirtää alatiliä, on käyttänyt käyttörajansa loppuun eikä voi saada lisää alatilejä.  Pyydä heitä ystävällisesti joko poistamaan käyttämätön alatili tai päivittämään korkeampaan toimisto-suunnitelmaan saadaksesi tämän alatilin."
          },
          "pendingRequest": {
            "heading": "Tämän alatilin siirtopyyntö on jo vireillä.",
            "message": "Peruuta tämän alatilin jo olemassa oleva siirtopyyntö ennen kuin jatkat uuden siirtopyynnön tekemistä."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Eikö löydä etsimääsi sivua? Käy Facebook-asetuksissasi ja varmista, että kaikki sivut on valittu.",
        "instagramAvailable": "Instagram on saatavilla tälle tilille!",
        "noPages": "Sinulla ei ole yhtään sivua tällä tilillä.",
        "title": "Valitse, minkä Facebook-sivun haluat linkittää tähän sijaintiin."
      },
      "googleLocationSelect": {
        "closeButton": "Sulje!",
        "enableCallTracking": "Ota GBP-puheluiden seuranta käyttöön",
        "noBusinesses": "Sinulla ei ole yhtään yhdistettyä yritystä tällä tilillä."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Tehokkaampi",
          "faster": "Nopeampi",
          "itsText": "Se on",
          "smoother": "Tasaisempi",
          "title": "Uusi tuontikokemus on täällä!",
          "warningMessage": "Uuden tuontikokemuksen käyttöönotto aktivoi Labsin tälle alatilille ja ottaa käyttöön beetaominaisuuden."
        },
        "validateEmails": "Vahvistetaanko sähköpostit?"
      },
      "initBundle": {
        "numberType": "Numeroiden tyyppi, joita suunnittelit käyttäväsi",
        "numberTypes": {
          "local": "Paikalliset numerot",
          "mobile": "Mobiili",
          "tollfree": "Ilmaisnumero"
        },
        "selectCountry": "Valitse maasi",
        "selectUserType": "Valitse käyttäjätyyppi",
        "userTypes": {
          "business": "Yritys",
          "individual": "Yksilö"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Luotto viimeksi lisätty:",
        "currentBalance": "Tämänhetkinen saldo",
        "debitBalance": "- Debit-saldo",
        "depositComplimentaryCreditsOf": "Talleta ilmaisia krediittejä, joiden arvo on",
        "manageBalance": "Hallinnoi saldoa",
        "mustBeValidInteger": "Sen on oltava kelvollinen kokonaisluku",
        "nextDate": "Seuraava päivämäärä:",
        "perMonth": "kuukaudessa",
        "remainingWalletBalance": "Tämän alatilin jäljellä oleva lompakon saldo",
        "rolloverCredits": "Krediittien siirtäminen seuraavaan kuukauteen",
        "toManageMonthlyCredits": "Kuukausittaisten luottojen hallinnointi,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Lisää uusi tilaus"
      },
      "manualActions": {
        "confirmDelete": "Haluatko varmasti poistaa tämän toiminnon?",
        "confirmDeleteAll": "Haluatko varmasti poistaa kaikki tämän sivun manuaaliset toiminnot?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Luo vahva salasana",
          "sendEmailNotification": "Lähetä myös sähköposti-ilmoitus."
        }
      },
      "modal": {
        "description": "Sinun täytyy suorittaa muutama yksinkertainen vaatimustenmukaisuusvaihe käyttääksesi puhelinjärjestelmiä",
        "submit": "Lähetä",
        "title": "Lead Connectorin puhelinpalvelu"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Kotisivun vierailijat",
          "launched": "Lanseerattu",
          "newNotification": "Uusi ilmoitus",
          "startMessage": "Aloita konversioiden parantaminen luomalla ensimmäinen ilmoituksesi",
          "types": {
            "combination": "Yhdistelmä"
          }
        },
        "page": {
          "createTitle": "Luo uusi ilmoitus",
          "steps": {
            "display": "Näyttö",
            "track": "Seuranta"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Lisätiedot",
          "calendarEvent": "Kalenteritapahtuma",
          "hideAssignedTo": "Piilota määrityksen saaja",
          "hideTags": "Piilota tagit"
        },
        "filters": {
          "dateAddedAsc": "↑ Lisäämispäivä (NOUSEVA)",
          "dateAddedDesc": "↓ Lisäämispäivä (LASKEVA)",
          "orderBy": "Järjestä"
        },
        "getStarted": "Aloita!",
        "noPipelines": "Hups! Prosesseja ei näytä vielä olevan. Luo uusi prosessi, jotta voit"
      },
      "pages": {
        "pageMoved": {
          "title": "Online-listaukset ovat siirtyneet"
        }
      },
      "recentlyVisited": {
        "prices": "{count} hinnat"
      },
      "reminders": {
        "appointmentReminders": "Tapaamisen muistutukset",
        "apptTime": "Tapaamisen aika",
        "defaultDateRange": "su 1.4.2018 – ma 30.4.2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "Pidossa",
        "rebillingOnHoldWarning": "Tällä tilillä on jo uudelleenlaskutusasetukset pidossa. SaaS-tilaus voidaan liittää vasta, kun asiakas on lisännyt maksutavan.",
        "subscriptionId": "Tilaustunnus:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Vahvista ja jatka",
        "documents": {
          "acceptedDocuments": "Hyväksytyt asiakirjat",
          "acceptedDocumentsLabel": "Hyväksytyt tiedostot:",
          "additionalInfo": "Lisätietoja:",
          "createAddressLink": "Luo osoite.",
          "createAddressPrompt": "Luo ensin osoite ja jatka sitten paketin luomista.",
          "documentInfo": "PNG, JPG, PDF, enintään 5 Mt.",
          "documentType": "Asiakirjatyyppi",
          "option": "Vaihtoehto {number}",
          "selectAddress": "Valitse osoite:",
          "selectDocumentType": "Valitse asiakirjatyyppi:",
          "selectFile": "Valitse tiedosto",
          "title": "Pakolliset asiakirjat:",
          "updateDocuments": "Päivitä asiakirjat"
        },
        "everythingIn": "Kaikki suunnitelmassa <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "Lisää luottokortti tähän",
          "message": "Pyydä asiakasta",
          "title": "Sijainnin on ensin lisättävä maksutapa."
        },
        "noSaasPlan": {
          "linkText": "Luo SaaS-suunnitelmasi tässä.",
          "message": "Ole hyvä",
          "title": "Sinulla ei ole määritettyä SaaS-palvelupakettia."
        },
        "saasModeSetupPendingWarning": "SaaS-tilaus aktivoidaan, kun asiakas on lisännyt maksutavan. Tilin käyttö estetään siihen asti.",
        "skipForNow": "Ohita nyt",
        "skipPlan": "Ohita tilaustyyppi",
        "success": {
          "title": "Sääntelypaketti on lähetetty onnistuneesti",
          "underReview": "Lähetetty paketti on tarkastettavana"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Tämä vaihtoehto lisää uuden osoitteen tiliisi",
          "label": "Osoitepaketti"
        },
        "regulatoryBundle": {
          "description": "Tämä vaihtoehto auttaa sinua luomaan uuden sääntelypaketin",
          "label": "Sääntelypaketti"
        },
        "title": "Valitse, minkä paketin haluat lisätä"
      },
      "settings": {
        "billing": "Laskutus",
        "calendars": "Kalenterit",
        "customEmails": "Mukautetut sähköpostiosoitteet",
        "domains": "Verkkotunnukset",
        "domainsAndUrlRedirects": "Verkkotunnukset ja URL-uudelleenohjaukset",
        "facebookFormFieldsMapping": "Facebook-lomakekenttien kartoitus",
        "groups": "Ryhmät",
        "integrations": "Integroinnit",
        "labs": "Laboratoriot",
        "media": "Media",
        "noShowSMS": "Ilmestymättä jääminen -tekstiviesti",
        "pipelines": "Prosessit",
        "profile": "Profiili",
        "smtpAndMailGunService": "SMTP- ja MailGun-palvelu",
        "templates": "Mallipohjat",
        "urlRedirects": "URL-uudelleenohjaukset"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Puhelusi on nyt vahvistettu!"
        },
        "modal": {
          "andThe": " ja ",
          "certification": "Vakuutan, että liitetty yritysprofiili on puheluiden alkuperä ja vakuutan, että liityn jäljitystoimiin, mukaan lukien ne, jotka on käynnistetty",
          "failedTitle": "Lähetys epäonnistui",
          "friendlyNamePlaceholder": "Esim. SHST 24.11.2022 klo 19.47.14",
          "linkInfo": {
            "description": "Kaikki tämänhetkiset saatavilla olevat numerot ja tulevaisuudessa ostettavat numerot rekisteröidään automaattisesti SHAKEN/STIR:illä.",
            "title": "Kaikki numerot linkitetään automaattisesti"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Anna yksityiskohdat ja kuvaus",
          "successMessage": "SHAKEN/STIR-rekisteröintipyyntösi on lähetetty. Hyväksytyksi tuleminen voi kestää jopa <b>3–4 päivää</b>. Tila päivitetään pian.",
          "successTitle": "SHAKEN/STIR luotettu soittaminen käytössä.",
          "title": "Ota käyttöön SHAKEN/STIR luotettu soittaminen",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Haluatko mennä askeleen pidemmälle? Näytä yrityksen nimi puheluissa CNAM:n avulla.",
          "registerCnam": "Rekisteröidy CNAM:iin",
          "title": "Rakenna asiakasluottamusta ja lisää puheluihin vastauksen prosenttia"
        },
        "successMessage": "SHAKEN/STIR-rekisteröintipyyntösi on lähetetty. Hyväksytyksi tuleminen voi kestää jopa <b>3–4 päivää</b>. Tila päivitetään pian."
      },
      "shopify": {
        "selectLocation": "Valitse, mihin sijaintiin haluat linkittää tämän Shopify-kaupan"
      },
      "signup": {
        "accountType": "Tilin tyyppi",
        "agencyProAccount": "Agency Pro -tili (497 $/kuukausi)",
        "agencyTestAccount": "Toimiston testitili",
        "freeTrialMessage": "Hanki 14 päivän <strong>ilmainen</strong> kokeilu rekisteröitymällä juuri nyt.",
        "freelancerAccount": "Freelancer-tili (297 $/kuukausi)",
        "getStartedForFree": "Aloita ilmaiseksi!",
        "pickPassword": "Valitse salasana",
        "signUp": "Rekisteröidy",
        "starterAccount": "Aloitustili (97 $/kuukausi)",
        "termsAndConditions": "Rekisteröitymällä hyväksyt <a href='https://www.gohighlevel.com/privacy' target='_blank'>käyttöehdot</a>",
        "yourCompanyName": "Yrityksesi nimi",
        "yourFullName": "Koko nimesi"
      },
      "standardPlan": {
        "description": "Meillä on seuraavat suunnitelmat tavallisille brändirekisteröinneille.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN-tunnus on pakollinen rekisteröintiä varten",
            "moreThan1Phone": "Yli yksi puhelinnumero on sallittu"
          },
          "highVolume": {
            "heading": "Suuren volyymin tavallinen",
            "point3": "Jopa 600 000 segmenttiä päivässä",
            "infoText": "Brändin ja kampanjan rekisteröinnistä veloitetaan kertaluontoisesti 20,95 $. TCR-sääntöjen mukaisesti sovelletaan kampanjan lisämaksua, joka on enintään 2,25 $ kuukaudessa.",
            "point2": "Voit lähettää jopa 3 000 segmenttiä päivässä",
            "point1": "EIN-tunnus on pakollinen rekisteröintiä varten"
          },
          "lowVolume": {
            "heading": "Matalan volyymin tavallinen",
            "recommended": "Suositeltu",
            "point3": "Jopa 6 000 segmenttiä päivässä",
            "infoText": "Brändin ja kampanjan rekisteröinnistä veloitetaan kertaluontoisesti 20,95 $. TCR-sääntöjen mukaisesti sovelletaan kampanjan lisämaksua, joka on enintään 2,25 $ kuukaudessa.",
            "point2": "Voit lähettää jopa 3 000 segmenttiä päivässä",
            "point1": "EIN-tunnus on pakollinen rekisteröintiä varten"
          }
        },
        "title": "Valitse tavallinen brändisuunnitelmasi"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Varaustiedot",
          "form": "Lomake",
          "quiz": "Tietovisa",
          "submissionDetail": "Lähetyksen tiedot",
          "survey": "Kysely"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Vain toimiston järjestelmänvalvojilla/käyttäjillä on pääsy tälle alatilille. Tällä hetkellä sinulla ja muilla tilin järjestelmänvalvojilla/käyttäjillä ei ole pääsyä tälle alatilille.",
          "heading": "Tämä alatili on keskeytetty."
        },
        "temporarily": {
          "description": "Kaikki tietosi ovat turvassa, ja kaikki käynnistimet, kampanjat jne. ovat taas käytössä aktivoinnin jälkeen.",
          "heading": " Tilisi on väliaikaisesti keskeytetty."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Käytä vain määrittämättömiin kontakteihin",
          "splitTraffic": "Jaa liikennettä",
          "trafficWeightage": "Liikenteen painotus",
          "userRequired": "Käyttäjä pitää valita",
          "weightage": "Painotus"
        },
        "birthdayFilters": {
          "afterDays": "Päivien lukumäärän jälkeen",
          "beforeDays": "Ennen tiettyjen päivien määrää",
          "dayIs": "Päivä on",
          "daysInNumber": "Päivien määrä",
          "hasTag": "Sisältää tagin",
          "monthIs": "Kuukausi on",
          "selectDay": "Valitse päivä",
          "selectMonth": "Valitse kuukausi"
        },
        "botConversation": {
          "enterTimeout": "Aseta aikakatkaisu (tuntia)",
          "selectEliza": "Valitse Eliza.",
          "selectThankyouTemplate": "Valitse kiitos-mallipohja",
          "selectWelcomeTemplate": "Valitse Tervetuloa-mallipohja"
        },
        "contactField": {
          "addField": "Lisää kenttiä",
          "defineFilters": "Määritä suodattimet"
        },
        "copyModal": {
          "title": "Kopioi käynnistin"
        },
        "detailModal": {
          "actionsPerform": "Mitä toimintoja meidän tulisi suorittaa?",
          "campaignNameRequired": "Kampanjan nimi -kenttä on pakollinen",
          "campaignsDeprecation": "Kampanjoita ei enää ylläpidetä. Tasaisen siirtymän varmistamiseksi muunna tämänhetkiset kampanjasi työnkuluiksi.",
          "folderName": "Kansion nimi",
          "mustSelectFolder": "Kansio on valittava.",
          "newFolderName": "Uuden kansion nimi",
          "selectFolder": "Valitse kansio",
          "triggerNameRequired": "Trigger-nimen kenttä on pakollinen",
          "triggersDeprecation": "Käynnistimiä ei enää ylläpidetä. Sujuvan siirtymän varmistamiseksi muunna tämänhetkiset käynnistimesi työnkuluiksi.",
          "triggerName": "Käynnistimen nimi"
        },
        "dnd": {
          "disableAll": "Poista DND käytöstä kaikilta kanavilta",
          "disableSpecific": "Poista DND käytöstä tietyillä kanavilla",
          "enableAll": "Ota DND käyttöön kaikilla kanavilla",
          "enableSpecific": "Ota DND käyttöön tietyillä kanavilla",
          "selectAction": "Valitse toiminto"
        },
        "email": {
          "sendTestEmail": "Lähetä testisähköposti",
          "smtpWarning": "SMTP-palveluntarjoajilla on joitain rajoituksia. Napsauta tätä saadaksesi lisätietoja."
        },
        "facebook": {
          "avatarAlt": "Facebook-avatar",
          "selectCustomAudience": "Valitse mukautettu yleisö"
        },
        "googleAds": {
          "conversionName": "Konversion nimi",
          "conversionTooltip": "Konversion lähteen tulisi olla Tuo napsautuksista ja kategorian tulisi olla Tuotu liidi tai Liidi",
          "noConversions": "Ei konversioaste löytynyt",
          "selectConversion": "Valitse muuntaminen"
        },
        "googleAnalytics": {
          "eventAction": "Tapahtuman toiminta",
          "eventActionRequired": "Tapahtuma toiminta on pakollinen.",
          "eventCategory": "Tapahtuman kategoria",
          "eventCategoryRequired": "Tapahtuman kategoria on pakollinen.",
          "eventLabel": "Tapahtuman tunniste",
          "eventValue": "Tapahtuman arvo",
          "hitType": "Osumatyyppi",
          "hitTypeRequired": "Osumatyyppi on pakollinen",
          "trackingId": "Seurantatunnus",
          "trackingIdRequired": "Seurantatunnus on pakollinen."
        },
        "membershipOffer": {
          "selectOffer": "Valitse tarjous"
        },
        "notification": {
          "selectRedirectPage": "Valitse uudelleenohjaussivu.",
          "selectUser": "Valitse käyttäjä",
          "selectUserType": "Valitse käyttäjätyyppi"
        },
        "sms": {
          "sendTestSMS": "Lähetä testi-SMS"
        },
        "stripeCharge": {
          "customerId": "Stripen asiakastunnus",
          "enterAmount": "Anna summa",
          "selectCurrency": "Valitse valuutta"
        },
        "webhook": {
          "webhookUrl": "Webhook URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Toimintapäivämäärä",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Pro-sopimuksen tehneet toimistot ansaitsevat noin 363 dollaria kuukaudessa laskuttamalla puhelinkustannukset asiakkailtaan.",
          "title": "Haluatko laskuttaa tämän uudelleen asiakkaillesi?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Profiilisi lähettäminen epäonnistui."
        },
        "success": {
          "message": "A2P-brändisi ja kampanjasi on lähetetty.<br/><br/><b>Huomaa:</b> Saat <b>OTP-viestin antamaasi matkapuhelinnumeroon tarkistettavaksi</b> TCR:ltä. Vastaa <b>Kyllä 24 tunnin kuluessa</b> tekstiviestin vastaanottamisesta."
        }
      },
      "usageLimit": {
        "contactLimit": "Kontaktirajoitus",
        "maxContactsAllowed": "Alatilillä sallittujen kontaktien enimmäismäärä",
        "maxUsersAllowed": "Alatilillä sallittujen käyttäjien enimmäismäärä",
        "unlimited": "Ei rajoitusta",
        "usageLimits": "Käyttörajoitukset",
        "userLimit": "Käyttäjärajoitus",
        "userLimitHelpMessage": "Vain alitilin tason käyttäjät lasketaan mukaan tähän rajoitukseen. Voit silti lisätä alatileille niin monta toimiston käyttäjää kuin tarvitset."
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Hyväksyn listausten käyttöönoton tälle asiakkaalle ilman lisämyyntiä ja vahvistan, että minulta veloitetaan",
          "deployDirectly": "Ota listaukset käyttöön suoraan",
          "deployDirectlyDesc": "Käytä tätä vaihtoehtoa, jos tarjoat listauksia osana tarjoustasi tai jos haluat laskuttaa asiakastasi ulkoisesti.",
          "minimumCommitment": "Vähintään yhden kuukauden sitoumusjakso.",
          "offerListings": "Tarjouslistaukset",
          "resellListings": "Myy listauksia uudelleen",
          "subscribedInfo": "{withoutUpsell} Ilman lisämyyntiä, {withUpsell} lisämyynnillä ja {withSaas} Saas-paketilla",
          "subscriptionCreated": "Tilaus on luotu. Odota...",
          "subscriptionCreating": "Tilausta luodaan.<br/>Älä lataa sivua uudelleen tai paina Takaisin-painiketta",
          "unableToCreate": "Tilausta ei voi luoda, ota yhteyttä tukeen",
          "unavailabilityForAgencyAdmin": "Yext ei ole saatavilla tässä maassa. Jos uskot, että kyseessä on virhe, pyydä sitä etenemissuunnitelmassamme kohteessa",
          "yourResellOffer": "Uudelleenmyyntitarjouksesi"
        }
      },
      "selectCountry": "Valitse maasi",
      "documents": {
        "additionalInfo": "Lisätiedot",
        "createAddressLink": "Luo osoite.",
        "createAddressPrompt": "Luo ensin osoite ja jatka sitten paketin luomista.",
        "selectAddress": "Valitse osoite:"
      }
    },
    "triggers": {
      "emptyTrigger": "Tyhjä käynnistin"
    },
    "util": {
      "addFiles": "+ Lisää tiedostoja",
      "fillValues": "Täytä arvot",
      "image": "img",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Kirjoita {consentString} yläpuolelle tai peruuta tämä toiminto.",
      "pressEnterToAddCustomOption": "Paina Enter lisätäksesi mukautetun vaihtoehdon",
      "required": "* vaaditaan",
      "unsaved": "Tallentamaton"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Voit ottaa työnkulun käyttöön tietyssä sijainnissa siirtymällä Tilit-välilehdelle, napsauttamalla alatilin oikealla puolella olevaa kolmen pisteen kuvaketta ja valitsemalla <strong>Ota työnkulkujen suunnittelutyökalu käyttöön</strong>. Tämä prosessi on väliaikainen, sillä työnkulut otetaan käyttöön kaikissa sijainneissa seuraavalla viikolla."
      },
      "faq": "FAQ",
      "gotIt": "Selvä",
      "workflowIsLive": "Työnkulku on livenä tililläsi!"
    },
    "action": {
      "stats": {
        "bounced": "Palautunut",
        "clicked": "Napsautettu",
        "delivered": "Toimitettu",
        "opened": "Avattu",
        "replied": "Vastattu",
        "unsubscribed": "Tilaus peruutettu",
        "total": "Yhteensä",
        "failed": "Epäonnistunut"
      },
      "actions": {
        "edit": "Muokkaa",
        "send": "Lähetä",
        "remove": "Poista"
      },
      "timing": {
        "days": "Päivät",
        "immediately": "Heti",
        "before": "Ennen",
        "after": "Jälkeen",
        "minutes": "Minuutit",
        "hours": "Tunnit"
      },
      "labels": {
        "template": "Mallipohja",
        "manual": "Manuaalinen"
      },
      "details": {
        "hideDetail": "Piilota tiedot",
        "showDetail": "Näytä tiedot"
      },
      "queue": {
        "people": "henkilöä",
        "person": "Yksilöllinen",
        "queued": "jonossa"
      },
      "tooltips": {
        "clickedHelp": "Klikkausseurannan tarkkuus saattaa vaihdella sähköpostiohjelman ja käyttäjäasetusten perusteella.",
        "statsAccuracy": "Tilastojen tarkkuus saattaa vaihdella sähköpostiohjelman ja käyttäjäasetusten perusteella."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Haluatko varmasti poistaa tämän massapyynnön?",
        "startImmediately": "Aloita heti"
      },
      "modal": {
        "contactTypes": {
          "all": "Kaikki",
          "leads": "Liidit",
          "customers": "Asiakkaat"
        },
        "buttons": {
          "cancel": "Peruuta",
          "update": "Päivitä",
          "add": "Lisää"
        },
        "labels": {
          "name": "Nimi",
          "contactType": "Kontaktin tyyppi",
          "campaign": "Kampanja",
          "scheduledDate": "Aikataulun mukainen päivämäärä",
          "tag": "Tagi"
        },
        "placeholders": {
          "tags": "Tagit",
          "selectCampaign": "Valitse kampanja",
          "pickType": "Valitse tyyppi"
        },
        "sections": {
          "bulkRequest": "Massapyyntö",
          "whoShouldRun": "Kenelle se pitäisi suorittaa?"
        },
        "titleAdd": "Lisää massapyyntö",
        "titleEdit": "Muokkaa massapyyntöjä",
        "validation": {
          "scheduledDateRequired": "Ajoitettu päivämäärä on pakollinen"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Laajenna"
    },
    "list": {
      "confirmDeleteFolder": "Vahvista kansion poistaminen",
      "delete": "Poista",
      "confirmDelete": "Haluatko varmasti poistaa tämän kampanjan?",
      "moveToFolder": "Siirrä kansioon",
      "pleaseRename": "nimeä uudelleen",
      "removeFromFolder": "Poista kansiosta"
    },
    "copy": {
      "title": "Kopioi kampanja",
      "newCampaignName": "Uusi kampanjan nimi",
      "locations": "Sijainnit"
    }
  },
  "compliance": {
    "findOutMore": "Lisätietoja",
    "gdprDescription": "Suhtaudumme sinun ja asiakkaidesi henkilötietojen suojaamiseen erittäin vakavasti ja käsittelemme henkilötietoja erittäin luottamuksellisesti sekä lakisääteisten tietosuojasäännösten että tämän tietosuojaselosteen mukaisesti.",
    "gdprTitle": "GDPR-vaatimustenmukaisuus",
    "hipaaDescription": "Aktivoi tietoturvapäivitykset varmistaaksesi, että HighLevel-tilisi tiedot ovat turvassa ja täyttävät HIPAA-vaatimukset.",
    "hipaaTitle": "HIPAA-vaatimustenmukaisuus"
  },
  "customValues": {
    "key": "Avain",
    "selectedItemsCountSingular": "{count} rivi valittu",
    "selectedItemsCountPlural": "{count} riviä valittu"
  },
  "facebookAdFields": {
    "checkIcon": "Lomake kartoitettu onnistuneesti",
    "errorMessage": "Sivun käyttöoikeustunnus on vanhentunut tai sillä ei ole riittäviä käyttöoikeuksia. Varmista, että sinulla on sivujen ylläpitäjän oikeudet."
  },
  "fbLeadSync": {
    "confirmTitle": "Tallennetaanko Facebook-liidien synkronointi?",
    "impactMessage": "Ymmärrä Facebook-liidien synkronoinnin vaikutukset ennen kuin jatkat:",
    "observations": "– Tämä synkronoi Facebook-liidit ja luo uusia kontakteja jokaiselle liidille, joka on luotu viimeisen {days} päivän aikana eikä ole kontakteissasi. <br>2. Jos olet tuonut manuaalisesti puuttuvia liidejä käyttämällä Facebook Ad Managerista vietyä CSV-tiedostoa, poista käytöstä &quot;Salli päällekkäiset kontaktit&quot; estääksesi synkronoinnin luomasta päällekkäisiä kontakteja. <br>3. Jos sinulla on työnkulkuja, jotka käynnistyvät toiminnon <b>Kontaktin luominen</b> tai <b>Facebookin liidilomake lähetetty</b>, ne käynnistyvät jokaiselle uudelle luodulle kontaktille. <br>4. Facebook-liidien kautta luodut olemassa olevat yhteystiedot eivät muutu. <br>5. Tietueessa oleva kontaktin luomisaika on tämänhetkinen aika. <br>6. Synkronointi voi kestää jopa tunnin, riippuen synkronoitavien liidien määrästä. <br>",
    "proceedQuestion": "Haluatko jatkaa Facebook-liidien synkronoinnin kanssa?"
  },
  "integrationAI": {
    "accountDisconnected": "Tilin yhteys katkaistu!",
    "appNotFound": "Sovelluksen määritystä ei löydy. Käytetään varatietoja.",
    "checkingConnection": "Tarkistetaan yhteyden tilaa...",
    "connecting": "Yhdistetään...",
    "disconnectApp": "Katkaise sovellus",
    "disconnecting": "Yhteyttä katkaistaan...",
    "loadingAppInfo": "Ladataan sovellustietoja...",
    "refreshConnection": "Päivitä yhteys",
    "refreshing": "Päivitetään...",
    "svgNotAvailable": "SVG ei ole saatavilla"
  },
  "phoneSystem": {
    "additionalSettings": "Lisäasetukset",
    "messaging": "Viestittely",
    "messagingAnalytics": "Viestittelyanalytiikka",
    "regulatoryBundles": "Sääntelypaketit",
    "title": "Puhelinjärjestelmä",
    "trustCenter": "Trust Center",
    "voice": "Ääni"
  },
  "demo": {
    "draggable": {
      "title": "Vedettävän komponentin testi",
      "usingVue3": "Vue 3 -yhteensopivan vedettävän komponentin käyttö",
      "description": "Tämä komponentti käyttää nyt uudistettua Vue 3 -yhteensopivaa vedettävää komponenttia.",
      "buttons": {
        "resetAllLists": "Nollaa kaikki luettelot",
        "clearLog": "Tyhjennä loki",
        "stopLoading": "Pysäytä lataaminen",
        "simulateLoading": "Simuloi lataaminen",
        "refreshData": "Päivitä tiedot"
      },
      "examples": {
        "basicDraggable": "Vedettävä peruskomponentti",
        "draggableWithElement": "Vedettävä elementin avulla",
        "draggableWithTransitionGroup": "Vedettävä siirtoryhmällä",
        "draggableWithMoveFunction": "Vedettävä siirtotoiminnolla"
      },
      "eventLog": "Tapahtumaloki",
      "handle": "Tunnus",
      "name": "Nimi",
      "cannotMove": "(ei voi siirtää)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable Demo",
      "basicControls": "Perussäätimet",
      "labels": {
        "filter": "Suodata:",
        "sortBy": "Lajitteluperuste:",
        "sortDirection": "Lajittelusuunta:",
        "perPage": "Per sivu:",
        "tableStyling": "Taulukon muotoilu:"
      },
      "placeholders": {
        "typeToSearch": "Hae kirjoittamalla..."
      },
      "checkboxLabels": {
        "striped": "Raidallinen",
        "bordered": "Reunallinen",
        "hover": "Osoita",
        "small": "Pieni",
        "responsive": "Reagoiva"
      },
      "fields": {
        "id": "Tunnus",
        "name": "Nimi",
        "email": "Sähköposti",
        "status": "Tila",
        "created": "Luotu",
        "actions": "Toiminnot"
      },
      "statuses": {
        "active": "Aktiivinen",
        "inactive": "Inaktiivinen",
        "pending": "Kesken",
        "banned": "Estetyt"
      },
      "modal": {
        "title": "Kohteen tiedot",
        "close": "Sulje"
      },
      "messages": {
        "confirmDelete": "Haluatko varmasti poistaa käyttäjän {name}?",
        "editItem": "Muokkaa objektia {id}",
        "showingItems": "Näytetään {count} / {total} kohdetta"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Vahvista ja jatka",
      "everythingIn": "Kaikki suunnitelmassa <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "lisäämään luottokortti tähän",
        "message": "Pyydä asiakasta",
        "title": "Sijainnin on ensin lisättävä maksutapa."
      },
      "noSaasPlan": {
        "linkText": "luo SaaS-suunnitelmasi tässä.",
        "message": "Ole hyvä ja",
        "title": "Sinulla ei ole määritettyä SaaS-sunnitelmaa."
      },
      "saasModeSetupPendingWarning": "SaaS-tilaus aktivoidaan, kun asiakas on lisännyt maksutavan. Tilin käyttö estetään siihen asti.",
      "skipForNow": "Ohita toistaiseksi",
      "skipPlan": "Ohita tilaustyyppi"
    }
  },
  "isv": {
    "business_registration_id_type": "Yritysrekisteröinnin tunnustyyppi",
    "business_registration_number": "Yrityksen rekisteröintinumero",
    "business_website": "Yrityksen verkkosivusto",
    "enter_your_business_registration_id_type": "Anna yrityksesi rekisteröintitunnuksen tyyppi",
    "name_of_other_registration_id_type": "Muun rekisteröintitunnuksen tyypin nimi",
    "pick_business_industry": "Valitse liiketoiminnan toimiala",
    "pick_business_registration_id_type": "Valitse yritysrekisteröintitunnuksen tyyppi",
    "emailWithStar": "Sähköposti*",
    "businessIndustry": "Liiketoiminta-ala*",
    "businessType": "Yritystyyppi*",
    "regionsOfOperations": "Liiketoiminnan toiminta-alueet*",
    "registrationNumber": "Yrityksen rekisteröintinumero*",
    "registrationNumberHelper": "Lukumäärä, jota käytetään yrityksen tunnistamiseen. Yhdysvaltain EIN-tunnuksen on oltava 9-numeroinen luku, esim. 12-3456789.",
    "businessWebsiteWithStar": "Yrityksen verkkosivusto*",
    "businessTypeWithStar": "Yritystyyppi",
    "businessWebsite": "Yrityksen verkkosivusto"
  },
  "aiProductRebilling": {
    "enableRebilling": "Ota uudelleenlaskutus käyttöön",
    "ratesMayDiffer": "Hinnat voivat vaihdella alueittain. Esitetyt laskelmat ovat Yhdistyneen kuningaskunnan hintojen mukaisia,",
    "supportDoc": "tukiasiakirja",
    "cancel": "Peruuta",
    "profit": "Voitto",
    "chargedToCustomer": "Veloitettu asiakkaalta",
    "enabling": "Otetaan käyttöön...",
    "forMore": "lisätietoja.",
    "rebillAmount": "Uudelleenlaskutussumma",
    "tenDollarsWillGive": "10 $:lla saat noin",
    "yourCost": "Oma kustannus",
    "clientBillingPage": "asiakkaan yrityksen laskutussivu",
    "needStripeConnection": "Jotta uudelleenlaskutus voidaan ottaa käyttöön, sinun täytyy yhdistää Stripe-tilisi.",
    "per1000Words": "1 000 sanaa kohden",
    "perImage": "kuvaa kohti",
    "perReviewResponse": "arvosteluvastausta kohden",
    "perFunnel": "suppiloa kohden",
    "minimumBetween": "Vähimmäismäärän tulee olla välillä {min} ja {max}.",
    "images": "kuvat",
    "reviewResponse": "arvosteluvastaus",
    "funnel": "suppilo",
    "pleaseCheckSupport": "tarkista"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP Success",
      "message": "OTP:n menestysviesti"
    },
    "otpError": {
      "title": "OTP-virhe",
      "message": "OTP-virheilmoitus"
    },
    "businessProfileError": {
      "title": "Yritysprofiilin virhe",
      "message": "Yritysprofiilin virheilmoitus"
    },
    "addressError": {
      "title": "Osoitevirhe",
      "status": "Osoitevirheen tila"
    },
    "profileError": {
      "title": "A2P-profiilivirhe",
      "message": "A2P-profiilin virheilmoitusf"
    },
    "address": {
      "country": "Maa",
      "state": "Osavaltio",
      "chooseCountry": "Valitse maa...",
      "statePlaceholder": "Anna osavaltio",
      "chooseState": "Valitse osavaltio...",
      "city": "Kaupunki*",
      "postalCode": "Postinumero*",
      "streetAddress": "Katuosoite*",
      "streetAddressHelper": "On oltava yritykseesi linkitetty kelvollinen osoite.",
      "title": "Yrityksen osoite"
    },
    "validation": {
      "brandNameRequired": "Brändin nimi on pakollinen.",
      "businessVerticalRequired": "Toimiala on pakollinen.",
      "cityRequired": "Kaupunki on pakollinen.",
      "countryRequired": "Maa on pakollinen.",
      "invalidMobileNumber": "Virheellinen matkapuhelinnumero.",
      "mobileNumberRequired": "Matkapuhelinnumero on pakollinen.",
      "postalCodeRequired": "Postinumero on pakollinen.",
      "stateRequired": "Osavaltio on pakollinen.",
      "streetAddressRequired": "Katuosoite on pakollinen."
    },
    "authorizedRep": {
      "email": "Sähköposti*",
      "firstName": "Etunimi*",
      "jobPosition": "Työtehtävä*",
      "jobTitle": "Työtehtävä*",
      "jobTitlePlaceholder": "Syötä tehtävänimike",
      "lastName": "Sukunimi*",
      "phoneNumber": "Puhelinnumero*",
      "phoneNumberPlaceholder": "Anna puhelinnumero",
      "pickJobPosition": "Valitse työtehtävä",
      "title": "Valtuutetun edustajan tiedot"
    },
    "registration": {
      "stepProgress": "Vaihe {currentStep} / 8",
      "successTitle": "A2P-brändisi ja kampanjasi on lähetetty.",
      "successWaitDays": "seitsemän päivää",
      "successWaitPrefix": "Saattaa kestää jopa ",
      "successWaitSuffix": " brändin hyväksyntään ja kampanjan hyväksyntä kestää 4–5 viikkoa lisää.",
      "otpNote": "Huomaa: Saat OTP-viestin antamaasi matkapuhelinnumeroon vahvistusta varten TCR:ltä. Vastaa Kyllä 24 tunnin kuluessa tekstiviestin vastaanottamisesta."
    },
    "update": {
      "brandDetailsTitle": "Päivitä brändin tiedot",
      "brandName": "Brändin nimi*",
      "brandNameHelper": "Käytä joko viestejä lähettävän organisaation virallista nimeä tai omaa nimeäsi, jos tämä brändi ei ole organisaatiolle.",
      "businessVerticals": "Liiketoiminta-ala*",
      "chooseVertical": "Valitse toimiala...",
      "mobileNumber": "OTP-todentamisen matkapuhelinnumero (maakoodilla)*",
      "mobileNumberHelper": "Anna matkapuhelinnumero, johon sinulla on pääsy, jotta voit vahvistaa OTP-todennuksen. Vain yhdysvaltalaiset / kanadalaiset numerot hyväksytään. Et saa käyttää CPaaS-puhelinnumeroa, kuten LeadConnectorista hankittua numeroa. Et voi käyttää samaa matkapuhelinnumeroa rekisteröidäksesi yli kolmea yksityisyrittäjän tuotemerkkiä. Tätä rajaa hallinnoidaan TCR-tasolla.",
      "updateButton": "Päivitä",
      "retryOTPTitle": "Toista OTP",
      "retryOTPMessage": "Lähetä kertakäyttöisen salasanan vahvistusviesti uudelleen napsauttamalla alla olevaa painiketta.",
      "sending": "Lähetetään...",
      "resendOTP": "Lähetä kertakäyttöinen salasana uudelleen"
    },
    "einModal": {
      "title": "Onko sinulla EIN-tunnus?",
      "question": "Onko sinulla työnantajan tunnistenumero (EIN)?",
      "hasEIN": "Kyllä, minulla on EIN.",
      "noEIN": "Ei, minulla ei ole EIN-tunnusta.",
      "disableNoEINText": "EIN vaaditaan muissa kuin Yhdysvaltojen/Kanadan toimipaikoissa",
      "infoText": "Yhdysvalloissa ja Kanadassa toimivilta yrityksiltä vaaditaan EIN."
    },
    "brandDetails": {
      "brandHeading": "Bränditaulutiedot",
      "brandName": "Brändin nimi*",
      "brandNameHelper": "Käytä joko viestejä lähettävän organisaation virallista nimeä tai omaa nimeäsi, jos tämä brändi ei ole organisaatiolle.",
      "businessIndustry": "Liiketoiminta-ala*",
      "chooseVertical": "Valita pystysuuntainen...",
      "mobileNumber": "Matkapuhelinnumero OTP-varmennukseen (maakoodilla)*",
      "mobileNumberHelper": "Anna matkapuhelinnumero, johon sinulla on pääsy, jotta voit vahvistaa OTP-todennuksen. Vain yhdysvaltalaiset / kanadalaiset numerot hyväksytään. Et saa käyttää CPaaS-puhelinnumeroa, kuten LeadConnectorista hankittua numeroa. Et voi käyttää samaa matkapuhelinnumeroa rekisteröidäksesi yli kolmea yksityisyrittäjän tuotemerkkiä. Tätä rajaa hallinnoidaan TCR-tasolla.",
      "solePropBrand": {
        "heading": "Yksinyrittäjäbrändi",
        "point1": "Vain yksi puhelinnumero on sallittu",
        "point2": "EIN/SSN/DUNS ei ole pakollinen",
        "subheading": "Yksinyrittäjäbrändin rekisteröinti"
      },
      "solePropCampaign": {
        "heading": "Yksinyrittäjäkampanja",
        "point1": "Yksinyrittäjäkampanjaan saa liittää vain yhden numeron.",
        "point2": "Hyväksynnän jälkeen oletusnumerosi linkitetään automaattisesti",
        "infoText": "Voit myös päivittää numeron hyväksynnän jälkeen",
        "warningText": "Yksityisyrittäjäkampanjaan saa liittää vain yhden numeron. Kun hyväksyntä on saatu, oletusnumero yhdistetään automaattisesti. Voit myös päivittää numeron hyväksynnän jälkeen.",
        "subheading": "Yksityisyrittäjän kampanjarekisteröinti"
      },
      "solePropSubtitle": "Yksinyrittäjäbränditaulujen ja kampanjatiedot",
      "standardBrand": {
        "heading": "4,41 $ – Kertaluonteinen",
        "point1": "EIN/SSN/DUNS vaaditaan",
        "point2": "Yli yksi puhelinnumero on sallittu",
        "subheading": "Standard-brändin rekisteröinti"
      },
      "standardCampaign": {
        "heading": "16,54 $ - kertaluonteinen",
        "point1": "Vakiokampanjaan voi liittää useamman kuin yhden numeron.",
        "point2": "EIN/SSN/DUNS vaaditaan",
        "infoText": "TCR-sääntöjen mukaisesti sovelletaan kampanjan lisämaksua, joka on enintään 12 $ kuukaudessa.",
        "subheading": "Tavallinen kampanjarekisteröinti"
      },
      "standardSubtitle": "Tavallinen bränditaulut- ja kampanjatiedot",
      "title": "Bränditaulut- ja kampanjatiedot"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Kampanjan käyttötapauksen tiedot",
        "subtitle": "Syötä kampanjan yksityiskohdat ja kuvaus",
        "useCase": "Kampanjan käyttötapaus*",
        "pickUseCase": "Valitse kampanjan käyttötapaus",
        "useCaseDescription": "Käyttötapauksen kuvaus*",
        "explainInDetail": "Selitä yksityiskohtaisesti",
        "useCaseDescriptionPlaceholder": "Esimerkki: tämä kampanja lähettää asiakkaillemme tapaamisetiedot – vahvistus- ja muistutusviestit – kun he ovat varanneet tapaamisen verkkosivustollamme ja suostuneet vastaanottamaan meiltä mainos- ja ilmoitusviestejä tekstiviestitse.",
        "useCaseDescriptionHelper": "Anna yksityiskohtainen kuvaus siitä, miten aiot käyttää tätä kampanjaa.",
        "solePropLabel": "Yksityisyrittäjä",
        "seeExamples": "Katso esimerkkejä",
        "closeExamples": "Sulje esimerkit"
      }
    }
  },
  "opportunities": {
    "email": "Sähköposti",
    "phone": "Puhelin",
    "status": "Tila",
    "contactType": "Kontaktin tyyppi",
    "bulkOperation": "Massatoiminto",
    "contactName": "Kontaktin nimi",
    "unassigned": "Määrittämätön",
    "abandoned": "Hylätty",
    "addOpportunityName": "Lisää mahdollisuuden nimi",
    "companyName": "Yrityksen nimi",
    "contactInfo": "Kontaktin tiedot",
    "enterValue": "Anna arvo",
    "lost": "Menetetty",
    "open": "Avaa",
    "opportunityInfo": "Mahdollisuuden tiedot",
    "opportunityName": "Mahdollisuuden nimi",
    "opportunitySource": "Mahdollisuuden lähde",
    "owner": "Omistaja",
    "pipeline": "Prosessi",
    "selectPipeline": "Valitse prosessi",
    "selectStage": "Valitse vaihe",
    "stage": "Vaihe",
    "won": "Toteutunut",
    "createdOn": "Luotu",
    "goToContactDetail": "Siirry yhteystietosivulle",
    "leadValue": "Liidin arvo",
    "removeOwner": "Poista omistaja",
    "createdBy": "Luonut",
    "notAllowedToChange": "Sinulla ei ole oikeutta muuttaa tätä yhteystietoa",
    "opportunityAlreadyExists": "Tälle kontaktihenkilölle on jo olemassa mahdollisuus valitussa prosessissa.",
    "filters": {
      "all": "Kaikki",
      "statuses": {
        "all": "Kaikki",
        "open": "Avaa",
        "won": "Toteutunut",
        "lost": "Menetetty",
        "abandoned": "Hylätty"
      },
      "search": "Hae",
      "status": "Tila",
      "campaign": "Kampanja",
      "owner": "Omistaja",
      "pipeline": "Prosessi",
      "dateAddedAsc": "↑ Lisäämispäivä (NOUSEVA)",
      "dateAddedDesc": "↓ Lisäämispäivä (LASKEVA)",
      "orderBy": "Tilaaja"
    },
    "columns": {
      "note": "Muistiinpano",
      "task": "Tehtävä",
      "companyName": "Yrityksen nimi",
      "additionalInfo": "Lisätiedot",
      "calendarEvent": "Kalenteritapahtuma",
      "hideAssignedTo": "Piilota määrityksen saaja",
      "hideTags": "Piilota tagit"
    },
    "buttons": {
      "new": "Uusi"
    },
    "dragActions": {
      "abandoned": "Hylätty",
      "lost": "Menetetty",
      "won": "Toteutunut"
    },
    "getStarted": "Aloittaa!",
    "noPipelines": "Hups! Prosesseja ei näytä vielä olevan. Luo uusi prosessi, jotta voit",
    "addTask": "Lisää tehtävä",
    "tasksCount": "{count} tehtävää"
  },
  "appointmentDetails": "Tapaamisen tiedot",
  "cloneFunnel": {
    "cloneButton": "Kloonaa {entityName}",
    "cloning": "Kloonaus käynnissä...",
    "cloningLimit": "Kloonaus on rajoitettu kolmeen paikkaan kerrallaan",
    "error": "Virhe suppilon kloonauksessa!",
    "locationsLabel": "Valitse sijainnit",
    "nameLabel": "Nimi kloonatulle kohteelle {entityName}",
    "namePlaceholder": "Anna nimi kloonatulle kohteelle {entityName}",
    "selectUpTo": "Valitse enintään {maxSelectableLocations} sijaintia",
    "title": "Kloonaa {entityName}"
  },
  "errors": "Virheet",
  "renderEmailAddress": "Renderöi sähköpostiosoite",
  "noPaymentMethodWarning": "Ei maksutapaa -varoitus",
  "pageDetail": "Sivun tiedot",
  "activityHistory": "Toimintahistoria",
  "uiAlert": "UI Alert",
  "eventModals": {
    "wait": {
      "save": "Tallenna",
      "days": "Päivät",
      "fri": "pe",
      "mon": "ma",
      "sat": "la",
      "sun": "su",
      "thu": "to",
      "tue": "ti",
      "wed": "ke",
      "wait": "Odota",
      "minutes": "Minuutit",
      "hours": "Tunnit",
      "title": "Muokkaa odotustapahtumaa",
      "whichDaysResume": "Minä päivinä meidän tulisi jatkaa?",
      "pickDayError": "Valitse vähintään yksi päivä",
      "whatTimeResume": "Mihin aikaan meidän tulisi jatkaa?"
    },
    "sms": {
      "send": "Lähetä",
      "name": "Nimi",
      "attachFile": "Liitä tiedosto",
      "learnMore": "Lue lisää",
      "sendTest": "Lähetä testi",
      "title": "Muokkaa {eventType} tapahtumaa",
      "titleTemplate": "Muokkaa {eventType} mallipohjaa",
      "nameRequired": "Nimi on pakollinen",
      "pickTemplate": "Valitse mallipohja",
      "appCharacters": "Sovelluksen merkit",
      "numSegments": "Segmenttien lukumäärä",
      "approximateCost": "Arvioitu kustannus",
      "costEstimateNote": "Kustannusarvion huomautus",
      "urlAttachmentAutocompleteToken": "URL-liite",
      "addFileUrl": "Lisää tiedosto-URL",
      "urlImageAlt": "Kuvan URL-osoite",
      "fileImageAlt": "Tiedostokuva",
      "enterMessage": "Kirjoita viesti",
      "mobilePhonePlaceholder": "Matkapuhelin",
      "unsupportedContentType": "Sisältötyyppiä ei tueta: {fileType}",
      "urlAttachmentWarning": "{count} URL-liitteen{plural} lataaminen epäonnistui. Haluatko jatkaa?",
      "provideMobileNumber": "Anna matkapuhelinnumero"
    },
    "email": {
      "text": "Teksti",
      "checkLinks": "Tarkista linkit, joissa on mukautettu arvo. {{ ja mukautettujen_arvojen välissä on ylimääräinen '%20'.",
      "errorOccurred": "Tapahtui virhe, yritä uudelleen.",
      "insertToAddress": "Anna vastaanottajan osoite."
    },
    "voicemail": {
      "save": "Tallenna",
      "dropFile": "Pudota tiedosto tähän tai lataa napsauttamalla",
      "faq": "UKK",
      "title": "Muokkaa vastaajatapahtumaa",
      "voicemailFile": "Vastaajatiedosto",
      "warning": "Varoitus: vastaajatiedostojen on oltava MP3-, WAV- tai GSM-muodossa.",
      "unsupportedFormat": "Tiedostomuotoa ei tueta. Käytä MP3-, WAV- tai GSM-muotoa."
    },
    "call": {
      "title": "Muokkaa puhelutapahtumaa",
      "save": "Tallenna",
      "name": "Nimi",
      "nameRequired": "Nimi on pakollinen",
      "callWhisper": "Soita kuiskaukselle",
      "whisperMessage": "Kuiskausviesti",
      "thisIsTheMessage": "Tämä on viesti, joka toistetaan edustajalle ennen puhelun yhdistämistä.",
      "callTimeoutS": "Puhelun aikakatkaisu (s)",
      "timeoutSeconds": "Aikakatkaisu (sekunnit)",
      "disableVoicemailDetect": "Poista vastaajaviestien tunnistus",
      "callWillPatchInstantly": "Puhelu yhdistetään välittömästi ilman, että vastaajaa havaitaan."
    }
  },
  "emailTemplate": {
    "createdOn": "Luotu",
    "updatedOn": "Päivitetty"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Lue lisää",
      "description": "CNAM-kuvaus"
    },
    "submitted": {
      "checkStatus": "Tarkista CNAM-tila",
      "description": "Yrityksesi nimi tulee näkyviin sopiville kontakteille noin 3–5 päivän kuluessa.",
      "subtitle": "CNAM-pyyntösi on nyt lähetetty.",
      "title": "Onnittelut!"
    },
    "registration": {
      "confirm": "Vahvista",
      "learnMore": "Lue lisää",
      "characterLimit": "{count}/15",
      "title": "CNAM-rekisteröinti",
      "description": "Syötä yrityksesi nimi (enintään 15 merkkiä)",
      "warning": "Varoitus: Yrityksesi nimi näkyy soittajan tunnistetiedossa. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Päivitysvirhe",
      "message": "Päivitä virheviesti"
    },
    "success": {
      "message": "A2P-brändi ja kampanjasi on lähetetty.<br/><br/><b>Huomaa:</b> Saat <b>OTP-viestin antamaasi matkapuhelinnumeroon tarkistettavaksi</b> TCR:ltä. Vastaa <b>Kyllä 24 tunnin kuluessa</b> tekstiviestin vastaanottamisesta.",
      "title": "A2P-brändisi ja kampanjasi on lähetetty. Brändin hyväksyntä voi kestää jopa <b>7 päivää</b> ja kampanjan hyväksyntä 4–5 viikkoa."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Sääntelypaketin virhe",
      "status": "Sääntelypaketin virhetila"
    },
    "createAddress": {
      "successMessage": "A2P-brändisi ja kampanjasi on lähetetty.",
      "successTitle": "Osoite lähetetty onnistuneesti",
      "underReview": "Lähetetty osoite on tarkastettavana"
    },
    "createEndUser": {
      "dateFormat": "Päivämäärän tulee olla muodossa VVVV-KK-PP.",
      "phoneExample": " Esimerkki: +14155552671",
      "title": "Yrityksen tiedot:"
    },
    "success": {
      "title": "Sääntelypaketti on lähetetty onnistuneesti",
      "underReview": "Lähetetty paketti on tarkastettavana",
      "message": "SHAKEN/STIR-rekisteröintipyyntösi on lähetetty. Hyväksytyksi tuleminen voi kestää jopa <b>3–4 päivää</b>. Tila päivitetään pian."
    },
    "documents": {
      "additionalInfo": "Lisätiedot",
      "createAddressLink": "Luo osoite.",
      "createAddressPrompt": "Luo ensin osoite ja jatka sitten paketin luomista.",
      "selectAddress": "Valitse osoite:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Tämä vaihtoehto lisää uuden osoitteen tiliisi",
        "label": "Osoitepaketti"
      },
      "regulatoryBundle": {
        "description": "Tämä vaihtoehto auttaa sinua luomaan uuden sääntelypaketin",
        "label": "Sääntelypaketti"
      },
      "title": "Valita, minkä paketin haluat lisätä"
    },
    "modal": {
      "back": "Takaisin",
      "next": "Seuraava",
      "submit": "Lähetä",
      "title": "Uusi sääntelypaketti",
      "description": "Luo uusi sääntelypaketti sijaintiasi varten"
    }
  },
  "reminder": {
    "phone": "Puhelin",
    "noReplyYet": "Ei vielä vastausta"
  },
  "sendGrid": {
    "apiKey": "SendGrid API-avain",
    "save": "SendGrid-tallennus",
    "apiKeyRequired": "SendGrid API-avain on pakollinen"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Päivitä",
      "subtitle": "Pro-sopimuksen tehneet toimistot ansaitsevat noin 363 dollaria kuukaudessa laskuttamalla puhelinkustannukset asiakkailtaan.",
      "title": "Haluatko laskuttaa tämän uudelleen asiakkaillesi?"
    }
  },
  "emailField": {
    "label": "Sähköposti",
    "placeholder": "Sähköposti",
    "tooltip": {
      "primary": "Ensisijainen",
      "emails": "Sähköpostit"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Lataa tilannevedos:",
    "loadSnapshotWarning": "Haluatko ladata tähän suunnitelmaan liittyvän tilannevedoksen? <br /> <strong class='text-danger'>Tämänhetkiset tiedot voidaan menettää</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Vain toimiston järjestelmänvalvojilla/käyttäjillä on pääsy tälle alatilille. Tällä hetkellä sinulla ja muilla tilin järjestelmänvalvojilla/käyttäjillä ei ole pääsyä tälle alatilille.",
      "heading": "Tämä alatili on keskeytetty."
    },
    "temporarily": {
      "description": "Kaikki tietosi ovat turvassa, ja kaikki käynnistimet, kampanjat jne. ovat taas käytössä aktivoinnin jälkeen.",
      "heading": " Tilisi on väliaikaisesti keskeytetty."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Yrityksen kutsumanimi",
    "title": "Päivitä soittajan tunnistetieto"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Valitse toimisto",
    "whichOffice": "Minkä toimiston haluat liittää tähän tiliin?",
    "connect": "Muodosta yhteys!"
  },
  "phoneField": {
    "label": "Puhelin",
    "placeholder": "Puhelinnumero",
    "tooltip": {
      "invalidNumber": "Virheellinen puhelinnumero",
      "notSmsCapable": "Tämä {type} -numero ei tue tekstiviestejä"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Varaustiedot",
      "form": "Lomake",
      "quiz": "Tietovisa",
      "submissionDetail": "Lähetyksen tiedot",
      "survey": "Kysely"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "SHAKEN/STIR-rekisteröintipyyntösi on lähetetty. Hyväksytyksi tuleminen voi kestää jopa <b>3–4 päivää</b>. Tila päivitetään pian.",
      "title": "SHAKEN/STIR luotettu soittaminen käytössä."
    },
    "modal": {
      "andThe": " ja ",
      "businessProfile": "Yritysprofiili",
      "certification": "Vakuutan, että liitetty yritysprofiili on puheluiden alkuperä ja vakuutan, että liityn jäljitystoimiin, mukaan lukien ne, jotka on käynnistetty",
      "failedTitle": "Lähetys epäonnistui",
      "friendlyName": "Kutsumanimi",
      "friendlyNamePlaceholder": "Esim. SHST 24.11.2022 klo 19.47.14",
      "linkInfo": {
        "description": "Kaikki tämänhetkiset saatavilla olevat numerot ja tulevaisuudessa ostettavat numerot rekisteröidään automaattisesti SHAKEN/STIR:illä.",
        "title": "Kaikki numerot linkitetään automaattisesti"
      },
      "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
      "subtitle": "Anna yksityiskohdat ja kuvaus",
      "successMessage": "SHAKEN/STIR-rekisteröintipyyntösi on lähetetty. Hyväksytyksi tuleminen voi kestää jopa <b>3–4 päivää</b>. Tila päivitetään pian.",
      "successTitle": "SHAKEN/STIR luotettu soittaminen käytössä.",
      "title": "Ota käyttöön SHAKEN/STIR luotettu soittaminen",
      "tracebackGroup": "US Telecom Traceback Groupin toimesta"
    },
    "withCnam": {
      "cnamPromo": "Rekisteröidy CNAMiin, jotta yrityksesi nimi näkyisi soittajan tunnistetiedossa",
      "registerCnam": "Rekisteröi CNAM"
    }
  },
  "task": {
    "2day": "2 päivää",
    "3day": "3 päivää",
    "4day": "4 päivää",
    "5day": "5 päivää",
    "addTask": "Lisää tehtävä",
    "countTasks": "{count} tehtävää"
  },
  "updatedProductsModal": {
    "title": "Päivitetyt tuotteet",
    "copyDirectSaleLink": "Kopioi suoramyyntilinkki",
    "setupFeeInstruction": "Aloitusmaksu voidaan määrittää Stripe Dashboardissa. ",
    "doNotDeleteWarning": "Älä poista tuotteita tai hintoja Stripe-hallintapaneelista. Tämä tulee rikkomaan integraation."
  },
  "termsOfService": {
    "privacyLink": "Tietoseloste",
    "accept": "Hyväksy",
    "termsLink": "Palveluehdot",
    "updateMessage": "Olemme päivittäneet käyttöehtomme ja tietosuojakäytäntömme. Tarkista ja hyväksy jatkaaksesi.",
    "agreementPrefix": "Jatkamalla hyväksyt meidän ",
    "agreementConjunction": " ja "
  },
  "callerIdVerificationModal": {
    "answerCall": "Vastaa puheluun ja anna tämä vahvistuskoodi:",
    "leadConnectorCalling": "Lead Connector soittaa...",
    "title": "Lisää soittajan tunnistetieto äänen mukaan",
    "waitingForVerification": "Odottaa vahvistusta..."
  },
  "emailOTPModal": {
    "confirmCode": "Vahvista koodi",
    "resendCode": "Jos et saanut koodia, lähetä se uudelleen napsauttamalla tästä"
  },
  "survey": {
    "copy": {
      "cancel": "Peruuta",
      "location": "Sijainti",
      "copy": "Kopioi",
      "newSurveyName": "Uusi kyselyn nimi",
      "title": "Kopioi kysely",
      "locationRequired": "Sijainti on pakollinen"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Tuotteen nimi",
    "planDetails": "Suunnitelman tiedot",
    "title": "Tuotetiedot",
    "planId": "Suunnitelmatunnus",
    "copiedToClipboard": "Kopioitu leikepöydälle"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Tehokkaampi",
      "faster": "Nopeampi",
      "itsText": "Se on",
      "smoother": "Tasaisempi",
      "title": "Uusi tuontikokemus on täällä!",
      "warningMessage": "Uuden tuontikokemuksen käyttöönotto aktivoi Labsin tälle alatilille ja ottaa käyttöön beetaominaisuuden.",
      "tryNow": "Kokeile nyt"
    },
    "validateEmails": "Vahvistetaanko sähköpostit?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-hinta",
      "howDoesItWork": "Miten se toimii?",
      "payNow": "Maksa heti",
      "priceError": "Hinnan on oltava vähintään yhtä suuri kuin HighLevel-hinnan",
      "saving": "Tallennetaan",
      "yourPrice": "Oma hinta",
      "yourProfit": "Oma tuotto",
      "subscriptionCreating": "Tilausta luodaan.<br/>Älä lataa sivua uudelleen tai paina Takaisin-painiketta",
      "subscriptionCreated": "Tilaus on luotu. Odota...",
      "unableToCreate": "Tilausta ei voi luoda, ota yhteyttä tukeen",
      "perMonth": "kuukaudessa",
      "agreeToEnable": "Hyväksyn listausten tallentamisen tälle asiakkaalle ilman lisämyyntiä ja ymmärrän, että minulta veloitetaan",
      "deployDirectly": "Ota listaukset käyttöön suoraan",
      "deployDirectlyDesc": "Käytä tätä vaihtoehtoa, jos tarjoat listauksia osana tarjoustasi tai jos haluat laskuttaa asiakastasi ulkoisesti.",
      "minimumCommitment": "Vähintään yhden kuukauden sitoumusjakso.",
      "offerListings": "Tarjouslistaukset",
      "resellListings": "Myy listauksia uudelleen",
      "subscribedInfo": "{withoutUpsell} Ilman lisämyyntiä, {withUpsell} lisämyynnillä ja {withSaas} Saas-paketilla",
      "yourResellOffer": "Uudelleenmyyntitarjouksesi"
    }
  }
}
